// // // // // // // // // // // // // import { useState, useEffect } from "react";
// // // // // // // // // // // // // import {
// // // // // // // // // // // // //   AppBar,
// // // // // // // // // // // // //   Toolbar,
// // // // // // // // // // // // //   Typography,
// // // // // // // // // // // // //   Box,
// // // // // // // // // // // // //   IconButton,
// // // // // // // // // // // // //   Menu,
// // // // // // // // // // // // //   MenuItem,
// // // // // // // // // // // // //   Badge,
// // // // // // // // // // // // //   Avatar,
// // // // // // // // // // // // //   useTheme,
// // // // // // // // // // // // //   useMediaQuery,
// // // // // // // // // // // // //   Tooltip,
// // // // // // // // // // // // //   Divider,
// // // // // // // // // // // // // } from "@mui/material";
// // // // // // // // // // // // // import {
// // // // // // // // // // // // //   NotificationsOutlined,
// // // // // // // // // // // // //   Menu as MenuIcon,
// // // // // // // // // // // // //   Brightness4,
// // // // // // // // // // // // //   Brightness7,
// // // // // // // // // // // // //   EmailOutlined,
// // // // // // // // // // // // //   PhoneOutlined,
// // // // // // // // // // // // // } from "@mui/icons-material";
// // // // // // // // // // // // // import { useAuth } from "../../context/AuthContext";
// // // // // // // // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // // // // // // // import { useChatBot } from "../../context/ChatBotContext";
// // // // // // // // // // // // // import Sidebar from "./Sidebar";
// // // // // // // // // // // // // import ChatBot from "../common/ChatBot";
// // // // // // // // // // // // // import { useThemeToggle } from "./Theme";
// // // // // // // // // // // // // import apiClient from "../../context/apiClient";

// // // // // // // // // // // // // const Layout = ({ children, title }) => {
// // // // // // // // // // // // //   const { user, logout } = useAuth();
// // // // // // // // // // // // //   const { setIsOpen } = useChatBot();
// // // // // // // // // // // // //   const navigate = useNavigate();
// // // // // // // // // // // // //   const theme = useTheme();
// // // // // // // // // // // // //   const { toggleColorMode } = useThemeToggle();
// // // // // // // // // // // // //   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

// // // // // // // // // // // // //   const [isDesktopOpen, setDesktopOpen] = useState(() => {
// // // // // // // // // // // // //     const savedState = sessionStorage.getItem("sidebarOpenState");
// // // // // // // // // // // // //     return savedState !== null ? JSON.parse(savedState) : true;
// // // // // // // // // // // // //   });

// // // // // // // // // // // // //   const [isMobileOpen, setMobileOpen] = useState(false);
// // // // // // // // // // // // //   const [anchorEl, setAnchorEl] = useState(null);
// // // // // // // // // // // // //   const [notificationAnchor, setNotificationAnchor] = useState(null);
// // // // // // // // // // // // //   const [profilePhotoUrl, setProfilePhotoUrl] = useState(null);
// // // // // // // // // // // // //   const [notifications, setNotifications] = useState([]);

// // // // // // // // // // // // //   useEffect(() => {
// // // // // // // // // // // // //     if (!isMobile) {
// // // // // // // // // // // // //       sessionStorage.setItem("sidebarOpenState", JSON.stringify(isDesktopOpen));
// // // // // // // // // // // // //     }
// // // // // // // // // // // // //   }, [isDesktopOpen, isMobile]);

// // // // // // // // // // // // //   useEffect(() => {
// // // // // // // // // // // // //     const fetchProfilePhoto = async () => {
// // // // // // // // // // // // //       try {
// // // // // // // // // // // // //         const response = await apiClient.get("resume-builder/");
// // // // // // // // // // // // //         if (response.data && response.data.profile_photo_url) {
// // // // // // // // // // // // //           setProfilePhotoUrl(response.data.profile_photo_url);
// // // // // // // // // // // // //         }
// // // // // // // // // // // // //       } catch (error) {
// // // // // // // // // // // // //         console.error("Failed to fetch profile photo", error);
// // // // // // // // // // // // //       }
// // // // // // // // // // // // //     };

// // // // // // // // // // // // //     const fetchNotifications = async () => {
// // // // // // // // // // // // //       try {
// // // // // // // // // // // // //         const response = await apiClient.get("notifications/");
// // // // // // // // // // // // //         if (response.data && Array.isArray(response.data.notifications)) {
// // // // // // // // // // // // //           setNotifications(response.data.notifications);
// // // // // // // // // // // // //         }
// // // // // // // // // // // // //       } catch (error) {
// // // // // // // // // // // // //         console.error("Failed to fetch notifications", error);
// // // // // // // // // // // // //       }
// // // // // // // // // // // // //     };

// // // // // // // // // // // // //     fetchProfilePhoto();
// // // // // // // // // // // // //     fetchNotifications();
// // // // // // // // // // // // //   }, []);

// // // // // // // // // // // // //   const handleDesktopToggle = () => {
// // // // // // // // // // // // //     setDesktopOpen(!isDesktopOpen);
// // // // // // // // // // // // //   };

// // // // // // // // // // // // //   const handleMobileToggle = () => {
// // // // // // // // // // // // //     setMobileOpen(!isMobileOpen);
// // // // // // // // // // // // //   };

// // // // // // // // // // // // //   const handleMenu = (event) => setAnchorEl(event.currentTarget);
// // // // // // // // // // // // //   const handleNotificationMenu = (event) =>
// // // // // // // // // // // // //     setNotificationAnchor(event.currentTarget);
// // // // // // // // // // // // //   const handleClose = () => {
// // // // // // // // // // // // //     setAnchorEl(null);
// // // // // // // // // // // // //     setNotificationAnchor(null);
// // // // // // // // // // // // //   };

// // // // // // // // // // // // //   return (
// // // // // // // // // // // // //     <Box
// // // // // // // // // // // // //       sx={{
// // // // // // // // // // // // //         display: "flex",
// // // // // // // // // // // // //         minHeight: "100vh",
// // // // // // // // // // // // //         overflow: "hidden",
// // // // // // // // // // // // //         bgcolor: "background.default",
// // // // // // // // // // // // //       }}
// // // // // // // // // // // // //     >
// // // // // // // // // // // // //       <AppBar
// // // // // // // // // // // // //         position="fixed"
// // // // // // // // // // // // //         elevation={0}
// // // // // // // // // // // // //         sx={{
// // // // // // // // // // // // //           zIndex: theme.zIndex.drawer + 1,
// // // // // // // // // // // // //           backgroundColor: theme.palette.primary.main,
// // // // // // // // // // // // //           color: theme.palette.primary.contrastText,
// // // // // // // // // // // // //         }}
// // // // // // // // // // // // //       >
// // // // // // // // // // // // //         <Toolbar
// // // // // // // // // // // // //           sx={{
// // // // // // // // // // // // //             px: { xs: 2, sm: 3 },
// // // // // // // // // // // // //             minHeight: { xs: 56, sm: 64 },
// // // // // // // // // // // // //             display: "flex",
// // // // // // // // // // // // //             justifyContent: "space-between",
// // // // // // // // // // // // //             alignItems: "center",
// // // // // // // // // // // // //           }}
// // // // // // // // // // // // //         >
// // // // // // // // // // // // //           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
// // // // // // // // // // // // //             <IconButton
// // // // // // // // // // // // //               color="inherit"
// // // // // // // // // // // // //               onClick={handleMobileToggle}
// // // // // // // // // // // // //               sx={{ display: { md: "none" } }}
// // // // // // // // // // // // //             >
// // // // // // // // // // // // //               <MenuIcon />
// // // // // // // // // // // // //             </IconButton>
// // // // // // // // // // // // //             <Typography
// // // // // // // // // // // // //               variant="h6"
// // // // // // // // // // // // //               sx={{
// // // // // // // // // // // // //                 fontWeight: "bold",
// // // // // // // // // // // // //                 fontSize: { xs: "1.1rem", sm: "1.25rem" },
// // // // // // // // // // // // //                 color: "inherit",
// // // // // // // // // // // // //               }}
// // // // // // // // // // // // //             >
// // // // // // // // // // // // //               {title}
// // // // // // // // // // // // //             </Typography>
// // // // // // // // // // // // //           </Box>
// // // // // // // // // // // // //           <Box
// // // // // // // // // // // // //             sx={{
// // // // // // // // // // // // //               display: "flex",
// // // // // // // // // // // // //               alignItems: "center",
// // // // // // // // // // // // //               gap: { xs: 1, sm: 2 },
// // // // // // // // // // // // //             }}
// // // // // // // // // // // // //           >
// // // // // // // // // // // // //             <Tooltip title="Toggle light/dark theme">
// // // // // // // // // // // // //               <IconButton color="inherit" onClick={toggleColorMode}>
// // // // // // // // // // // // //                 {theme.palette.mode === "dark" ? (
// // // // // // // // // // // // //                   <Brightness7 />
// // // // // // // // // // // // //                 ) : (
// // // // // // // // // // // // //                   <Brightness4 />
// // // // // // // // // // // // //                 )}
// // // // // // // // // // // // //               </IconButton>
// // // // // // // // // // // // //             </Tooltip>
// // // // // // // // // // // // //             <Tooltip title="Notifications">
// // // // // // // // // // // // //               <IconButton color="inherit" onClick={handleNotificationMenu}>
// // // // // // // // // // // // //                 <Badge badgeContent={notifications.length} color="error">
// // // // // // // // // // // // //                   <NotificationsOutlined />
// // // // // // // // // // // // //                 </Badge>
// // // // // // // // // // // // //               </IconButton>
// // // // // // // // // // // // //             </Tooltip>
// // // // // // // // // // // // //             <Box
// // // // // // // // // // // // //               onClick={handleMenu}
// // // // // // // // // // // // //               sx={{
// // // // // // // // // // // // //                 display: "flex",
// // // // // // // // // // // // //                 alignItems: "center",
// // // // // // // // // // // // //                 gap: 1.5,
// // // // // // // // // // // // //                 cursor: "pointer",
// // // // // // // // // // // // //                 p: 0.5,
// // // // // // // // // // // // //                 borderRadius: "8px",
// // // // // // // // // // // // //                 "&:hover": {
// // // // // // // // // // // // //                   backgroundColor: "rgba(255, 255, 255, 0.1)",
// // // // // // // // // // // // //                 },
// // // // // // // // // // // // //               }}
// // // // // // // // // // // // //             >
// // // // // // // // // // // // //               <Avatar
// // // // // // // // // // // // //                 sx={{ width: 40, height: 40 }}
// // // // // // // // // // // // //                 alt={user?.username || "Not specified"}
// // // // // // // // // // // // //                 src={profilePhotoUrl}
// // // // // // // // // // // // //               />
// // // // // // // // // // // // //               <Box
// // // // // // // // // // // // //                 sx={{
// // // // // // // // // // // // //                   display: { xs: "none", md: "flex" },
// // // // // // // // // // // // //                   flexDirection: "column",
// // // // // // // // // // // // //                   alignItems: "flex-start",
// // // // // // // // // // // // //                 }}
// // // // // // // // // // // // //               >
// // // // // // // // // // // // //                 <Typography
// // // // // // // // // // // // //                   sx={{
// // // // // // // // // // // // //                     color: "inherit",
// // // // // // // // // // // // //                     fontWeight: "bold",
// // // // // // // // // // // // //                     lineHeight: 1.2,
// // // // // // // // // // // // //                     fontSize: "0.9rem",
// // // // // // // // // // // // //                   }}
// // // // // // // // // // // // //                 >
// // // // // // // // // // // // //                   {user?.username || "Not specified"}
// // // // // // // // // // // // //                 </Typography>
// // // // // // // // // // // // //                 <Typography
// // // // // // // // // // // // //                   variant="caption"
// // // // // // // // // // // // //                   sx={{
// // // // // // // // // // // // //                     color: "inherit",
// // // // // // // // // // // // //                     opacity: 0.85,
// // // // // // // // // // // // //                     textTransform: "capitalize",
// // // // // // // // // // // // //                   }}
// // // // // // // // // // // // //                 >
// // // // // // // // // // // // //                   {user?.role || "Admin"}
// // // // // // // // // // // // //                 </Typography>
// // // // // // // // // // // // //               </Box>
// // // // // // // // // // // // //             </Box>
// // // // // // // // // // // // //           </Box>
// // // // // // // // // // // // //         </Toolbar>
// // // // // // // // // // // // //       </AppBar>

// // // // // // // // // // // // //       <Sidebar
// // // // // // // // // // // // //         open={isDesktopOpen}
// // // // // // // // // // // // //         onToggle={handleDesktopToggle}
// // // // // // // // // // // // //         mobileOpen={isMobileOpen}
// // // // // // // // // // // // //         onMobileToggle={handleMobileToggle}
// // // // // // // // // // // // //       />

// // // // // // // // // // // // //       <Box
// // // // // // // // // // // // //         component="main"
// // // // // // // // // // // // //         sx={{
// // // // // // // // // // // // //           flexGrow: 1,
// // // // // // // // // // // // //           mt: { xs: "56px", sm: "64px" },
// // // // // // // // // // // // //           overflow: "hidden",
// // // // // // // // // // // // //           boxSizing: "border-box",
// // // // // // // // // // // // //           height: `calc(100vh - ${isMobile ? "56px" : "64px"})`,
// // // // // // // // // // // // //           position: "relative",
// // // // // // // // // // // // //         }}
// // // // // // // // // // // // //       >
// // // // // // // // // // // // //         <Box
// // // // // // // // // // // // //           sx={{
// // // // // // // // // // // // //             height: "100%",
// // // // // // // // // // // // //             overflowY: "scroll",
// // // // // // // // // // // // //           }}
// // // // // // // // // // // // //         >
// // // // // // // // // // // // //           {children}
// // // // // // // // // // // // //         </Box>
// // // // // // // // // // // // //       </Box>

// // // // // // // // // // // // //       <Menu
// // // // // // // // // // // // //         anchorEl={notificationAnchor}
// // // // // // // // // // // // //         open={Boolean(notificationAnchor)}
// // // // // // // // // // // // //         onClose={handleClose}
// // // // // // // // // // // // //         MenuListProps={{ "aria-labelledby": "notification-button" }}
// // // // // // // // // // // // //         sx={{ mt: 1.5 }}
// // // // // // // // // // // // //         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
// // // // // // // // // // // // //         transformOrigin={{ vertical: "top", horizontal: "right" }}
// // // // // // // // // // // // //       >
// // // // // // // // // // // // //         <Box sx={{ p: 2, pb: 1, width: 320 }}>
// // // // // // // // // // // // //           <Typography variant="h6" fontWeight={600}>
// // // // // // // // // // // // //             Notifications
// // // // // // // // // // // // //           </Typography>
// // // // // // // // // // // // //         </Box>
// // // // // // // // // // // // //         <Divider />
// // // // // // // // // // // // //         {notifications.length > 0 ? (
// // // // // // // // // // // // //           notifications.map((n, index) => (
// // // // // // // // // // // // //             <MenuItem
// // // // // // // // // // // // //               key={index}
// // // // // // // // // // // // //               onClick={handleClose}
// // // // // // // // // // // // //               sx={{ py: 1.5, px: 2, whiteSpace: "normal", display: "block" }}
// // // // // // // // // // // // //             >
// // // // // // // // // // // // //               <Typography variant="body2" fontWeight="bold">
// // // // // // // // // // // // //                 {n.title}
// // // // // // // // // // // // //               </Typography>
// // // // // // // // // // // // //               <Typography variant="caption" color="text.secondary">
// // // // // // // // // // // // //                 {n.description}
// // // // // // // // // // // // //               </Typography>
// // // // // // // // // // // // //             </MenuItem>
// // // // // // // // // // // // //           ))
// // // // // // // // // // // // //         ) : (
// // // // // // // // // // // // //           <MenuItem onClick={handleClose} sx={{ py: 2, px: 2 }}>
// // // // // // // // // // // // //             <Typography variant="body2" color="text.secondary">
// // // // // // // // // // // // //               No new notifications
// // // // // // // // // // // // //             </Typography>
// // // // // // // // // // // // //           </MenuItem>
// // // // // // // // // // // // //         )}
// // // // // // // // // // // // //       </Menu>

// // // // // // // // // // // // //       <Menu
// // // // // // // // // // // // //         anchorEl={anchorEl}
// // // // // // // // // // // // //         open={Boolean(anchorEl)}
// // // // // // // // // // // // //         onClose={handleClose}
// // // // // // // // // // // // //         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
// // // // // // // // // // // // //         transformOrigin={{ vertical: "top", horizontal: "right" }}
// // // // // // // // // // // // //         slotProps={{
// // // // // // // // // // // // //           paper: {
// // // // // // // // // // // // //             elevation: 0,
// // // // // // // // // // // // //             sx: {
// // // // // // // // // // // // //               overflow: "visible",
// // // // // // // // // // // // //               width: 250,
// // // // // // // // // // // // //               mt: 1.5,
// // // // // // // // // // // // //               backgroundColor: "primary.main",
// // // // // // // // // // // // //               color: "primary.contrastText",
// // // // // // // // // // // // //               borderRadius: "10px",
// // // // // // // // // // // // //               boxShadow: "0px 4px 20px rgba(0,0,0,0.4)",
// // // // // // // // // // // // //               "& .MuiList-root": {
// // // // // // // // // // // // //                 padding: "0px",
// // // // // // // // // // // // //               },
// // // // // // // // // // // // //               "& .MuiMenuItem-root": {
// // // // // // // // // // // // //                 padding: "12px 16px",
// // // // // // // // // // // // //               },
// // // // // // // // // // // // //             },
// // // // // // // // // // // // //           },
// // // // // // // // // // // // //         }}
// // // // // // // // // // // // //       >
// // // // // // // // // // // // //         <Box sx={{ p: 2, pt: 1.5 }}>
// // // // // // // // // // // // //           <Typography variant="subtitle1" fontWeight={600} color="inherit">
// // // // // // // // // // // // //             {user?.username}
// // // // // // // // // // // // //           </Typography>
// // // // // // // // // // // // //           <Typography
// // // // // // // // // // // // //             variant="caption"
// // // // // // // // // // // // //             sx={{ textTransform: "capitalize", color: "inherit", opacity: 0.9 }}
// // // // // // // // // // // // //           >
// // // // // // // // // // // // //             Role: {user?.role}
// // // // // // // // // // // // //           </Typography>
// // // // // // // // // // // // //           <Divider sx={{ my: 1.5, borderColor: "rgba(255, 255, 255, 0.2)" }} />
// // // // // // // // // // // // //           <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
// // // // // // // // // // // // //             <EmailOutlined
// // // // // // // // // // // // //               fontSize="small"
// // // // // // // // // // // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // // // // // // // // // // //             />
// // // // // // // // // // // // //             <Typography
// // // // // // // // // // // // //               variant="body2"
// // // // // // // // // // // // //               sx={{ wordBreak: "break-all", color: "inherit" }}
// // // // // // // // // // // // //             >
// // // // // // // // // // // // //               {user?.email}
// // // // // // // // // // // // //             </Typography>
// // // // // // // // // // // // //           </Box>
// // // // // // // // // // // // //           <Box sx={{ display: "flex", alignItems: "center" }}>
// // // // // // // // // // // // //             <PhoneOutlined
// // // // // // // // // // // // //               fontSize="small"
// // // // // // // // // // // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // // // // // // // // // // //             />
// // // // // // // // // // // // //             <Typography variant="body2" color="inherit">
// // // // // // // // // // // // //               {user?.phone_number}
// // // // // // // // // // // // //             </Typography>
// // // // // // // // // // // // //           </Box>
// // // // // // // // // // // // //         </Box>
// // // // // // // // // // // // //       </Menu>

// // // // // // // // // // // // //       <ChatBot />
// // // // // // // // // // // // //     </Box>
// // // // // // // // // // // // //   );
// // // // // // // // // // // // // };

// // // // // // // // // // // // // export default Layout;

// // // // // // // // // // // // import { useState, useEffect, Fragment } from "react";
// // // // // // // // // // // // import {
// // // // // // // // // // // //   AppBar,
// // // // // // // // // // // //   Toolbar,
// // // // // // // // // // // //   Typography,
// // // // // // // // // // // //   Box,
// // // // // // // // // // // //   IconButton,
// // // // // // // // // // // //   Menu,
// // // // // // // // // // // //   MenuItem,
// // // // // // // // // // // //   Badge,
// // // // // // // // // // // //   Avatar,
// // // // // // // // // // // //   useTheme,
// // // // // // // // // // // //   useMediaQuery,
// // // // // // // // // // // //   Tooltip,
// // // // // // // // // // // //   Divider,
// // // // // // // // // // // //   Drawer,
// // // // // // // // // // // //   List,
// // // // // // // // // // // //   ListItem,
// // // // // // // // // // // //   ListItemText,
// // // // // // // // // // // // } from "@mui/material";
// // // // // // // // // // // // import {
// // // // // // // // // // // //   NotificationsOutlined,
// // // // // // // // // // // //   Menu as MenuIcon,
// // // // // // // // // // // //   Brightness4,
// // // // // // // // // // // //   Brightness7,
// // // // // // // // // // // //   EmailOutlined,
// // // // // // // // // // // //   PhoneOutlined,
// // // // // // // // // // // //   Close,
// // // // // // // // // // // // } from "@mui/icons-material";
// // // // // // // // // // // // import { useAuth } from "../../context/AuthContext";
// // // // // // // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // // // // // // import { useChatBot } from "../../context/ChatBotContext";
// // // // // // // // // // // // import Sidebar from "./Sidebar";
// // // // // // // // // // // // import ChatBot from "../common/ChatBot";
// // // // // // // // // // // // import { useThemeToggle } from "./Theme";
// // // // // // // // // // // // import apiClient from "../../context/apiClient";

// // // // // // // // // // // // const Layout = ({ children, title }) => {
// // // // // // // // // // // //   const { user, logout } = useAuth();
// // // // // // // // // // // //   const { setIsOpen } = useChatBot();
// // // // // // // // // // // //   const navigate = useNavigate();
// // // // // // // // // // // //   const theme = useTheme();
// // // // // // // // // // // //   const { toggleColorMode } = useThemeToggle();
// // // // // // // // // // // //   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

// // // // // // // // // // // //   const [isDesktopOpen, setDesktopOpen] = useState(() => {
// // // // // // // // // // // //     const savedState = sessionStorage.getItem("sidebarOpenState");
// // // // // // // // // // // //     return savedState !== null ? JSON.parse(savedState) : true;
// // // // // // // // // // // //   });

// // // // // // // // // // // //   const [isMobileOpen, setMobileOpen] = useState(false);
// // // // // // // // // // // //   const [anchorEl, setAnchorEl] = useState(null);
// // // // // // // // // // // //   const [isNotificationDrawerOpen, setNotificationDrawerOpen] = useState(false);
// // // // // // // // // // // //   const [profilePhotoUrl, setProfilePhotoUrl] = useState(null);
// // // // // // // // // // // //   const [notifications, setNotifications] = useState([]);

// // // // // // // // // // // //   useEffect(() => {
// // // // // // // // // // // //     if (!isMobile) {
// // // // // // // // // // // //       sessionStorage.setItem("sidebarOpenState", JSON.stringify(isDesktopOpen));
// // // // // // // // // // // //     }
// // // // // // // // // // // //   }, [isDesktopOpen, isMobile]);

// // // // // // // // // // // //   useEffect(() => {
// // // // // // // // // // // //     const fetchProfilePhoto = async () => {
// // // // // // // // // // // //       try {
// // // // // // // // // // // //         const response = await apiClient.get("resume-builder/");
// // // // // // // // // // // //         if (response.data && response.data.profile_photo_url) {
// // // // // // // // // // // //           setProfilePhotoUrl(response.data.profile_photo_url);
// // // // // // // // // // // //         }
// // // // // // // // // // // //       } catch (error) {
// // // // // // // // // // // //         console.error("Failed to fetch profile photo", error);
// // // // // // // // // // // //       }
// // // // // // // // // // // //     };

// // // // // // // // // // // //     const fetchNotifications = async () => {
// // // // // // // // // // // //       try {
// // // // // // // // // // // //         const response = await apiClient.get("notifications/");
// // // // // // // // // // // //         // Updated to handle direct array response
// // // // // // // // // // // //         if (response.data && Array.isArray(response.data)) {
// // // // // // // // // // // //           setNotifications(response.data);
// // // // // // // // // // // //         }
// // // // // // // // // // // //       } catch (error) {
// // // // // // // // // // // //         console.error("Failed to fetch notifications", error);
// // // // // // // // // // // //       }
// // // // // // // // // // // //     };

// // // // // // // // // // // //     fetchProfilePhoto();
// // // // // // // // // // // //     fetchNotifications();
// // // // // // // // // // // //   }, []);

// // // // // // // // // // // //   const handleDesktopToggle = () => {
// // // // // // // // // // // //     setDesktopOpen(!isDesktopOpen);
// // // // // // // // // // // //   };

// // // // // // // // // // // //   const handleMobileToggle = () => {
// // // // // // // // // // // //     setMobileOpen(!isMobileOpen);
// // // // // // // // // // // //   };

// // // // // // // // // // // //   const handleMenu = (event) => setAnchorEl(event.currentTarget);

// // // // // // // // // // // //   const handleNotificationToggle = () => {
// // // // // // // // // // // //     setNotificationDrawerOpen(!isNotificationDrawerOpen);
// // // // // // // // // // // //   };

// // // // // // // // // // // //   const handleClose = () => {
// // // // // // // // // // // //     setAnchorEl(null);
// // // // // // // // // // // //   };

// // // // // // // // // // // //   return (
// // // // // // // // // // // //     <Box
// // // // // // // // // // // //       sx={{
// // // // // // // // // // // //         display: "flex",
// // // // // // // // // // // //         minHeight: "100vh",
// // // // // // // // // // // //         overflow: "hidden",
// // // // // // // // // // // //         bgcolor: "background.default",
// // // // // // // // // // // //       }}
// // // // // // // // // // // //     >
// // // // // // // // // // // //       <AppBar
// // // // // // // // // // // //         position="fixed"
// // // // // // // // // // // //         elevation={0}
// // // // // // // // // // // //         sx={{
// // // // // // // // // // // //           zIndex: theme.zIndex.drawer + 1,
// // // // // // // // // // // //           backgroundColor: theme.palette.primary.main,
// // // // // // // // // // // //           color: theme.palette.primary.contrastText,
// // // // // // // // // // // //         }}
// // // // // // // // // // // //       >
// // // // // // // // // // // //         <Toolbar
// // // // // // // // // // // //           sx={{
// // // // // // // // // // // //             px: { xs: 2, sm: 3 },
// // // // // // // // // // // //             minHeight: { xs: 56, sm: 64 },
// // // // // // // // // // // //             display: "flex",
// // // // // // // // // // // //             justifyContent: "space-between",
// // // // // // // // // // // //             alignItems: "center",
// // // // // // // // // // // //           }}
// // // // // // // // // // // //         >
// // // // // // // // // // // //           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
// // // // // // // // // // // //             <IconButton
// // // // // // // // // // // //               color="inherit"
// // // // // // // // // // // //               onClick={handleMobileToggle}
// // // // // // // // // // // //               sx={{ display: { md: "none" } }}
// // // // // // // // // // // //             >
// // // // // // // // // // // //               <MenuIcon />
// // // // // // // // // // // //             </IconButton>
// // // // // // // // // // // //             <Typography
// // // // // // // // // // // //               variant="h6"
// // // // // // // // // // // //               sx={{
// // // // // // // // // // // //                 fontWeight: "bold",
// // // // // // // // // // // //                 fontSize: { xs: "1.1rem", sm: "1.25rem" },
// // // // // // // // // // // //                 color: "inherit",
// // // // // // // // // // // //               }}
// // // // // // // // // // // //             >
// // // // // // // // // // // //               {title}
// // // // // // // // // // // //             </Typography>
// // // // // // // // // // // //           </Box>
// // // // // // // // // // // //           <Box
// // // // // // // // // // // //             sx={{
// // // // // // // // // // // //               display: "flex",
// // // // // // // // // // // //               alignItems: "center",
// // // // // // // // // // // //               gap: { xs: 1, sm: 2 },
// // // // // // // // // // // //             }}
// // // // // // // // // // // //           >
// // // // // // // // // // // //             <Tooltip title="Toggle light/dark theme">
// // // // // // // // // // // //               <IconButton color="inherit" onClick={toggleColorMode}>
// // // // // // // // // // // //                 {theme.palette.mode === "dark" ? (
// // // // // // // // // // // //                   <Brightness7 />
// // // // // // // // // // // //                 ) : (
// // // // // // // // // // // //                   <Brightness4 />
// // // // // // // // // // // //                 )}
// // // // // // // // // // // //               </IconButton>
// // // // // // // // // // // //             </Tooltip>
// // // // // // // // // // // //             <Tooltip title="Notifications">
// // // // // // // // // // // //               <IconButton color="inherit" onClick={handleNotificationToggle}>
// // // // // // // // // // // //                 <Badge badgeContent={notifications.length} color="error">
// // // // // // // // // // // //                   <NotificationsOutlined />
// // // // // // // // // // // //                 </Badge>
// // // // // // // // // // // //               </IconButton>
// // // // // // // // // // // //             </Tooltip>
// // // // // // // // // // // //             <Box
// // // // // // // // // // // //               onClick={handleMenu}
// // // // // // // // // // // //               sx={{
// // // // // // // // // // // //                 display: "flex",
// // // // // // // // // // // //                 alignItems: "center",
// // // // // // // // // // // //                 gap: 1.5,
// // // // // // // // // // // //                 cursor: "pointer",
// // // // // // // // // // // //                 p: 0.5,
// // // // // // // // // // // //                 borderRadius: "8px",
// // // // // // // // // // // //                 "&:hover": {
// // // // // // // // // // // //                   backgroundColor: "rgba(255, 255, 255, 0.1)",
// // // // // // // // // // // //                 },
// // // // // // // // // // // //               }}
// // // // // // // // // // // //             >
// // // // // // // // // // // //               <Avatar
// // // // // // // // // // // //                 sx={{ width: 40, height: 40 }}
// // // // // // // // // // // //                 alt={user?.username || "Not specified"}
// // // // // // // // // // // //                 src={profilePhotoUrl}
// // // // // // // // // // // //               />
// // // // // // // // // // // //               <Box
// // // // // // // // // // // //                 sx={{
// // // // // // // // // // // //                   display: { xs: "none", md: "flex" },
// // // // // // // // // // // //                   flexDirection: "column",
// // // // // // // // // // // //                   alignItems: "flex-start",
// // // // // // // // // // // //                 }}
// // // // // // // // // // // //               >
// // // // // // // // // // // //                 <Typography
// // // // // // // // // // // //                   sx={{
// // // // // // // // // // // //                     color: "inherit",
// // // // // // // // // // // //                     fontWeight: "bold",
// // // // // // // // // // // //                     lineHeight: 1.2,
// // // // // // // // // // // //                     fontSize: "0.9rem",
// // // // // // // // // // // //                   }}
// // // // // // // // // // // //                 >
// // // // // // // // // // // //                   {user?.username || "Not specified"}
// // // // // // // // // // // //                 </Typography>
// // // // // // // // // // // //                 <Typography
// // // // // // // // // // // //                   variant="caption"
// // // // // // // // // // // //                   sx={{
// // // // // // // // // // // //                     color: "inherit",
// // // // // // // // // // // //                     opacity: 0.85,
// // // // // // // // // // // //                     textTransform: "capitalize",
// // // // // // // // // // // //                   }}
// // // // // // // // // // // //                 >
// // // // // // // // // // // //                   {user?.role || "Admin"}
// // // // // // // // // // // //                 </Typography>
// // // // // // // // // // // //               </Box>
// // // // // // // // // // // //             </Box>
// // // // // // // // // // // //           </Box>
// // // // // // // // // // // //         </Toolbar>
// // // // // // // // // // // //       </AppBar>

// // // // // // // // // // // //       <Sidebar
// // // // // // // // // // // //         open={isDesktopOpen}
// // // // // // // // // // // //         onToggle={handleDesktopToggle}
// // // // // // // // // // // //         mobileOpen={isMobileOpen}
// // // // // // // // // // // //         onMobileToggle={handleMobileToggle}
// // // // // // // // // // // //       />

// // // // // // // // // // // //       <Box
// // // // // // // // // // // //         component="main"
// // // // // // // // // // // //         sx={{
// // // // // // // // // // // //           flexGrow: 1,
// // // // // // // // // // // //           mt: { xs: "56px", sm: "64px" },
// // // // // // // // // // // //           overflow: "hidden",
// // // // // // // // // // // //           boxSizing: "border-box",
// // // // // // // // // // // //           height: `calc(100vh - ${isMobile ? "56px" : "64px"})`,
// // // // // // // // // // // //           position: "relative",
// // // // // // // // // // // //         }}
// // // // // // // // // // // //       >
// // // // // // // // // // // //         <Box
// // // // // // // // // // // //           sx={{
// // // // // // // // // // // //             height: "100%",
// // // // // // // // // // // //             overflowY: "scroll",
// // // // // // // // // // // //           }}
// // // // // // // // // // // //         >
// // // // // // // // // // // //           {children}
// // // // // // // // // // // //         </Box>
// // // // // // // // // // // //       </Box>

// // // // // // // // // // // //       {/* --- Notification Drawer --- */}
// // // // // // // // // // // //       <Drawer
// // // // // // // // // // // //         anchor="right"
// // // // // // // // // // // //         open={isNotificationDrawerOpen}
// // // // // // // // // // // //         onClose={handleNotificationToggle}
// // // // // // // // // // // //         sx={{
// // // // // // // // // // // //           "& .MuiDrawer-paper": {
// // // // // // // // // // // //             boxSizing: "border-box",
// // // // // // // // // // // //             width: { xs: "90vw", sm: 360, md: 400 },
// // // // // // // // // // // //           },
// // // // // // // // // // // //         }}
// // // // // // // // // // // //       >
// // // // // // // // // // // //         <Box
// // // // // // // // // // // //           sx={{
// // // // // // // // // // // //             p: 2,
// // // // // // // // // // // //             display: "flex",
// // // // // // // // // // // //             justifyContent: "space-between",
// // // // // // // // // // // //             alignItems: "center",
// // // // // // // // // // // //           }}
// // // // // // // // // // // //         >
// // // // // // // // // // // //           <Typography variant="h6" fontWeight={600}>
// // // // // // // // // // // //             Notifications
// // // // // // // // // // // //           </Typography>
// // // // // // // // // // // //           <IconButton onClick={handleNotificationToggle}>
// // // // // // // // // // // //             <Close />
// // // // // // // // // // // //           </IconButton>
// // // // // // // // // // // //         </Box>
// // // // // // // // // // // //         <Divider />
// // // // // // // // // // // //         {notifications.length > 0 ? (
// // // // // // // // // // // //           <List sx={{ p: 0 }}>
// // // // // // // // // // // //             {notifications.map((n) => (
// // // // // // // // // // // //               <Fragment key={n.id}>
// // // // // // // // // // // //                 <ListItem alignItems="flex-start" sx={{ py: 1.5, px: 2 }}>
// // // // // // // // // // // //                   <ListItemText
// // // // // // // // // // // //                     primary={n.title}
// // // // // // // // // // // //                     secondary={
// // // // // // // // // // // //                       <Typography
// // // // // // // // // // // //                         variant="body2"
// // // // // // // // // // // //                         color="text.secondary"
// // // // // // // // // // // //                         sx={{ whiteSpace: "pre-wrap" }} // Preserves newlines
// // // // // // // // // // // //                       >
// // // // // // // // // // // //                         {n.message}
// // // // // // // // // // // //                       </Typography>
// // // // // // // // // // // //                     }
// // // // // // // // // // // //                     primaryTypographyProps={{ fontWeight: "bold" }}
// // // // // // // // // // // //                   />
// // // // // // // // // // // //                 </ListItem>
// // // // // // // // // // // //                 <Divider component="li" />
// // // // // // // // // // // //               </Fragment>
// // // // // // // // // // // //             ))}
// // // // // // // // // // // //           </List>
// // // // // // // // // // // //         ) : (
// // // // // // // // // // // //           <Box sx={{ p: 3, textAlign: "center" }}>
// // // // // // // // // // // //             <Typography variant="body2" color="text.secondary">
// // // // // // // // // // // //               No new notifications
// // // // // // // // // // // //             </Typography>
// // // // // // // // // // // //           </Box>
// // // // // // // // // // // //         )}
// // // // // // // // // // // //       </Drawer>

// // // // // // // // // // // //       <Menu
// // // // // // // // // // // //         anchorEl={anchorEl}
// // // // // // // // // // // //         open={Boolean(anchorEl)}
// // // // // // // // // // // //         onClose={handleClose}
// // // // // // // // // // // //         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
// // // // // // // // // // // //         transformOrigin={{ vertical: "top", horizontal: "right" }}
// // // // // // // // // // // //         slotProps={{
// // // // // // // // // // // //           paper: {
// // // // // // // // // // // //             elevation: 0,
// // // // // // // // // // // //             sx: {
// // // // // // // // // // // //               overflow: "visible",
// // // // // // // // // // // //               width: 250,
// // // // // // // // // // // //               mt: 1.5,
// // // // // // // // // // // //               backgroundColor: "primary.main",
// // // // // // // // // // // //               color: "primary.contrastText",
// // // // // // // // // // // //               borderRadius: "10px",
// // // // // // // // // // // //               boxShadow: "0px 4px 20px rgba(0,0,0,0.4)",
// // // // // // // // // // // //               "& .MuiList-root": {
// // // // // // // // // // // //                 padding: "0px",
// // // // // // // // // // // //               },
// // // // // // // // // // // //               "& .MuiMenuItem-root": {
// // // // // // // // // // // //                 padding: "12px 16px",
// // // // // // // // // // // //               },
// // // // // // // // // // // //             },
// // // // // // // // // // // //           },
// // // // // // // // // // // //         }}
// // // // // // // // // // // //       >
// // // // // // // // // // // //         <Box sx={{ p: 2, pt: 1.5 }}>
// // // // // // // // // // // //           <Typography variant="subtitle1" fontWeight={600} color="inherit">
// // // // // // // // // // // //             {user?.username}
// // // // // // // // // // // //           </Typography>
// // // // // // // // // // // //           <Typography
// // // // // // // // // // // //             variant="caption"
// // // // // // // // // // // //             sx={{ textTransform: "capitalize", color: "inherit", opacity: 0.9 }}
// // // // // // // // // // // //           >
// // // // // // // // // // // //             Role: {user?.role}
// // // // // // // // // // // //           </Typography>
// // // // // // // // // // // //           <Divider sx={{ my: 1.5, borderColor: "rgba(255, 255, 255, 0.2)" }} />
// // // // // // // // // // // //           <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
// // // // // // // // // // // //             <EmailOutlined
// // // // // // // // // // // //               fontSize="small"
// // // // // // // // // // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // // // // // // // // // //             />
// // // // // // // // // // // //             <Typography
// // // // // // // // // // // //               variant="body2"
// // // // // // // // // // // //               sx={{ wordBreak: "break-all", color: "inherit" }}
// // // // // // // // // // // //             >
// // // // // // // // // // // //               {user?.email}
// // // // // // // // // // // //             </Typography>
// // // // // // // // // // // //           </Box>
// // // // // // // // // // // //           <Box sx={{ display: "flex", alignItems: "center" }}>
// // // // // // // // // // // //             <PhoneOutlined
// // // // // // // // // // // //               fontSize="small"
// // // // // // // // // // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // // // // // // // // // //             />
// // // // // // // // // // // //             <Typography variant="body2" color="inherit">
// // // // // // // // // // // //               {user?.phone_number}
// // // // // // // // // // // //             </Typography>
// // // // // // // // // // // //           </Box>
// // // // // // // // // // // //         </Box>
// // // // // // // // // // // //       </Menu>

// // // // // // // // // // // //       <ChatBot />
// // // // // // // // // // // //     </Box>
// // // // // // // // // // // //   );
// // // // // // // // // // // // };

// // // // // // // // // // // // export default Layout;
// // // // // // // // // // // import { useState, useEffect, Fragment } from "react";
// // // // // // // // // // // import {
// // // // // // // // // // //   AppBar,
// // // // // // // // // // //   Toolbar,
// // // // // // // // // // //   Typography,
// // // // // // // // // // //   Box,
// // // // // // // // // // //   IconButton,
// // // // // // // // // // //   Menu,
// // // // // // // // // // //   MenuItem,
// // // // // // // // // // //   Badge,
// // // // // // // // // // //   Avatar,
// // // // // // // // // // //   useTheme,
// // // // // // // // // // //   useMediaQuery,
// // // // // // // // // // //   Tooltip,
// // // // // // // // // // //   Divider,
// // // // // // // // // // //   Drawer,
// // // // // // // // // // //   List,
// // // // // // // // // // //   ListItem,
// // // // // // // // // // //   ListItemText,
// // // // // // // // // // // } from "@mui/material";
// // // // // // // // // // // import {
// // // // // // // // // // //   NotificationsOutlined,
// // // // // // // // // // //   Menu as MenuIcon,
// // // // // // // // // // //   Brightness4,
// // // // // // // // // // //   Brightness7,
// // // // // // // // // // //   EmailOutlined,
// // // // // // // // // // //   PhoneOutlined,
// // // // // // // // // // //   Close,
// // // // // // // // // // // } from "@mui/icons-material";
// // // // // // // // // // // import { useAuth } from "../../context/AuthContext";
// // // // // // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // // // // // import { useChatBot } from "../../context/ChatBotContext";
// // // // // // // // // // // import Sidebar from "./Sidebar";
// // // // // // // // // // // import ChatBot from "../common/ChatBot";
// // // // // // // // // // // import { useThemeToggle } from "./Theme";
// // // // // // // // // // // // --- REMOVED: apiClient is no longer needed here ---
// // // // // // // // // // // // import apiClient from "../../context/apiClient";

// // // // // // // // // // // const Layout = ({ children, title }) => {
// // // // // // // // // // //   // --- UPDATED: Get user AND notifications from the context ---
// // // // // // // // // // //   const { user, logout, notifications } = useAuth();
// // // // // // // // // // //   const { setIsOpen } = useChatBot();
// // // // // // // // // // //   const navigate = useNavigate();
// // // // // // // // // // //   const theme = useTheme();
// // // // // // // // // // //   const { toggleColorMode } = useThemeToggle();
// // // // // // // // // // //   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

// // // // // // // // // // //   const [isDesktopOpen, setDesktopOpen] = useState(() => {
// // // // // // // // // // //     const savedState = sessionStorage.getItem("sidebarOpenState");
// // // // // // // // // // //     return savedState !== null ? JSON.parse(savedState) : true;
// // // // // // // // // // //   });

// // // // // // // // // // //   const [isMobileOpen, setMobileOpen] = useState(false);
// // // // // // // // // // //   const [anchorEl, setAnchorEl] = useState(null);
// // // // // // // // // // //   const [isNotificationDrawerOpen, setNotificationDrawerOpen] = useState(false);

// // // // // // // // // // //   // --- REMOVED: All state and useEffects related to data fetching ---
// // // // // // // // // // //   // const [profilePhotoUrl, setProfilePhotoUrl] = useState(null);
// // // // // // // // // // //   // const [notifications, setNotifications] = useState([]);
// // // // // // // // // // //   // The useEffect for fetching is GONE.

// // // // // // // // // // //   useEffect(() => {
// // // // // // // // // // //     if (!isMobile) {
// // // // // // // // // // //       sessionStorage.setItem("sidebarOpenState", JSON.stringify(isDesktopOpen));
// // // // // // // // // // //     }
// // // // // // // // // // //   }, [isDesktopOpen, isMobile]);

// // // // // // // // // // //   const handleDesktopToggle = () => setDesktopOpen(!isDesktopOpen);
// // // // // // // // // // //   const handleMobileToggle = () => setMobileOpen(!isMobileOpen);
// // // // // // // // // // //   const handleMenu = (event) => setAnchorEl(event.currentTarget);
// // // // // // // // // // //   const handleNotificationToggle = () =>
// // // // // // // // // // //     setNotificationDrawerOpen(!isNotificationDrawerOpen);
// // // // // // // // // // //   const handleClose = () => setAnchorEl(null);

// // // // // // // // // // //   return (
// // // // // // // // // // //     <Box
// // // // // // // // // // //       sx={{
// // // // // // // // // // //         display: "flex",
// // // // // // // // // // //         minHeight: "100vh",
// // // // // // // // // // //         overflow: "hidden",
// // // // // // // // // // //         bgcolor: "background.default",
// // // // // // // // // // //       }}
// // // // // // // // // // //     >
// // // // // // // // // // //       <AppBar
// // // // // // // // // // //         position="fixed"
// // // // // // // // // // //         elevation={0}
// // // // // // // // // // //         sx={{
// // // // // // // // // // //           zIndex: theme.zIndex.drawer + 1,
// // // // // // // // // // //           backgroundColor: theme.palette.primary.main,
// // // // // // // // // // //           color: theme.palette.primary.contrastText,
// // // // // // // // // // //         }}
// // // // // // // // // // //       >
// // // // // // // // // // //         <Toolbar
// // // // // // // // // // //           sx={{
// // // // // // // // // // //             px: { xs: 2, sm: 3 },
// // // // // // // // // // //             minHeight: { xs: 56, sm: 64 },
// // // // // // // // // // //             display: "flex",
// // // // // // // // // // //             justifyContent: "space-between",
// // // // // // // // // // //             alignItems: "center",
// // // // // // // // // // //           }}
// // // // // // // // // // //         >
// // // // // // // // // // //           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
// // // // // // // // // // //             <IconButton
// // // // // // // // // // //               color="inherit"
// // // // // // // // // // //               onClick={handleMobileToggle}
// // // // // // // // // // //               sx={{ display: { md: "none" } }}
// // // // // // // // // // //             >
// // // // // // // // // // //               <MenuIcon />
// // // // // // // // // // //             </IconButton>
// // // // // // // // // // //             <Typography
// // // // // // // // // // //               variant="h6"
// // // // // // // // // // //               sx={{
// // // // // // // // // // //                 fontWeight: "bold",
// // // // // // // // // // //                 fontSize: { xs: "1.1rem", sm: "1.25rem" },
// // // // // // // // // // //                 color: "inherit",
// // // // // // // // // // //               }}
// // // // // // // // // // //             >
// // // // // // // // // // //               {title}
// // // // // // // // // // //             </Typography>
// // // // // // // // // // //           </Box>
// // // // // // // // // // //           <Box
// // // // // // // // // // //             sx={{
// // // // // // // // // // //               display: "flex",
// // // // // // // // // // //               alignItems: "center",
// // // // // // // // // // //               gap: { xs: 1, sm: 2 },
// // // // // // // // // // //             }}
// // // // // // // // // // //           >
// // // // // // // // // // //             <Tooltip title="Toggle light/dark theme">
// // // // // // // // // // //               <IconButton color="inherit" onClick={toggleColorMode}>
// // // // // // // // // // //                 {theme.palette.mode === "dark" ? (
// // // // // // // // // // //                   <Brightness7 />
// // // // // // // // // // //                 ) : (
// // // // // // // // // // //                   <Brightness4 />
// // // // // // // // // // //                 )}
// // // // // // // // // // //               </IconButton>
// // // // // // // // // // //             </Tooltip>
// // // // // // // // // // //             <Tooltip title="Notifications">
// // // // // // // // // // //               <IconButton color="inherit" onClick={handleNotificationToggle}>
// // // // // // // // // // //                 {/* --- UPDATED: Uses notifications from context now --- */}
// // // // // // // // // // //                 <Badge badgeContent={notifications?.length || 0} color="error">
// // // // // // // // // // //                   <NotificationsOutlined />
// // // // // // // // // // //                 </Badge>
// // // // // // // // // // //               </IconButton>
// // // // // // // // // // //             </Tooltip>
// // // // // // // // // // //             <Box
// // // // // // // // // // //               onClick={handleMenu}
// // // // // // // // // // //               sx={{
// // // // // // // // // // //                 display: "flex",
// // // // // // // // // // //                 alignItems: "center",
// // // // // // // // // // //                 gap: 1.5,
// // // // // // // // // // //                 cursor: "pointer",
// // // // // // // // // // //                 p: 0.5,
// // // // // // // // // // //                 borderRadius: "8px",
// // // // // // // // // // //                 "&:hover": {
// // // // // // // // // // //                   backgroundColor: "rgba(255, 255, 255, 0.1)",
// // // // // // // // // // //                 },
// // // // // // // // // // //               }}
// // // // // // // // // // //             >
// // // // // // // // // // //               {/* --- UPDATED: Avatar no longer uses profilePhotoUrl --- */}
// // // // // // // // // // //               <Avatar
// // // // // // // // // // //                 sx={{ width: 40, height: 40 }}
// // // // // // // // // // //                 alt={user?.username || "Not specified"}
// // // // // // // // // // //               />
// // // // // // // // // // //               <Box
// // // // // // // // // // //                 sx={{
// // // // // // // // // // //                   display: { xs: "none", md: "flex" },
// // // // // // // // // // //                   flexDirection: "column",
// // // // // // // // // // //                   alignItems: "flex-start",
// // // // // // // // // // //                 }}
// // // // // // // // // // //               >
// // // // // // // // // // //                 <Typography
// // // // // // // // // // //                   sx={{
// // // // // // // // // // //                     color: "inherit",
// // // // // // // // // // //                     fontWeight: "bold",
// // // // // // // // // // //                     lineHeight: 1.2,
// // // // // // // // // // //                     fontSize: "0.9rem",
// // // // // // // // // // //                   }}
// // // // // // // // // // //                 >
// // // // // // // // // // //                   {user?.username || "Not specified"}
// // // // // // // // // // //                 </Typography>
// // // // // // // // // // //                 <Typography
// // // // // // // // // // //                   variant="caption"
// // // // // // // // // // //                   sx={{
// // // // // // // // // // //                     color: "inherit",
// // // // // // // // // // //                     opacity: 0.85,
// // // // // // // // // // //                     textTransform: "capitalize",
// // // // // // // // // // //                   }}
// // // // // // // // // // //                 >
// // // // // // // // // // //                   {user?.role || "Admin"}
// // // // // // // // // // //                 </Typography>
// // // // // // // // // // //               </Box>
// // // // // // // // // // //             </Box>
// // // // // // // // // // //           </Box>
// // // // // // // // // // //         </Toolbar>
// // // // // // // // // // //       </AppBar>

// // // // // // // // // // //       <Sidebar
// // // // // // // // // // //         open={isDesktopOpen}
// // // // // // // // // // //         onToggle={handleDesktopToggle}
// // // // // // // // // // //         mobileOpen={isMobileOpen}
// // // // // // // // // // //         onMobileToggle={handleMobileToggle}
// // // // // // // // // // //       />

// // // // // // // // // // //       <Box
// // // // // // // // // // //         component="main"
// // // // // // // // // // //         sx={{
// // // // // // // // // // //           flexGrow: 1,
// // // // // // // // // // //           mt: { xs: "56px", sm: "64px" },
// // // // // // // // // // //           overflow: "hidden",
// // // // // // // // // // //           boxSizing: "border-box",
// // // // // // // // // // //           height: `calc(100vh - ${isMobile ? "56px" : "64px"})`,
// // // // // // // // // // //           position: "relative",
// // // // // // // // // // //         }}
// // // // // // // // // // //       >
// // // // // // // // // // //         <Box
// // // // // // // // // // //           sx={{
// // // // // // // // // // //             height: "100%",
// // // // // // // // // // //             overflowY: "scroll",
// // // // // // // // // // //           }}
// // // // // // // // // // //         >
// // // // // // // // // // //           {children}
// // // // // // // // // // //         </Box>
// // // // // // // // // // //       </Box>

// // // // // // // // // // //       {/* --- Notification Drawer (no changes needed inside) --- */}
// // // // // // // // // // //       <Drawer
// // // // // // // // // // //         anchor="right"
// // // // // // // // // // //         open={isNotificationDrawerOpen}
// // // // // // // // // // //         onClose={handleNotificationToggle}
// // // // // // // // // // //         sx={{
// // // // // // // // // // //           "& .MuiDrawer-paper": {
// // // // // // // // // // //             boxSizing: "border-box",
// // // // // // // // // // //             width: { xs: "90vw", sm: 360, md: 400 },
// // // // // // // // // // //           },
// // // // // // // // // // //         }}
// // // // // // // // // // //       >
// // // // // // // // // // //         <Box
// // // // // // // // // // //           sx={{
// // // // // // // // // // //             p: 2,
// // // // // // // // // // //             display: "flex",
// // // // // // // // // // //             justifyContent: "space-between",
// // // // // // // // // // //             alignItems: "center",
// // // // // // // // // // //           }}
// // // // // // // // // // //         >
// // // // // // // // // // //           <Typography variant="h6" fontWeight={600}>
// // // // // // // // // // //             Notifications
// // // // // // // // // // //           </Typography>
// // // // // // // // // // //           <IconButton onClick={handleNotificationToggle}>
// // // // // // // // // // //             <Close />
// // // // // // // // // // //           </IconButton>
// // // // // // // // // // //         </Box>
// // // // // // // // // // //         <Divider />
// // // // // // // // // // //         {notifications && notifications.length > 0 ? (
// // // // // // // // // // //           <List sx={{ p: 0 }}>
// // // // // // // // // // //             {notifications.map((n) => (
// // // // // // // // // // //               <Fragment key={n.id}>
// // // // // // // // // // //                 <ListItem alignItems="flex-start" sx={{ py: 1.5, px: 2 }}>
// // // // // // // // // // //                   <ListItemText
// // // // // // // // // // //                     primary={n.title}
// // // // // // // // // // //                     secondary={
// // // // // // // // // // //                       <Typography
// // // // // // // // // // //                         variant="body2"
// // // // // // // // // // //                         color="text.secondary"
// // // // // // // // // // //                         sx={{ whiteSpace: "pre-wrap" }} // Preserves newlines
// // // // // // // // // // //                       >
// // // // // // // // // // //                         {n.message}
// // // // // // // // // // //                       </Typography>
// // // // // // // // // // //                     }
// // // // // // // // // // //                     primaryTypographyProps={{ fontWeight: "bold" }}
// // // // // // // // // // //                   />
// // // // // // // // // // //                 </ListItem>
// // // // // // // // // // //                 <Divider component="li" />
// // // // // // // // // // //               </Fragment>
// // // // // // // // // // //             ))}
// // // // // // // // // // //           </List>
// // // // // // // // // // //         ) : (
// // // // // // // // // // //           <Box sx={{ p: 3, textAlign: "center" }}>
// // // // // // // // // // //             <Typography variant="body2" color="text.secondary">
// // // // // // // // // // //               No new notifications
// // // // // // // // // // //             </Typography>
// // // // // // // // // // //           </Box>
// // // // // // // // // // //         )}
// // // // // // // // // // //       </Drawer>

// // // // // // // // // // //       {/* --- Menu (no changes needed) --- */}
// // // // // // // // // // //       <Menu
// // // // // // // // // // //         anchorEl={anchorEl}
// // // // // // // // // // //         open={Boolean(anchorEl)}
// // // // // // // // // // //         onClose={handleClose}
// // // // // // // // // // //         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
// // // // // // // // // // //         transformOrigin={{ vertical: "top", horizontal: "right" }}
// // // // // // // // // // //         slotProps={{
// // // // // // // // // // //           paper: {
// // // // // // // // // // //             elevation: 0,
// // // // // // // // // // //             sx: {
// // // // // // // // // // //               overflow: "visible",
// // // // // // // // // // //               width: 250,
// // // // // // // // // // //               mt: 1.5,
// // // // // // // // // // //               backgroundColor: "primary.main",
// // // // // // // // // // //               color: "primary.contrastText",
// // // // // // // // // // //               borderRadius: "10px",
// // // // // // // // // // //               boxShadow: "0px 4px 20px rgba(0,0,0,0.4)",
// // // // // // // // // // //               "& .MuiList-root": {
// // // // // // // // // // //                 padding: "0px",
// // // // // // // // // // //               },
// // // // // // // // // // //               "& .MuiMenuItem-root": {
// // // // // // // // // // //                 padding: "12px 16px",
// // // // // // // // // // //               },
// // // // // // // // // // //             },
// // // // // // // // // // //           },
// // // // // // // // // // //         }}
// // // // // // // // // // //       >
// // // // // // // // // // //         <Box sx={{ p: 2, pt: 1.5 }}>
// // // // // // // // // // //           <Typography variant="subtitle1" fontWeight={600} color="inherit">
// // // // // // // // // // //             {user?.username}
// // // // // // // // // // //           </Typography>
// // // // // // // // // // //           <Typography
// // // // // // // // // // //             variant="caption"
// // // // // // // // // // //             sx={{ textTransform: "capitalize", color: "inherit", opacity: 0.9 }}
// // // // // // // // // // //           >
// // // // // // // // // // //             Role: {user?.role}
// // // // // // // // // // //           </Typography>
// // // // // // // // // // //           <Divider sx={{ my: 1.5, borderColor: "rgba(255, 255, 255, 0.2)" }} />
// // // // // // // // // // //           <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
// // // // // // // // // // //             <EmailOutlined
// // // // // // // // // // //               fontSize="small"
// // // // // // // // // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // // // // // // // // //             />
// // // // // // // // // // //             <Typography
// // // // // // // // // // //               variant="body2"
// // // // // // // // // // //               sx={{ wordBreak: "break-all", color: "inherit" }}
// // // // // // // // // // //             >
// // // // // // // // // // //               {user?.email}
// // // // // // // // // // //             </Typography>
// // // // // // // // // // //           </Box>
// // // // // // // // // // //           <Box sx={{ display: "flex", alignItems: "center" }}>
// // // // // // // // // // //             <PhoneOutlined
// // // // // // // // // // //               fontSize="small"
// // // // // // // // // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // // // // // // // // //             />
// // // // // // // // // // //             <Typography variant="body2" color="inherit">
// // // // // // // // // // //               {user?.phone_number}
// // // // // // // // // // //             </Typography>
// // // // // // // // // // //           </Box>
// // // // // // // // // // //         </Box>
// // // // // // // // // // //       </Menu>

// // // // // // // // // // //       <ChatBot />
// // // // // // // // // // //     </Box>
// // // // // // // // // // //   );
// // // // // // // // // // // };

// // // // // // // // // // // export default Layout;
// // // // // // // // // // import { useState, useEffect, Fragment } from "react";
// // // // // // // // // // import {
// // // // // // // // // //   AppBar,
// // // // // // // // // //   Toolbar,
// // // // // // // // // //   Typography,
// // // // // // // // // //   Box,
// // // // // // // // // //   IconButton,
// // // // // // // // // //   Menu,
// // // // // // // // // //   MenuItem,
// // // // // // // // // //   Badge,
// // // // // // // // // //   Avatar,
// // // // // // // // // //   useTheme,
// // // // // // // // // //   useMediaQuery,
// // // // // // // // // //   Tooltip,
// // // // // // // // // //   Divider,
// // // // // // // // // //   Drawer,
// // // // // // // // // //   List,
// // // // // // // // // //   ListItem,
// // // // // // // // // //   ListItemText,
// // // // // // // // // //   Button, // Import Button for the new footer
// // // // // // // // // //   Paper, // Import Paper for the card design
// // // // // // // // // //   Stack, // Import Stack for easy layout
// // // // // // // // // // } from "@mui/material";
// // // // // // // // // // import {
// // // // // // // // // //   NotificationsOutlined,
// // // // // // // // // //   Menu as MenuIcon,
// // // // // // // // // //   Brightness4,
// // // // // // // // // //   Brightness7,
// // // // // // // // // //   EmailOutlined,
// // // // // // // // // //   PhoneOutlined,
// // // // // // // // // //   Close,
// // // // // // // // // //   CheckCircleOutline, // New icon for empty state
// // // // // // // // // //   DeleteSweepOutlined, // New icon for "Clear All"
// // // // // // // // // //   AccessTime, // New icon for timestamp
// // // // // // // // // //   CampaignOutlined, // New icon for notification items
// // // // // // // // // // } from "@mui/icons-material";
// // // // // // // // // // import { useAuth } from "../../context/AuthContext";
// // // // // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // // // // import { useChatBot } from "../../context/ChatBotContext";
// // // // // // // // // // import Sidebar from "./Sidebar";
// // // // // // // // // // import ChatBot from "../common/ChatBot";
// // // // // // // // // // import { useThemeToggle } from "./Theme";

// // // // // // // // // // const Layout = ({ children, title }) => {
// // // // // // // // // //   const { user, logout, notifications } = useAuth();
// // // // // // // // // //   const { setIsOpen } = useChatBot();
// // // // // // // // // //   const navigate = useNavigate();
// // // // // // // // // //   const theme = useTheme();
// // // // // // // // // //   const { toggleColorMode } = useThemeToggle();
// // // // // // // // // //   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

// // // // // // // // // //   const [isDesktopOpen, setDesktopOpen] = useState(() => {
// // // // // // // // // //     const savedState = sessionStorage.getItem("sidebarOpenState");
// // // // // // // // // //     return savedState !== null ? JSON.parse(savedState) : true;
// // // // // // // // // //   });

// // // // // // // // // //   const [isMobileOpen, setMobileOpen] = useState(false);
// // // // // // // // // //   const [anchorEl, setAnchorEl] = useState(null);
// // // // // // // // // //   const [isNotificationDrawerOpen, setNotificationDrawerOpen] = useState(false);

// // // // // // // // // //   useEffect(() => {
// // // // // // // // // //     if (!isMobile) {
// // // // // // // // // //       sessionStorage.setItem("sidebarOpenState", JSON.stringify(isDesktopOpen));
// // // // // // // // // //     }
// // // // // // // // // //   }, [isDesktopOpen, isMobile]);

// // // // // // // // // //   const handleDesktopToggle = () => setDesktopOpen(!isDesktopOpen);
// // // // // // // // // //   const handleMobileToggle = () => setMobileOpen(!isMobileOpen);
// // // // // // // // // //   const handleMenu = (event) => setAnchorEl(event.currentTarget);
// // // // // // // // // //   const handleNotificationToggle = () =>
// // // // // // // // // //     setNotificationDrawerOpen(!isNotificationDrawerOpen);
// // // // // // // // // //   const handleClose = () => setAnchorEl(null);

// // // // // // // // // //   return (
// // // // // // // // // //     <Box
// // // // // // // // // //       sx={{
// // // // // // // // // //         display: "flex",
// // // // // // // // // //         minHeight: "100vh",
// // // // // // // // // //         overflow: "hidden",
// // // // // // // // // //         bgcolor: "background.default",
// // // // // // // // // //       }}
// // // // // // // // // //     >
// // // // // // // // // //       <AppBar
// // // // // // // // // //         position="fixed"
// // // // // // // // // //         elevation={0}
// // // // // // // // // //         sx={{
// // // // // // // // // //           zIndex: theme.zIndex.drawer + 1,
// // // // // // // // // //           backgroundColor: theme.palette.primary.main,
// // // // // // // // // //           color: theme.palette.primary.contrastText,
// // // // // // // // // //         }}
// // // // // // // // // //       >
// // // // // // // // // //         <Toolbar
// // // // // // // // // //           sx={{
// // // // // // // // // //             px: { xs: 2, sm: 3 },
// // // // // // // // // //             minHeight: { xs: 56, sm: 64 },
// // // // // // // // // //             display: "flex",
// // // // // // // // // //             justifyContent: "space-between",
// // // // // // // // // //             alignItems: "center",
// // // // // // // // // //           }}
// // // // // // // // // //         >
// // // // // // // // // //           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
// // // // // // // // // //             <IconButton
// // // // // // // // // //               color="inherit"
// // // // // // // // // //               onClick={handleMobileToggle}
// // // // // // // // // //               sx={{ display: { md: "none" } }}
// // // // // // // // // //             >
// // // // // // // // // //               <MenuIcon />
// // // // // // // // // //             </IconButton>
// // // // // // // // // //             <Typography
// // // // // // // // // //               variant="h6"
// // // // // // // // // //               sx={{
// // // // // // // // // //                 fontWeight: "bold",
// // // // // // // // // //                 fontSize: { xs: "1.1rem", sm: "1.25rem" },
// // // // // // // // // //                 color: "inherit",
// // // // // // // // // //               }}
// // // // // // // // // //             >
// // // // // // // // // //               {title}
// // // // // // // // // //             </Typography>
// // // // // // // // // //           </Box>
// // // // // // // // // //           <Box
// // // // // // // // // //             sx={{
// // // // // // // // // //               display: "flex",
// // // // // // // // // //               alignItems: "center",
// // // // // // // // // //               gap: { xs: 1, sm: 2 },
// // // // // // // // // //             }}
// // // // // // // // // //           >
// // // // // // // // // //             <Tooltip title="Toggle light/dark theme">
// // // // // // // // // //               <IconButton color="inherit" onClick={toggleColorMode}>
// // // // // // // // // //                 {theme.palette.mode === "dark" ? (
// // // // // // // // // //                   <Brightness7 />
// // // // // // // // // //                 ) : (
// // // // // // // // // //                   <Brightness4 />
// // // // // // // // // //                 )}
// // // // // // // // // //               </IconButton>
// // // // // // // // // //             </Tooltip>
// // // // // // // // // //             <Tooltip title="Notifications">
// // // // // // // // // //               <IconButton color="inherit" onClick={handleNotificationToggle}>
// // // // // // // // // //                 <Badge badgeContent={notifications?.length || 0} color="error">
// // // // // // // // // //                   <NotificationsOutlined />
// // // // // // // // // //                 </Badge>
// // // // // // // // // //               </IconButton>
// // // // // // // // // //             </Tooltip>
// // // // // // // // // //             <Box
// // // // // // // // // //               onClick={handleMenu}
// // // // // // // // // //               sx={{
// // // // // // // // // //                 display: "flex",
// // // // // // // // // //                 alignItems: "center",
// // // // // // // // // //                 gap: 1.5,
// // // // // // // // // //                 cursor: "pointer",
// // // // // // // // // //                 p: 0.5,
// // // // // // // // // //                 borderRadius: "8px",
// // // // // // // // // //                 "&:hover": {
// // // // // // // // // //                   backgroundColor: "rgba(255, 255, 255, 0.1)",
// // // // // // // // // //                 },
// // // // // // // // // //               }}
// // // // // // // // // //             >
// // // // // // // // // //               <Avatar
// // // // // // // // // //                 sx={{ width: 40, height: 40 }}
// // // // // // // // // //                 alt={user?.username || "Not specified"}
// // // // // // // // // //               />
// // // // // // // // // //               <Box
// // // // // // // // // //                 sx={{
// // // // // // // // // //                   display: { xs: "none", md: "flex" },
// // // // // // // // // //                   flexDirection: "column",
// // // // // // // // // //                   alignItems: "flex-start",
// // // // // // // // // //                 }}
// // // // // // // // // //               >
// // // // // // // // // //                 <Typography
// // // // // // // // // //                   sx={{
// // // // // // // // // //                     color: "inherit",
// // // // // // // // // //                     fontWeight: "bold",
// // // // // // // // // //                     lineHeight: 1.2,
// // // // // // // // // //                     fontSize: "0.9rem",
// // // // // // // // // //                   }}
// // // // // // // // // //                 >
// // // // // // // // // //                   {user?.username || "Not specified"}
// // // // // // // // // //                 </Typography>
// // // // // // // // // //                 <Typography
// // // // // // // // // //                   variant="caption"
// // // // // // // // // //                   sx={{
// // // // // // // // // //                     color: "inherit",
// // // // // // // // // //                     opacity: 0.85,
// // // // // // // // // //                     textTransform: "capitalize",
// // // // // // // // // //                   }}
// // // // // // // // // //                 >
// // // // // // // // // //                   {user?.role || "Admin"}
// // // // // // // // // //                 </Typography>
// // // // // // // // // //               </Box>
// // // // // // // // // //             </Box>
// // // // // // // // // //           </Box>
// // // // // // // // // //         </Toolbar>
// // // // // // // // // //       </AppBar>

// // // // // // // // // //       <Sidebar
// // // // // // // // // //         open={isDesktopOpen}
// // // // // // // // // //         onToggle={handleDesktopToggle}
// // // // // // // // // //         mobileOpen={isMobileOpen}
// // // // // // // // // //         onMobileToggle={handleMobileToggle}
// // // // // // // // // //       />

// // // // // // // // // //       <Box
// // // // // // // // // //         component="main"
// // // // // // // // // //         sx={{
// // // // // // // // // //           flexGrow: 1,
// // // // // // // // // //           mt: { xs: "56px", sm: "64px" },
// // // // // // // // // //           overflow: "hidden",
// // // // // // // // // //           boxSizing: "border-box",
// // // // // // // // // //           height: `calc(100vh - ${isMobile ? "56px" : "64px"})`,
// // // // // // // // // //           position: "relative",
// // // // // // // // // //         }}
// // // // // // // // // //       >
// // // // // // // // // //         <Box
// // // // // // // // // //           sx={{
// // // // // // // // // //             height: "100%",
// // // // // // // // // //             overflowY: "auto",
// // // // // // // // // //           }}
// // // // // // // // // //         >
// // // // // // // // // //           {children}
// // // // // // // // // //         </Box>
// // // // // // // // // //       </Box>

// // // // // // // // // //       {/* --- ALTERNATIVE NOTIFICATION DRAWER (TIMELINE/CARD DESIGN) --- */}
// // // // // // // // // //       <Drawer
// // // // // // // // // //         anchor="right"
// // // // // // // // // //         open={isNotificationDrawerOpen}
// // // // // // // // // //         onClose={handleNotificationToggle}
// // // // // // // // // //         sx={{
// // // // // // // // // //           "& .MuiDrawer-paper": {
// // // // // // // // // //             boxSizing: "border-box",
// // // // // // // // // //             width: { xs: "90vw", sm: 380 },
// // // // // // // // // //             backgroundColor: "background.default",
// // // // // // // // // //           },
// // // // // // // // // //         }}
// // // // // // // // // //       >
// // // // // // // // // //         <Box
// // // // // // // // // //           sx={{
// // // // // // // // // //             display: "flex",
// // // // // // // // // //             flexDirection: "column",
// // // // // // // // // //             height: "100%",
// // // // // // // // // //           }}
// // // // // // // // // //         >
// // // // // // // // // //           {/* Header */}
// // // // // // // // // //           <Box
// // // // // // // // // //             sx={{
// // // // // // // // // //               p: 2,
// // // // // // // // // //               display: "flex",
// // // // // // // // // //               justifyContent: "space-between",
// // // // // // // // // //               alignItems: "center",
// // // // // // // // // //             }}
// // // // // // // // // //           >
// // // // // // // // // //             <Typography variant="h6" fontWeight={700}>
// // // // // // // // // //               Notifications
// // // // // // // // // //             </Typography>
// // // // // // // // // //             <IconButton onClick={handleNotificationToggle}>
// // // // // // // // // //               <Close />
// // // // // // // // // //             </IconButton>
// // // // // // // // // //           </Box>
// // // // // // // // // //           <Divider />

// // // // // // // // // //           {/* Content */}
// // // // // // // // // //           {notifications && notifications.length > 0 ? (
// // // // // // // // // //             <Box sx={{ flexGrow: 1, overflowY: "auto", p: 2 }}>
// // // // // // // // // //               <Stack spacing={2}>
// // // // // // // // // //                 {notifications.map((n, index) => (
// // // // // // // // // //                   <Paper
// // // // // // // // // //                     key={n.id}
// // // // // // // // // //                     elevation={0}
// // // // // // // // // //                     variant="outlined"
// // // // // // // // // //                     sx={{
// // // // // // // // // //                       p: 2,
// // // // // // // // // //                       display: "flex",
// // // // // // // // // //                       gap: 2,
// // // // // // // // // //                       borderRadius: 2,
// // // // // // // // // //                       borderColor: "divider",
// // // // // // // // // //                       overflow: "hidden",
// // // // // // // // // //                       position: "relative",
// // // // // // // // // //                       // Timeline accent line
// // // // // // // // // //                       "&:before": {
// // // // // // // // // //                         content: '""',
// // // // // // // // // //                         position: "absolute",
// // // // // // // // // //                         left: 0,
// // // // // // // // // //                         top: 0,
// // // // // // // // // //                         bottom: 0,
// // // // // // // // // //                         width: "4px",
// // // // // // // // // //                         backgroundColor: "primary.main",
// // // // // // // // // //                       },
// // // // // // // // // //                     }}
// // // // // // // // // //                   >
// // // // // // // // // //                     <Box
// // // // // // // // // //                       sx={{
// // // // // // // // // //                         color: "primary.main",
// // // // // // // // // //                         mt: "2px",
// // // // // // // // // //                       }}
// // // // // // // // // //                     >
// // // // // // // // // //                       <CampaignOutlined />
// // // // // // // // // //                     </Box>
// // // // // // // // // //                     <Box>
// // // // // // // // // //                       <Typography
// // // // // // // // // //                         variant="subtitle2"
// // // // // // // // // //                         fontWeight={600}
// // // // // // // // // //                         gutterBottom
// // // // // // // // // //                       >
// // // // // // // // // //                         {n.title}
// // // // // // // // // //                       </Typography>
// // // // // // // // // //                       <Typography
// // // // // // // // // //                         variant="body2"
// // // // // // // // // //                         color="text.secondary"
// // // // // // // // // //                         sx={{ mb: 1.5 }}
// // // // // // // // // //                       >
// // // // // // // // // //                         {n.message}
// // // // // // // // // //                       </Typography>
// // // // // // // // // //                       <Box
// // // // // // // // // //                         sx={{
// // // // // // // // // //                           display: "flex",
// // // // // // // // // //                           alignItems: "center",
// // // // // // // // // //                           color: "text.disabled",
// // // // // // // // // //                         }}
// // // // // // // // // //                       >
// // // // // // // // // //                         <AccessTime sx={{ fontSize: "1rem", mr: 0.5 }} />
// // // // // // // // // //                         <Typography variant="caption">
// // // // // // // // // //                           {/* Placeholder timestamp */}
// // // // // // // // // //                           {index * 5 + 2} minutes ago
// // // // // // // // // //                         </Typography>
// // // // // // // // // //                       </Box>
// // // // // // // // // //                     </Box>
// // // // // // // // // //                   </Paper>
// // // // // // // // // //                 ))}
// // // // // // // // // //               </Stack>
// // // // // // // // // //             </Box>
// // // // // // // // // //           ) : (
// // // // // // // // // //             <Box
// // // // // // // // // //               sx={{
// // // // // // // // // //                 flexGrow: 1,
// // // // // // // // // //                 display: "flex",
// // // // // // // // // //                 flexDirection: "column",
// // // // // // // // // //                 alignItems: "center",
// // // // // // // // // //                 justifyContent: "center",
// // // // // // // // // //                 textAlign: "center",
// // // // // // // // // //                 p: 3,
// // // // // // // // // //                 color: "text.secondary",
// // // // // // // // // //               }}
// // // // // // // // // //             >
// // // // // // // // // //               <CheckCircleOutline
// // // // // // // // // //                 sx={{ fontSize: 90, mb: 2, color: "success.main" }}
// // // // // // // // // //               />
// // // // // // // // // //               <Typography variant="h6" gutterBottom>
// // // // // // // // // //                 No New Updates
// // // // // // // // // //               </Typography>
// // // // // // // // // //               <Typography variant="body2">
// // // // // // // // // //                 Your notification inbox is clear.
// // // // // // // // // //               </Typography>
// // // // // // // // // //             </Box>
// // // // // // // // // //           )}

// // // // // // // // // //           {/* Footer */}
// // // // // // // // // //           {notifications && notifications.length > 0 && (
// // // // // // // // // //             <Box
// // // // // // // // // //               sx={{
// // // // // // // // // //                 p: 2,
// // // // // // // // // //                 borderTop: `1px solid ${theme.palette.divider}`,
// // // // // // // // // //               }}
// // // // // // // // // //             >
// // // // // // // // // //               <Button
// // // // // // // // // //                 fullWidth
// // // // // // // // // //                 variant="outlined"
// // // // // // // // // //                 color="secondary"
// // // // // // // // // //                 startIcon={<DeleteSweepOutlined />}
// // // // // // // // // //               >
// // // // // // // // // //                 Clear All Notifications
// // // // // // // // // //               </Button>
// // // // // // // // // //             </Box>
// // // // // // // // // //           )}
// // // // // // // // // //         </Box>
// // // // // // // // // //       </Drawer>

// // // // // // // // // //       {/* --- Menu (no changes) --- */}
// // // // // // // // // //       <Menu
// // // // // // // // // //         anchorEl={anchorEl}
// // // // // // // // // //         open={Boolean(anchorEl)}
// // // // // // // // // //         onClose={handleClose}
// // // // // // // // // //         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
// // // // // // // // // //         transformOrigin={{ vertical: "top", horizontal: "right" }}
// // // // // // // // // //         slotProps={{
// // // // // // // // // //           paper: {
// // // // // // // // // //             elevation: 0,
// // // // // // // // // //             sx: {
// // // // // // // // // //               overflow: "visible",
// // // // // // // // // //               width: 250,
// // // // // // // // // //               mt: 1.5,
// // // // // // // // // //               backgroundColor: "primary.main",
// // // // // // // // // //               color: "primary.contrastText",
// // // // // // // // // //               borderRadius: "10px",
// // // // // // // // // //               boxShadow: "0px 4px 20px rgba(0,0,0,0.4)",
// // // // // // // // // //               "& .MuiList-root": {
// // // // // // // // // //                 padding: "0px",
// // // // // // // // // //               },
// // // // // // // // // //               "& .MuiMenuItem-root": {
// // // // // // // // // //                 padding: "12px 16px",
// // // // // // // // // //               },
// // // // // // // // // //             },
// // // // // // // // // //           },
// // // // // // // // // //         }}
// // // // // // // // // //       >
// // // // // // // // // //         <Box sx={{ p: 2, pt: 1.5 }}>
// // // // // // // // // //           <Typography variant="subtitle1" fontWeight={600} color="inherit">
// // // // // // // // // //             {user?.username}
// // // // // // // // // //           </Typography>
// // // // // // // // // //           <Typography
// // // // // // // // // //             variant="caption"
// // // // // // // // // //             sx={{ textTransform: "capitalize", color: "inherit", opacity: 0.9 }}
// // // // // // // // // //           >
// // // // // // // // // //             Role: {user?.role}
// // // // // // // // // //           </Typography>
// // // // // // // // // //           <Divider sx={{ my: 1.5, borderColor: "rgba(255, 255, 255, 0.2)" }} />
// // // // // // // // // //           <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
// // // // // // // // // //             <EmailOutlined
// // // // // // // // // //               fontSize="small"
// // // // // // // // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // // // // // // // //             />
// // // // // // // // // //             <Typography
// // // // // // // // // //               variant="body2"
// // // // // // // // // //               sx={{ wordBreak: "break-all", color: "inherit" }}
// // // // // // // // // //             >
// // // // // // // // // //               {user?.email}
// // // // // // // // // //             </Typography>
// // // // // // // // // //           </Box>
// // // // // // // // // //           <Box sx={{ display: "flex", alignItems: "center" }}>
// // // // // // // // // //             <PhoneOutlined
// // // // // // // // // //               fontSize="small"
// // // // // // // // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // // // // // // // //             />
// // // // // // // // // //             <Typography variant="body2" color="inherit">
// // // // // // // // // //               {user?.phone_number}
// // // // // // // // // //             </Typography>
// // // // // // // // // //           </Box>
// // // // // // // // // //         </Box>
// // // // // // // // // //       </Menu>

// // // // // // // // // //       <ChatBot />
// // // // // // // // // //     </Box>
// // // // // // // // // //   );
// // // // // // // // // // };

// // // // // // // // // // export default Layout;
// // // // // // // // // import { useState, useEffect } from "react";
// // // // // // // // // import {
// // // // // // // // //   AppBar,
// // // // // // // // //   Toolbar,
// // // // // // // // //   Typography,
// // // // // // // // //   Box,
// // // // // // // // //   IconButton,
// // // // // // // // //   Menu,
// // // // // // // // //   MenuItem,
// // // // // // // // //   Badge,
// // // // // // // // //   Avatar,
// // // // // // // // //   useTheme,
// // // // // // // // //   useMediaQuery,
// // // // // // // // //   Tooltip,
// // // // // // // // //   Divider,
// // // // // // // // //   Drawer,
// // // // // // // // //   List,
// // // // // // // // //   ListItem,
// // // // // // // // //   ListItemText,
// // // // // // // // //   ListItemIcon,
// // // // // // // // //   ListSubheader, // Import for grouping
// // // // // // // // //   Tabs, // Import for filtering
// // // // // // // // //   Tab, // Import for filtering
// // // // // // // // // } from "@mui/material";
// // // // // // // // // import {
// // // // // // // // //   NotificationsOutlined,
// // // // // // // // //   Menu as MenuIcon,
// // // // // // // // //   Brightness4,
// // // // // // // // //   Brightness7,
// // // // // // // // //   EmailOutlined,
// // // // // // // // //   PhoneOutlined,
// // // // // // // // //   Close,
// // // // // // // // //   MoreVert, // Icon for inline actions
// // // // // // // // //   ArrowForward, // Icon for footer link
// // // // // // // // //   DynamicFeed, // Icon for empty state
// // // // // // // // //   PersonPin, // Example icon for user notifications
// // // // // // // // //   Settings, // Example icon for system notifications
// // // // // // // // // } from "@mui/icons-material";
// // // // // // // // // import { useAuth } from "../../context/AuthContext";
// // // // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // // // import { useChatBot } from "../../context/ChatBotContext";
// // // // // // // // // import Sidebar from "./Sidebar";
// // // // // // // // // import ChatBot from "../common/ChatBot";
// // // // // // // // // import { useThemeToggle } from "./Theme";

// // // // // // // // // const Layout = ({ children, title }) => {
// // // // // // // // //   const { user, logout, notifications } = useAuth();
// // // // // // // // //   const { setIsOpen } = useChatBot();
// // // // // // // // //   const navigate = useNavigate();
// // // // // // // // //   const theme = useTheme();
// // // // // // // // //   const { toggleColorMode } = useThemeToggle();
// // // // // // // // //   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

// // // // // // // // //   const [isDesktopOpen, setDesktopOpen] = useState(() => {
// // // // // // // // //     const savedState = sessionStorage.getItem("sidebarOpenState");
// // // // // // // // //     return savedState !== null ? JSON.parse(savedState) : true;
// // // // // // // // //   });

// // // // // // // // //   const [isMobileOpen, setMobileOpen] = useState(false);
// // // // // // // // //   const [anchorEl, setAnchorEl] = useState(null);
// // // // // // // // //   const [isNotificationDrawerOpen, setNotificationDrawerOpen] = useState(false);
// // // // // // // // //   const [tabValue, setTabValue] = useState(0); // State for tabs

// // // // // // // // //   useEffect(() => {
// // // // // // // // //     if (!isMobile) {
// // // // // // // // //       sessionStorage.setItem("sidebarOpenState", JSON.stringify(isDesktopOpen));
// // // // // // // // //     }
// // // // // // // // //   }, [isDesktopOpen, isMobile]);

// // // // // // // // //   const handleDesktopToggle = () => setDesktopOpen(!isDesktopOpen);
// // // // // // // // //   const handleMobileToggle = () => setMobileOpen(!isMobileOpen);
// // // // // // // // //   const handleMenu = (event) => setAnchorEl(event.currentTarget);
// // // // // // // // //   const handleNotificationToggle = () =>
// // // // // // // // //     setNotificationDrawerOpen(!isNotificationDrawerOpen);
// // // // // // // // //   const handleClose = () => setAnchorEl(null);
// // // // // // // // //   const handleTabChange = (event, newValue) => setTabValue(newValue);

// // // // // // // // //   // Example: Split notifications into "New" and "Earlier" for demo
// // // // // // // // //   const newNotifications = notifications ? notifications.slice(0, 2) : [];
// // // // // // // // //   const earlierNotifications = notifications ? notifications.slice(2) : [];

// // // // // // // // //   return (
// // // // // // // // //     <Box
// // // // // // // // //       sx={{
// // // // // // // // //         display: "flex",
// // // // // // // // //         minHeight: "100vh",
// // // // // // // // //         overflow: "hidden",
// // // // // // // // //         bgcolor: "background.default",
// // // // // // // // //       }}
// // // // // // // // //     >
// // // // // // // // //       <AppBar
// // // // // // // // //         position="fixed"
// // // // // // // // //         elevation={0}
// // // // // // // // //         sx={{
// // // // // // // // //           zIndex: theme.zIndex.drawer + 1,
// // // // // // // // //           backgroundColor: theme.palette.primary.main,
// // // // // // // // //           color: theme.palette.primary.contrastText,
// // // // // // // // //         }}
// // // // // // // // //       >
// // // // // // // // //         <Toolbar
// // // // // // // // //           sx={{
// // // // // // // // //             px: { xs: 2, sm: 3 },
// // // // // // // // //             minHeight: { xs: 56, sm: 64 },
// // // // // // // // //             display: "flex",
// // // // // // // // //             justifyContent: "space-between",
// // // // // // // // //             alignItems: "center",
// // // // // // // // //           }}
// // // // // // // // //         >
// // // // // // // // //           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
// // // // // // // // //             <IconButton
// // // // // // // // //               color="inherit"
// // // // // // // // //               onClick={handleMobileToggle}
// // // // // // // // //               sx={{ display: { md: "none" } }}
// // // // // // // // //             >
// // // // // // // // //               <MenuIcon />
// // // // // // // // //             </IconButton>
// // // // // // // // //             <Typography
// // // // // // // // //               variant="h6"
// // // // // // // // //               sx={{
// // // // // // // // //                 fontWeight: "bold",
// // // // // // // // //                 fontSize: { xs: "1.1rem", sm: "1.25rem" },
// // // // // // // // //                 color: "inherit",
// // // // // // // // //               }}
// // // // // // // // //             >
// // // // // // // // //               {title}
// // // // // // // // //             </Typography>
// // // // // // // // //           </Box>
// // // // // // // // //           <Box
// // // // // // // // //             sx={{
// // // // // // // // //               display: "flex",
// // // // // // // // //               alignItems: "center",
// // // // // // // // //               gap: { xs: 1, sm: 2 },
// // // // // // // // //             }}
// // // // // // // // //           >
// // // // // // // // //             <Tooltip title="Toggle light/dark theme">
// // // // // // // // //               <IconButton color="inherit" onClick={toggleColorMode}>
// // // // // // // // //                 {theme.palette.mode === "dark" ? (
// // // // // // // // //                   <Brightness7 />
// // // // // // // // //                 ) : (
// // // // // // // // //                   <Brightness4 />
// // // // // // // // //                 )}
// // // // // // // // //               </IconButton>
// // // // // // // // //             </Tooltip>
// // // // // // // // //             <Tooltip title="Notifications">
// // // // // // // // //               <IconButton color="inherit" onClick={handleNotificationToggle}>
// // // // // // // // //                 <Badge badgeContent={notifications?.length || 0} color="error">
// // // // // // // // //                   <NotificationsOutlined />
// // // // // // // // //                 </Badge>
// // // // // // // // //               </IconButton>
// // // // // // // // //             </Tooltip>
// // // // // // // // //             <Box
// // // // // // // // //               onClick={handleMenu}
// // // // // // // // //               sx={{
// // // // // // // // //                 display: "flex",
// // // // // // // // //                 alignItems: "center",
// // // // // // // // //                 gap: 1.5,
// // // // // // // // //                 cursor: "pointer",
// // // // // // // // //                 p: 0.5,
// // // // // // // // //                 borderRadius: "8px",
// // // // // // // // //                 "&:hover": {
// // // // // // // // //                   backgroundColor: "rgba(255, 255, 255, 0.1)",
// // // // // // // // //                 },
// // // // // // // // //               }}
// // // // // // // // //             >
// // // // // // // // //               <Avatar
// // // // // // // // //                 sx={{ width: 40, height: 40 }}
// // // // // // // // //                 alt={user?.username || "Not specified"}
// // // // // // // // //               />
// // // // // // // // //               <Box
// // // // // // // // //                 sx={{
// // // // // // // // //                   display: { xs: "none", md: "flex" },
// // // // // // // // //                   flexDirection: "column",
// // // // // // // // //                   alignItems: "flex-start",
// // // // // // // // //                 }}
// // // // // // // // //               >
// // // // // // // // //                 <Typography
// // // // // // // // //                   sx={{
// // // // // // // // //                     color: "inherit",
// // // // // // // // //                     fontWeight: "bold",
// // // // // // // // //                     lineHeight: 1.2,
// // // // // // // // //                     fontSize: "0.9rem",
// // // // // // // // //                   }}
// // // // // // // // //                 >
// // // // // // // // //                   {user?.username || "Not specified"}
// // // // // // // // //                 </Typography>
// // // // // // // // //                 <Typography
// // // // // // // // //                   variant="caption"
// // // // // // // // //                   sx={{
// // // // // // // // //                     color: "inherit",
// // // // // // // // //                     opacity: 0.85,
// // // // // // // // //                     textTransform: "capitalize",
// // // // // // // // //                   }}
// // // // // // // // //                 >
// // // // // // // // //                   {user?.role || "Admin"}
// // // // // // // // //                 </Typography>
// // // // // // // // //               </Box>
// // // // // // // // //             </Box>
// // // // // // // // //           </Box>
// // // // // // // // //         </Toolbar>
// // // // // // // // //       </AppBar>

// // // // // // // // //       <Sidebar
// // // // // // // // //         open={isDesktopOpen}
// // // // // // // // //         onToggle={handleDesktopToggle}
// // // // // // // // //         mobileOpen={isMobileOpen}
// // // // // // // // //         onMobileToggle={handleMobileToggle}
// // // // // // // // //       />

// // // // // // // // //       <Box
// // // // // // // // //         component="main"
// // // // // // // // //         sx={{
// // // // // // // // //           flexGrow: 1,
// // // // // // // // //           mt: { xs: "56px", sm: "64px" },
// // // // // // // // //           overflow: "hidden",
// // // // // // // // //           boxSizing: "border-box",
// // // // // // // // //           height: `calc(100vh - ${isMobile ? "56px" : "64px"})`,
// // // // // // // // //           position: "relative",
// // // // // // // // //         }}
// // // // // // // // //       >
// // // // // // // // //         <Box sx={{ height: "100%", overflowY: "auto" }}>{children}</Box>
// // // // // // // // //       </Box>

// // // // // // // // //       {/* --- ALTERNATIVE NOTIFICATION DRAWER (GROUPED PANEL) --- */}
// // // // // // // // //       <Drawer
// // // // // // // // //         anchor="right"
// // // // // // // // //         open={isNotificationDrawerOpen}
// // // // // // // // //         onClose={handleNotificationToggle}
// // // // // // // // //         sx={{
// // // // // // // // //           "& .MuiDrawer-paper": {
// // // // // // // // //             boxSizing: "border-box",
// // // // // // // // //             width: { xs: "90vw", sm: 380 },
// // // // // // // // //             display: "flex",
// // // // // // // // //             flexDirection: "column",
// // // // // // // // //           },
// // // // // // // // //         }}
// // // // // // // // //       >
// // // // // // // // //         <Box
// // // // // // // // //           sx={{
// // // // // // // // //             p: 2,
// // // // // // // // //             pb: 0,
// // // // // // // // //             display: "flex",
// // // // // // // // //             justifyContent: "space-between",
// // // // // // // // //             alignItems: "center",
// // // // // // // // //           }}
// // // // // // // // //         >
// // // // // // // // //           <Typography variant="h6" fontWeight={700}>
// // // // // // // // //             Notifications
// // // // // // // // //           </Typography>
// // // // // // // // //           <IconButton onClick={handleNotificationToggle}>
// // // // // // // // //             <Close />
// // // // // // // // //           </IconButton>
// // // // // // // // //         </Box>

// // // // // // // // //         <Tabs
// // // // // // // // //           value={tabValue}
// // // // // // // // //           onChange={handleTabChange}
// // // // // // // // //           variant="fullWidth"
// // // // // // // // //           sx={{ borderBottom: 1, borderColor: "divider" }}
// // // // // // // // //         >
// // // // // // // // //           <Tab label="All" />
// // // // // // // // //           <Tab label="Unread" />
// // // // // // // // //         </Tabs>

// // // // // // // // //         {notifications && notifications.length > 0 ? (
// // // // // // // // //           <>
// // // // // // // // //             <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
// // // // // // // // //               <List subheader={<li />}>
// // // // // // // // //                 {/* --- NEW Group --- */}
// // // // // // // // //                 {newNotifications.length > 0 && (
// // // // // // // // //                   <ListSubheader sx={{ bgcolor: "background.paper" }}>
// // // // // // // // //                     New
// // // // // // // // //                   </ListSubheader>
// // // // // // // // //                 )}
// // // // // // // // //                 {newNotifications.map((n, index) => (
// // // // // // // // //                   <ListItem key={n.id} alignItems="flex-start" sx={{ gap: 2 }}>
// // // // // // // // //                     <ListItemIcon sx={{ mt: 0.5 }}>
// // // // // // // // //                       <Avatar sx={{ bgcolor: "secondary.main" }}>
// // // // // // // // //                         <PersonPin />
// // // // // // // // //                       </Avatar>
// // // // // // // // //                     </ListItemIcon>
// // // // // // // // //                     <ListItemText
// // // // // // // // //                       primary={n.title}
// // // // // // // // //                       secondary={`${n.message.substring(0, 60)}...`}
// // // // // // // // //                       primaryTypographyProps={{ fontWeight: 600 }}
// // // // // // // // //                     />
// // // // // // // // //                     <IconButton size="small" sx={{ mt: 0.5 }}>
// // // // // // // // //                       <MoreVert fontSize="small" />
// // // // // // // // //                     </IconButton>
// // // // // // // // //                   </ListItem>
// // // // // // // // //                 ))}

// // // // // // // // //                 {/* --- EARLIER Group --- */}
// // // // // // // // //                 {earlierNotifications.length > 0 && (
// // // // // // // // //                   <ListSubheader sx={{ bgcolor: "background.paper" }}>
// // // // // // // // //                     Earlier
// // // // // // // // //                   </ListSubheader>
// // // // // // // // //                 )}
// // // // // // // // //                 {earlierNotifications.map((n, index) => (
// // // // // // // // //                   <ListItem key={n.id} alignItems="flex-start" sx={{ gap: 2 }}>
// // // // // // // // //                     <ListItemIcon sx={{ mt: 0.5 }}>
// // // // // // // // //                       <Avatar>
// // // // // // // // //                         <Settings />
// // // // // // // // //                       </Avatar>
// // // // // // // // //                     </ListItemIcon>
// // // // // // // // //                     <ListItemText
// // // // // // // // //                       primary={n.title}
// // // // // // // // //                       secondary={`${n.message.substring(0, 60)}...`}
// // // // // // // // //                     />
// // // // // // // // //                     <IconButton size="small" sx={{ mt: 0.5 }}>
// // // // // // // // //                       <MoreVert fontSize="small" />
// // // // // // // // //                     </IconButton>
// // // // // // // // //                   </ListItem>
// // // // // // // // //                 ))}
// // // // // // // // //               </List>
// // // // // // // // //             </Box>

// // // // // // // // //             <Box
// // // // // // // // //               sx={{
// // // // // // // // //                 p: 2,
// // // // // // // // //                 borderTop: 1,
// // // // // // // // //                 borderColor: "divider",
// // // // // // // // //                 textAlign: "center",
// // // // // // // // //               }}
// // // // // // // // //             >
// // // // // // // // //               <Typography
// // // // // // // // //                 variant="body2"
// // // // // // // // //                 color="primary"
// // // // // // // // //                 onClick={() => navigate("/notifications")}
// // // // // // // // //                 sx={{
// // // // // // // // //                   display: "inline-flex",
// // // // // // // // //                   alignItems: "center",
// // // // // // // // //                   cursor: "pointer",
// // // // // // // // //                   fontWeight: 600,
// // // // // // // // //                   "&:hover": { textDecoration: "underline" },
// // // // // // // // //                 }}
// // // // // // // // //               >
// // // // // // // // //                 View All Notifications{" "}
// // // // // // // // //                 <ArrowForward sx={{ ml: 0.5, fontSize: "1rem" }} />
// // // // // // // // //               </Typography>
// // // // // // // // //             </Box>
// // // // // // // // //           </>
// // // // // // // // //         ) : (
// // // // // // // // //           <Box
// // // // // // // // //             sx={{
// // // // // // // // //               flexGrow: 1,
// // // // // // // // //               display: "flex",
// // // // // // // // //               flexDirection: "column",
// // // // // // // // //               alignItems: "center",
// // // // // // // // //               justifyContent: "center",
// // // // // // // // //               textAlign: "center",
// // // // // // // // //               p: 3,
// // // // // // // // //             }}
// // // // // // // // //           >
// // // // // // // // //             <DynamicFeed sx={{ fontSize: 90, mb: 2, color: "text.disabled" }} />
// // // // // // // // //             <Typography variant="h6" gutterBottom>
// // // // // // // // //               Nothing new to see
// // // // // // // // //             </Typography>
// // // // // // // // //             <Typography variant="body2" color="text.secondary">
// // // // // // // // //               We'll let you know when there are new updates.
// // // // // // // // //             </Typography>
// // // // // // // // //           </Box>
// // // // // // // // //         )}
// // // // // // // // //       </Drawer>

// // // // // // // // //       {/* --- Menu (no changes) --- */}
// // // // // // // // //       <Menu
// // // // // // // // //         anchorEl={anchorEl}
// // // // // // // // //         open={Boolean(anchorEl)}
// // // // // // // // //         onClose={handleClose}
// // // // // // // // //         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
// // // // // // // // //         transformOrigin={{ vertical: "top", horizontal: "right" }}
// // // // // // // // //         slotProps={{
// // // // // // // // //           paper: {
// // // // // // // // //             elevation: 0,
// // // // // // // // //             sx: {
// // // // // // // // //               overflow: "visible",
// // // // // // // // //               width: 250,
// // // // // // // // //               mt: 1.5,
// // // // // // // // //               backgroundColor: "primary.main",
// // // // // // // // //               color: "primary.contrastText",
// // // // // // // // //               borderRadius: "10px",
// // // // // // // // //               boxShadow: "0px 4px 20px rgba(0,0,0,0.4)",
// // // // // // // // //               "& .MuiList-root": { padding: "0px" },
// // // // // // // // //               "& .MuiMenuItem-root": { padding: "12px 16px" },
// // // // // // // // //             },
// // // // // // // // //           },
// // // // // // // // //         }}
// // // // // // // // //       >
// // // // // // // // //         <Box sx={{ p: 2, pt: 1.5 }}>
// // // // // // // // //           <Typography variant="subtitle1" fontWeight={600} color="inherit">
// // // // // // // // //             {user?.username}
// // // // // // // // //           </Typography>
// // // // // // // // //           <Typography
// // // // // // // // //             variant="caption"
// // // // // // // // //             sx={{ textTransform: "capitalize", color: "inherit", opacity: 0.9 }}
// // // // // // // // //           >
// // // // // // // // //             Role: {user?.role}
// // // // // // // // //           </Typography>
// // // // // // // // //           <Divider sx={{ my: 1.5, borderColor: "rgba(255, 255, 255, 0.2)" }} />
// // // // // // // // //           <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
// // // // // // // // //             <EmailOutlined
// // // // // // // // //               fontSize="small"
// // // // // // // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // // // // // // //             />
// // // // // // // // //             <Typography
// // // // // // // // //               variant="body2"
// // // // // // // // //               sx={{ wordBreak: "break-all", color: "inherit" }}
// // // // // // // // //             >
// // // // // // // // //               {user?.email}
// // // // // // // // //             </Typography>
// // // // // // // // //           </Box>
// // // // // // // // //           <Box sx={{ display: "flex", alignItems: "center" }}>
// // // // // // // // //             <PhoneOutlined
// // // // // // // // //               fontSize="small"
// // // // // // // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // // // // // // //             />
// // // // // // // // //             <Typography variant="body2" color="inherit">
// // // // // // // // //               {user?.phone_number}
// // // // // // // // //             </Typography>
// // // // // // // // //           </Box>
// // // // // // // // //         </Box>
// // // // // // // // //       </Menu>

// // // // // // // // //       <ChatBot />
// // // // // // // // //     </Box>
// // // // // // // // //   );
// // // // // // // // // };

// // // // // // // // // export default Layout;
// // // // // // // // import { useState, useEffect } from "react";
// // // // // // // // import {
// // // // // // // //   AppBar,
// // // // // // // //   Toolbar,
// // // // // // // //   Typography,
// // // // // // // //   Box,
// // // // // // // //   IconButton,
// // // // // // // //   Menu,
// // // // // // // //   MenuItem,
// // // // // // // //   Badge,
// // // // // // // //   Avatar,
// // // // // // // //   useTheme,
// // // // // // // //   useMediaQuery,
// // // // // // // //   Tooltip,
// // // // // // // //   Divider,
// // // // // // // //   List,
// // // // // // // //   ListItem,
// // // // // // // //   ListItemText,
// // // // // // // //   ListItemIcon,
// // // // // // // //   Button,
// // // // // // // // } from "@mui/material";
// // // // // // // // // NOTE: Drawer import is no longer needed for notifications
// // // // // // // // import {
// // // // // // // //   NotificationsOutlined,
// // // // // // // //   Menu as MenuIcon,
// // // // // // // //   Brightness4,
// // // // // // // //   Brightness7,
// // // // // // // //   EmailOutlined,
// // // // // // // //   PhoneOutlined,
// // // // // // // //   Close,
// // // // // // // //   TaskAlt, // New icon for empty state
// // // // // // // //   DoneAll, // New icon for 'mark all as read'
// // // // // // // //   Comment, // Example notification icon
// // // // // // // // } from "@mui/icons-material";
// // // // // // // // import { useAuth } from "../../context/AuthContext";
// // // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // // import { useChatBot } from "../../context/ChatBotContext";
// // // // // // // // import Sidebar from "./Sidebar";
// // // // // // // // import ChatBot from "../common/ChatBot";
// // // // // // // // import { useThemeToggle } from "./Theme";

// // // // // // // // const Layout = ({ children, title }) => {
// // // // // // // //   const { user, logout, notifications } = useAuth();
// // // // // // // //   const { setIsOpen } = useChatBot();
// // // // // // // //   const navigate = useNavigate();
// // // // // // // //   const theme = useTheme();
// // // // // // // //   const { toggleColorMode } = useThemeToggle();
// // // // // // // //   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

// // // // // // // //   const [isDesktopOpen, setDesktopOpen] = useState(() => {
// // // // // // // //     const savedState = sessionStorage.getItem("sidebarOpenState");
// // // // // // // //     return savedState !== null ? JSON.parse(savedState) : true;
// // // // // // // //   });

// // // // // // // //   const [isMobileOpen, setMobileOpen] = useState(false);
// // // // // // // //   const [anchorEl, setAnchorEl] = useState(null);

// // // // // // // //   // --- STATE FOR NOTIFICATION POPOVER ---
// // // // // // // //   const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);

// // // // // // // //   useEffect(() => {
// // // // // // // //     if (!isMobile) {
// // // // // // // //       sessionStorage.setItem("sidebarOpenState", JSON.stringify(isDesktopOpen));
// // // // // // // //     }
// // // // // // // //   }, [isDesktopOpen, isMobile]);

// // // // // // // //   const handleDesktopToggle = () => setDesktopOpen(!isDesktopOpen);
// // // // // // // //   const handleMobileToggle = () => setMobileOpen(!isMobileOpen);
// // // // // // // //   const handleMenu = (event) => setAnchorEl(event.currentTarget);
// // // // // // // //   const handleClose = () => setAnchorEl(null);

// // // // // // // //   // --- HANDLERS FOR NOTIFICATION POPOVER ---
// // // // // // // //   const handleNotificationMenuOpen = (event) => {
// // // // // // // //     setNotificationAnchorEl(event.currentTarget);
// // // // // // // //   };
// // // // // // // //   const handleNotificationMenuClose = () => {
// // // // // // // //     setNotificationAnchorEl(null);
// // // // // // // //   };

// // // // // // // //   const isNotificationMenuOpen = Boolean(notificationAnchorEl);

// // // // // // // //   return (
// // // // // // // //     <Box
// // // // // // // //       sx={{
// // // // // // // //         display: "flex",
// // // // // // // //         minHeight: "100vh",
// // // // // // // //         overflow: "hidden",
// // // // // // // //         bgcolor: "background.default",
// // // // // // // //       }}
// // // // // // // //     >
// // // // // // // //       <AppBar
// // // // // // // //         position="fixed"
// // // // // // // //         elevation={0}
// // // // // // // //         sx={{
// // // // // // // //           zIndex: theme.zIndex.drawer + 1,
// // // // // // // //           backgroundColor: theme.palette.primary.main,
// // // // // // // //           color: theme.palette.primary.contrastText,
// // // // // // // //         }}
// // // // // // // //       >
// // // // // // // //         <Toolbar
// // // // // // // //           sx={{
// // // // // // // //             px: { xs: 2, sm: 3 },
// // // // // // // //             minHeight: { xs: 56, sm: 64 },
// // // // // // // //             display: "flex",
// // // // // // // //             justifyContent: "space-between",
// // // // // // // //             alignItems: "center",
// // // // // // // //           }}
// // // // // // // //         >
// // // // // // // //           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
// // // // // // // //             <IconButton
// // // // // // // //               color="inherit"
// // // // // // // //               onClick={handleMobileToggle}
// // // // // // // //               sx={{ display: { md: "none" } }}
// // // // // // // //             >
// // // // // // // //               <MenuIcon />
// // // // // // // //             </IconButton>
// // // // // // // //             <Typography
// // // // // // // //               variant="h6"
// // // // // // // //               sx={{
// // // // // // // //                 fontWeight: "bold",
// // // // // // // //                 fontSize: { xs: "1.1rem", sm: "1.25rem" },
// // // // // // // //                 color: "inherit",
// // // // // // // //               }}
// // // // // // // //             >
// // // // // // // //               {title}
// // // // // // // //             </Typography>
// // // // // // // //           </Box>
// // // // // // // //           <Box
// // // // // // // //             sx={{
// // // // // // // //               display: "flex",
// // // // // // // //               alignItems: "center",
// // // // // // // //               gap: { xs: 1, sm: 2 },
// // // // // // // //             }}
// // // // // // // //           >
// // // // // // // //             <Tooltip title="Toggle light/dark theme">
// // // // // // // //               <IconButton color="inherit" onClick={toggleColorMode}>
// // // // // // // //                 {theme.palette.mode === "dark" ? (
// // // // // // // //                   <Brightness7 />
// // // // // // // //                 ) : (
// // // // // // // //                   <Brightness4 />
// // // // // // // //                 )}
// // // // // // // //               </IconButton>
// // // // // // // //             </Tooltip>
// // // // // // // //             <Tooltip title="Notifications">
// // // // // // // //               {/* --- UPDATED ONCLICK HANDLER --- */}
// // // // // // // //               <IconButton color="inherit" onClick={handleNotificationMenuOpen}>
// // // // // // // //                 <Badge badgeContent={notifications?.length || 0} color="error">
// // // // // // // //                   <NotificationsOutlined />
// // // // // // // //                 </Badge>
// // // // // // // //               </IconButton>
// // // // // // // //             </Tooltip>
// // // // // // // //             <Box
// // // // // // // //               onClick={handleMenu}
// // // // // // // //               sx={{
// // // // // // // //                 display: "flex",
// // // // // // // //                 alignItems: "center",
// // // // // // // //                 gap: 1.5,
// // // // // // // //                 cursor: "pointer",
// // // // // // // //                 p: 0.5,
// // // // // // // //                 borderRadius: "8px",
// // // // // // // //                 "&:hover": {
// // // // // // // //                   backgroundColor: "rgba(255, 255, 255, 0.1)",
// // // // // // // //                 },
// // // // // // // //               }}
// // // // // // // //             >
// // // // // // // //               <Avatar
// // // // // // // //                 sx={{ width: 40, height: 40 }}
// // // // // // // //                 alt={user?.username || "Not specified"}
// // // // // // // //               />
// // // // // // // //               <Box
// // // // // // // //                 sx={{
// // // // // // // //                   display: { xs: "none", md: "flex" },
// // // // // // // //                   flexDirection: "column",
// // // // // // // //                   alignItems: "flex-start",
// // // // // // // //                 }}
// // // // // // // //               >
// // // // // // // //                 <Typography
// // // // // // // //                   sx={{
// // // // // // // //                     color: "inherit",
// // // // // // // //                     fontWeight: "bold",
// // // // // // // //                     lineHeight: 1.2,
// // // // // // // //                     fontSize: "0.9rem",
// // // // // // // //                   }}
// // // // // // // //                 >
// // // // // // // //                   {user?.username || "Not specified"}
// // // // // // // //                 </Typography>
// // // // // // // //                 <Typography
// // // // // // // //                   variant="caption"
// // // // // // // //                   sx={{
// // // // // // // //                     color: "inherit",
// // // // // // // //                     opacity: 0.85,
// // // // // // // //                     textTransform: "capitalize",
// // // // // // // //                   }}
// // // // // // // //                 >
// // // // // // // //                   {user?.role || "Admin"}
// // // // // // // //                 </Typography>
// // // // // // // //               </Box>
// // // // // // // //             </Box>
// // // // // // // //           </Box>
// // // // // // // //         </Toolbar>
// // // // // // // //       </AppBar>

// // // // // // // //       <Sidebar
// // // // // // // //         open={isDesktopOpen}
// // // // // // // //         onToggle={handleDesktopToggle}
// // // // // // // //         mobileOpen={isMobileOpen}
// // // // // // // //         onMobileToggle={handleMobileToggle}
// // // // // // // //       />

// // // // // // // //       <Box
// // // // // // // //         component="main"
// // // // // // // //         sx={{
// // // // // // // //           flexGrow: 1,
// // // // // // // //           mt: { xs: "56px", sm: "64px" },
// // // // // // // //           overflow: "hidden",
// // // // // // // //           boxSizing: "border-box",
// // // // // // // //           height: `calc(100vh - ${isMobile ? "56px" : "64px"})`,
// // // // // // // //           position: "relative",
// // // // // // // //         }}
// // // // // // // //       >
// // // // // // // //         <Box sx={{ height: "100%", overflowY: "auto" }}>{children}</Box>
// // // // // // // //       </Box>

// // // // // // // //       {/* --- ALTERNATIVE NOTIFICATION POPOVER MENU --- */}
// // // // // // // //       <Menu
// // // // // // // //         anchorEl={notificationAnchorEl}
// // // // // // // //         open={isNotificationMenuOpen}
// // // // // // // //         onClose={handleNotificationMenuClose}
// // // // // // // //         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
// // // // // // // //         transformOrigin={{ vertical: "top", horizontal: "right" }}
// // // // // // // //         slotProps={{
// // // // // // // //           paper: {
// // // // // // // //             sx: {
// // // // // // // //               width: 360,
// // // // // // // //               maxWidth: "90vw",
// // // // // // // //               mt: 1.5,
// // // // // // // //               borderRadius: "12px",
// // // // // // // //               boxShadow: theme.shadows[6],
// // // // // // // //               overflow: "hidden",
// // // // // // // //               display: "flex",
// // // // // // // //               flexDirection: "column",
// // // // // // // //             },
// // // // // // // //           },
// // // // // // // //         }}
// // // // // // // //       >
// // // // // // // //         <Box
// // // // // // // //           sx={{
// // // // // // // //             px: 2,
// // // // // // // //             py: 1.5,
// // // // // // // //             display: "flex",
// // // // // // // //             justifyContent: "space-between",
// // // // // // // //             alignItems: "center",
// // // // // // // //           }}
// // // // // // // //         >
// // // // // // // //           <Typography variant="subtitle1" fontWeight={600}>
// // // // // // // //             Notifications
// // // // // // // //           </Typography>
// // // // // // // //           <Button size="small" startIcon={<DoneAll />}>
// // // // // // // //             Mark all as read
// // // // // // // //           </Button>
// // // // // // // //         </Box>
// // // // // // // //         <Divider />

// // // // // // // //         {notifications && notifications.length > 0 ? (
// // // // // // // //           <Box sx={{ overflowY: "auto", maxHeight: 320 }}>
// // // // // // // //             <List sx={{ p: 0 }}>
// // // // // // // //               {notifications.map((n) => (
// // // // // // // //                 <MenuItem
// // // // // // // //                   key={n.id}
// // // // // // // //                   onClick={handleNotificationMenuClose}
// // // // // // // //                   sx={{ p: 2, alignItems: "flex-start" }}
// // // // // // // //                 >
// // // // // // // //                   <ListItemIcon sx={{ mr: 1, mt: 0.5 }}>
// // // // // // // //                     <Avatar
// // // // // // // //                       sx={{
// // // // // // // //                         width: 32,
// // // // // // // //                         height: 32,
// // // // // // // //                         bgcolor: "secondary.light",
// // // // // // // //                         color: "secondary.main",
// // // // // // // //                       }}
// // // // // // // //                     >
// // // // // // // //                       <Comment fontSize="small" />
// // // // // // // //                     </Avatar>
// // // // // // // //                   </ListItemIcon>
// // // // // // // //                   <ListItemText
// // // // // // // //                     primary={n.title}
// // // // // // // //                     secondary={n.message}
// // // // // // // //                     primaryTypographyProps={{
// // // // // // // //                       fontWeight: "bold",
// // // // // // // //                       variant: "body2",
// // // // // // // //                     }}
// // // // // // // //                     secondaryTypographyProps={{
// // // // // // // //                       variant: "caption",
// // // // // // // //                       color: "text.secondary",
// // // // // // // //                       sx: {
// // // // // // // //                         whiteSpace: "nowrap",
// // // // // // // //                         overflow: "hidden",
// // // // // // // //                         textOverflow: "ellipsis",
// // // // // // // //                         display: "block",
// // // // // // // //                       },
// // // // // // // //                     }}
// // // // // // // //                   />
// // // // // // // //                   <Typography
// // // // // // // //                     variant="caption"
// // // // // // // //                     color="text.disabled"
// // // // // // // //                     sx={{ ml: 2 }}
// // // // // // // //                   >
// // // // // // // //                     5m
// // // // // // // //                   </Typography>
// // // // // // // //                 </MenuItem>
// // // // // // // //               ))}
// // // // // // // //             </List>
// // // // // // // //           </Box>
// // // // // // // //         ) : (
// // // // // // // //           <Box sx={{ textAlign: "center", p: 4, color: "text.secondary" }}>
// // // // // // // //             <TaskAlt sx={{ fontSize: 50, mb: 1 }} />
// // // // // // // //             <Typography>You're all caught up</Typography>
// // // // // // // //           </Box>
// // // // // // // //         )}

// // // // // // // //         <Divider />
// // // // // // // //         <Box sx={{ p: 1, textAlign: "center" }}>
// // // // // // // //           <Button
// // // // // // // //             fullWidth
// // // // // // // //             onClick={() => {
// // // // // // // //               handleNotificationMenuClose();
// // // // // // // //               navigate("/notifications");
// // // // // // // //             }}
// // // // // // // //           >
// // // // // // // //             View All Notifications
// // // // // // // //           </Button>
// // // // // // // //         </Box>
// // // // // // // //       </Menu>

// // // // // // // //       {/* --- User Profile Menu (no changes) --- */}
// // // // // // // //       <Menu
// // // // // // // //         anchorEl={anchorEl}
// // // // // // // //         open={Boolean(anchorEl)}
// // // // // // // //         onClose={handleClose}
// // // // // // // //         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
// // // // // // // //         transformOrigin={{ vertical: "top", horizontal: "right" }}
// // // // // // // //         slotProps={{
// // // // // // // //           paper: {
// // // // // // // //             elevation: 0,
// // // // // // // //             sx: {
// // // // // // // //               overflow: "visible",
// // // // // // // //               width: 250,
// // // // // // // //               mt: 1.5,
// // // // // // // //               backgroundColor: "primary.main",
// // // // // // // //               color: "primary.contrastText",
// // // // // // // //               borderRadius: "10px",
// // // // // // // //               boxShadow: "0px 4px 20px rgba(0,0,0,0.4)",
// // // // // // // //               "& .MuiList-root": { padding: "0px" },
// // // // // // // //               "& .MuiMenuItem-root": { padding: "12px 16px" },
// // // // // // // //             },
// // // // // // // //           },
// // // // // // // //         }}
// // // // // // // //       >
// // // // // // // //         <Box sx={{ p: 2, pt: 1.5 }}>
// // // // // // // //           <Typography variant="subtitle1" fontWeight={600} color="inherit">
// // // // // // // //             {user?.username}
// // // // // // // //           </Typography>
// // // // // // // //           <Typography
// // // // // // // //             variant="caption"
// // // // // // // //             sx={{ textTransform: "capitalize", color: "inherit", opacity: 0.9 }}
// // // // // // // //           >
// // // // // // // //             Role: {user?.role}
// // // // // // // //           </Typography>
// // // // // // // //           <Divider sx={{ my: 1.5, borderColor: "rgba(255, 255, 255, 0.2)" }} />
// // // // // // // //           <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
// // // // // // // //             <EmailOutlined
// // // // // // // //               fontSize="small"
// // // // // // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // // // // // //             />
// // // // // // // //             <Typography
// // // // // // // //               variant="body2"
// // // // // // // //               sx={{ wordBreak: "break-all", color: "inherit" }}
// // // // // // // //             >
// // // // // // // //               {user?.email}
// // // // // // // //             </Typography>
// // // // // // // //           </Box>
// // // // // // // //           <Box sx={{ display: "flex", alignItems: "center" }}>
// // // // // // // //             <PhoneOutlined
// // // // // // // //               fontSize="small"
// // // // // // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // // // // // //             />
// // // // // // // //             <Typography variant="body2" color="inherit">
// // // // // // // //               {user?.phone_number}
// // // // // // // //             </Typography>
// // // // // // // //           </Box>
// // // // // // // //         </Box>
// // // // // // // //       </Menu>

// // // // // // // //       <ChatBot />
// // // // // // // //     </Box>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // export default Layout;
// // // // // // // import { useState, useEffect } from "react";
// // // // // // // import {
// // // // // // //   AppBar,
// // // // // // //   Toolbar,
// // // // // // //   Typography,
// // // // // // //   Box,
// // // // // // //   IconButton,
// // // // // // //   Menu,
// // // // // // //   MenuItem,
// // // // // // //   Badge,
// // // // // // //   Avatar,
// // // // // // //   useTheme,
// // // // // // //   useMediaQuery,
// // // // // // //   Tooltip,
// // // // // // //   Divider,
// // // // // // //   Drawer,
// // // // // // //   List,
// // // // // // //   ListItem,
// // // // // // //   ListItemText,
// // // // // // //   ListItemIcon,
// // // // // // //   Chip, // Import Chip for tags
// // // // // // //   ToggleButton, // For segmented control
// // // // // // //   ToggleButtonGroup, // For segmented control
// // // // // // // } from "@mui/material";
// // // // // // // import {
// // // // // // //   NotificationsOutlined,
// // // // // // //   Menu as MenuIcon,
// // // // // // //   Brightness4,
// // // // // // //   Brightness7,
// // // // // // //   EmailOutlined,
// // // // // // //   PhoneOutlined,
// // // // // // //   Close,
// // // // // // //   Settings as SettingsIcon, // For settings link
// // // // // // //   AlternateEmail, // For 'Mentions' category
// // // // // // //   Campaign, // For 'System' category
// // // // // // //   InboxOutlined, // For empty state
// // // // // // // } from "@mui/icons-material";
// // // // // // // import { useAuth } from "../../context/AuthContext";
// // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // import { useChatBot } from "../../context/ChatBotContext";
// // // // // // // import Sidebar from "./Sidebar";
// // // // // // // import ChatBot from "../common/ChatBot";
// // // // // // // import { useThemeToggle } from "./Theme";

// // // // // // // const Layout = ({ children, title }) => {
// // // // // // //   const { user, logout, notifications } = useAuth();
// // // // // // //   const { setIsOpen } = useChatBot();
// // // // // // //   const navigate = useNavigate();
// // // // // // //   const theme = useTheme();
// // // // // // //   const { toggleColorMode } = useThemeToggle();
// // // // // // //   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

// // // // // // //   const [isDesktopOpen, setDesktopOpen] = useState(() => {
// // // // // // //     const savedState = sessionStorage.getItem("sidebarOpenState");
// // // // // // //     return savedState !== null ? JSON.parse(savedState) : true;
// // // // // // //   });

// // // // // // //   const [isMobileOpen, setMobileOpen] = useState(false);
// // // // // // //   const [anchorEl, setAnchorEl] = useState(null);
// // // // // // //   const [isNotificationDrawerOpen, setNotificationDrawerOpen] = useState(false);

// // // // // // //   // --- STATE FOR NOTIFICATION FILTER ---
// // // // // // //   const [notificationFilter, setNotificationFilter] = useState("all");

// // // // // // //   useEffect(() => {
// // // // // // //     if (!isMobile) {
// // // // // // //       sessionStorage.setItem("sidebarOpenState", JSON.stringify(isDesktopOpen));
// // // // // // //     }
// // // // // // //   }, [isDesktopOpen, isMobile]);

// // // // // // //   const handleDesktopToggle = () => setDesktopOpen(!isDesktopOpen);
// // // // // // //   const handleMobileToggle = () => setMobileOpen(!isMobileOpen);
// // // // // // //   const handleMenu = (event) => setAnchorEl(event.currentTarget);
// // // // // // //   const handleNotificationToggle = () =>
// // // // // // //     setNotificationDrawerOpen(!isNotificationDrawerOpen);
// // // // // // //   const handleClose = () => setAnchorEl(null);

// // // // // // //   const handleFilterChange = (event, newFilter) => {
// // // // // // //     if (newFilter !== null) {
// // // // // // //       setNotificationFilter(newFilter);
// // // // // // //     }
// // // // // // //   };

// // // // // // //   // Add a 'type' to notifications for filtering demonstration
// // // // // // //   const demoNotifications =
// // // // // // //     notifications?.map((n, i) => ({
// // // // // // //       ...n,
// // // // // // //       type: i % 2 === 0 ? "system" : "mention",
// // // // // // //       priority: i === 1 ? "urgent" : "normal",
// // // // // // //     })) || [];

// // // // // // //   const filteredNotifications = demoNotifications.filter((n) =>
// // // // // // //     notificationFilter === "all" ? true : n.type === notificationFilter
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <Box
// // // // // // //       sx={{
// // // // // // //         display: "flex",
// // // // // // //         minHeight: "100vh",
// // // // // // //         overflow: "hidden",
// // // // // // //         bgcolor: "background.default",
// // // // // // //       }}
// // // // // // //     >
// // // // // // //       <AppBar
// // // // // // //         position="fixed"
// // // // // // //         elevation={0}
// // // // // // //         sx={{
// // // // // // //           zIndex: theme.zIndex.drawer + 1,
// // // // // // //           backgroundColor: theme.palette.primary.main,
// // // // // // //           color: theme.palette.primary.contrastText,
// // // // // // //         }}
// // // // // // //       >
// // // // // // //         <Toolbar
// // // // // // //           sx={{
// // // // // // //             px: { xs: 2, sm: 3 },
// // // // // // //             minHeight: { xs: 56, sm: 64 },
// // // // // // //             display: "flex",
// // // // // // //             justifyContent: "space-between",
// // // // // // //             alignItems: "center",
// // // // // // //           }}
// // // // // // //         >
// // // // // // //           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
// // // // // // //             <IconButton
// // // // // // //               color="inherit"
// // // // // // //               onClick={handleMobileToggle}
// // // // // // //               sx={{ display: { md: "none" } }}
// // // // // // //             >
// // // // // // //               <MenuIcon />
// // // // // // //             </IconButton>
// // // // // // //             <Typography
// // // // // // //               variant="h6"
// // // // // // //               sx={{
// // // // // // //                 fontWeight: "bold",
// // // // // // //                 fontSize: { xs: "1.1rem", sm: "1.25rem" },
// // // // // // //                 color: "inherit",
// // // // // // //               }}
// // // // // // //             >
// // // // // // //               {title}
// // // // // // //             </Typography>
// // // // // // //           </Box>
// // // // // // //           <Box
// // // // // // //             sx={{
// // // // // // //               display: "flex",
// // // // // // //               alignItems: "center",
// // // // // // //               gap: { xs: 1, sm: 2 },
// // // // // // //             }}
// // // // // // //           >
// // // // // // //             <Tooltip title="Toggle light/dark theme">
// // // // // // //               <IconButton color="inherit" onClick={toggleColorMode}>
// // // // // // //                 {theme.palette.mode === "dark" ? (
// // // // // // //                   <Brightness7 />
// // // // // // //                 ) : (
// // // // // // //                   <Brightness4 />
// // // // // // //                 )}
// // // // // // //               </IconButton>
// // // // // // //             </Tooltip>
// // // // // // //             <Tooltip title="Notifications">
// // // // // // //               <IconButton color="inherit" onClick={handleNotificationToggle}>
// // // // // // //                 <Badge badgeContent={notifications?.length || 0} color="error">
// // // // // // //                   <NotificationsOutlined />
// // // // // // //                 </Badge>
// // // // // // //               </IconButton>
// // // // // // //             </Tooltip>
// // // // // // //             <Box
// // // // // // //               onClick={handleMenu}
// // // // // // //               sx={{
// // // // // // //                 display: "flex",
// // // // // // //                 alignItems: "center",
// // // // // // //                 gap: 1.5,
// // // // // // //                 cursor: "pointer",
// // // // // // //                 p: 0.5,
// // // // // // //                 borderRadius: "8px",
// // // // // // //                 "&:hover": {
// // // // // // //                   backgroundColor: "rgba(255, 255, 255, 0.1)",
// // // // // // //                 },
// // // // // // //               }}
// // // // // // //             >
// // // // // // //               <Avatar
// // // // // // //                 sx={{ width: 40, height: 40 }}
// // // // // // //                 alt={user?.username || "Not specified"}
// // // // // // //               />
// // // // // // //               <Box
// // // // // // //                 sx={{
// // // // // // //                   display: { xs: "none", md: "flex" },
// // // // // // //                   flexDirection: "column",
// // // // // // //                   alignItems: "flex-start",
// // // // // // //                 }}
// // // // // // //               >
// // // // // // //                 <Typography
// // // // // // //                   sx={{
// // // // // // //                     color: "inherit",
// // // // // // //                     fontWeight: "bold",
// // // // // // //                     lineHeight: 1.2,
// // // // // // //                     fontSize: "0.9rem",
// // // // // // //                   }}
// // // // // // //                 >
// // // // // // //                   {user?.username || "Not specified"}
// // // // // // //                 </Typography>
// // // // // // //                 <Typography
// // // // // // //                   variant="caption"
// // // // // // //                   sx={{
// // // // // // //                     color: "inherit",
// // // // // // //                     opacity: 0.85,
// // // // // // //                     textTransform: "capitalize",
// // // // // // //                   }}
// // // // // // //                 >
// // // // // // //                   {user?.role || "Admin"}
// // // // // // //                 </Typography>
// // // // // // //               </Box>
// // // // // // //             </Box>
// // // // // // //           </Box>
// // // // // // //         </Toolbar>
// // // // // // //       </AppBar>

// // // // // // //       <Sidebar
// // // // // // //         open={isDesktopOpen}
// // // // // // //         onToggle={handleDesktopToggle}
// // // // // // //         mobileOpen={isMobileOpen}
// // // // // // //         onMobileToggle={handleMobileToggle}
// // // // // // //       />

// // // // // // //       <Box
// // // // // // //         component="main"
// // // // // // //         sx={{
// // // // // // //           flexGrow: 1,
// // // // // // //           mt: { xs: "56px", sm: "64px" },
// // // // // // //           overflow: "hidden",
// // // // // // //           boxSizing: "border-box",
// // // // // // //           height: `calc(100vh - ${isMobile ? "56px" : "64px"})`,
// // // // // // //           position: "relative",
// // // // // // //         }}
// // // // // // //       >
// // // // // // //         <Box sx={{ height: "100%", overflowY: "auto" }}>{children}</Box>
// // // // // // //       </Box>

// // // // // // //       {/* --- ALTERNATIVE NOTIFICATION DRAWER (SEGMENTED CONTROL) --- */}
// // // // // // //       <Drawer
// // // // // // //         anchor="right"
// // // // // // //         open={isNotificationDrawerOpen}
// // // // // // //         onClose={handleNotificationToggle}
// // // // // // //         sx={{
// // // // // // //           "& .MuiDrawer-paper": {
// // // // // // //             boxSizing: "border-box",
// // // // // // //             width: { xs: "90vw", sm: 400 },
// // // // // // //             display: "flex",
// // // // // // //             flexDirection: "column",
// // // // // // //           },
// // // // // // //         }}
// // // // // // //       >
// // // // // // //         <Box
// // // // // // //           sx={{
// // // // // // //             p: 2,
// // // // // // //             display: "flex",
// // // // // // //             justifyContent: "space-between",
// // // // // // //             alignItems: "center",
// // // // // // //           }}
// // // // // // //         >
// // // // // // //           <Typography variant="h6" fontWeight={700}>
// // // // // // //             Notifications
// // // // // // //           </Typography>
// // // // // // //           <IconButton onClick={handleNotificationToggle}>
// // // // // // //             <Close />
// // // // // // //           </IconButton>
// // // // // // //         </Box>

// // // // // // //         <Box sx={{ px: 2, pb: 2 }}>
// // // // // // //           <ToggleButtonGroup
// // // // // // //             color="primary"
// // // // // // //             value={notificationFilter}
// // // // // // //             exclusive
// // // // // // //             onChange={handleFilterChange}
// // // // // // //             fullWidth
// // // // // // //           >
// // // // // // //             <ToggleButton value="all">All</ToggleButton>
// // // // // // //             <ToggleButton value="mention">Mentions</ToggleButton>
// // // // // // //             <ToggleButton value="system">System</ToggleButton>
// // // // // // //           </ToggleButtonGroup>
// // // // // // //         </Box>

// // // // // // //         <Divider />

// // // // // // //         {filteredNotifications.length > 0 ? (
// // // // // // //           <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
// // // // // // //             <List sx={{ p: 0 }}>
// // // // // // //               {filteredNotifications.map((n) => (
// // // // // // //                 <ListItem
// // // // // // //                   key={n.id}
// // // // // // //                   divider
// // // // // // //                   sx={{ p: 2, alignItems: "flex-start", gap: 2 }}
// // // // // // //                 >
// // // // // // //                   <ListItemIcon sx={{ mt: 0.5 }}>
// // // // // // //                     <Avatar
// // // // // // //                       sx={{
// // // // // // //                         bgcolor:
// // // // // // //                           n.type === "mention"
// // // // // // //                             ? "secondary.light"
// // // // // // //                             : "primary.light",
// // // // // // //                       }}
// // // // // // //                     >
// // // // // // //                       {n.type === "mention" ? (
// // // // // // //                         <AlternateEmail sx={{ color: "secondary.main" }} />
// // // // // // //                       ) : (
// // // // // // //                         <Campaign sx={{ color: "primary.main" }} />
// // // // // // //                       )}
// // // // // // //                     </Avatar>
// // // // // // //                   </ListItemIcon>
// // // // // // //                   <ListItemText
// // // // // // //                     primary={
// // // // // // //                       <Box
// // // // // // //                         sx={{ display: "flex", alignItems: "center", mb: 0.5 }}
// // // // // // //                       >
// // // // // // //                         <Typography
// // // // // // //                           variant="body2"
// // // // // // //                           fontWeight={600}
// // // // // // //                           sx={{ flexGrow: 1 }}
// // // // // // //                         >
// // // // // // //                           {n.title}
// // // // // // //                         </Typography>
// // // // // // //                         {n.priority === "urgent" && (
// // // // // // //                           <Chip label="Urgent" color="error" size="small" />
// // // // // // //                         )}
// // // // // // //                       </Box>
// // // // // // //                     }
// // // // // // //                     secondary={
// // // // // // //                       <Typography variant="caption" color="text.secondary">
// // // // // // //                         {n.message}
// // // // // // //                       </Typography>
// // // // // // //                     }
// // // // // // //                   />
// // // // // // //                 </ListItem>
// // // // // // //               ))}
// // // // // // //             </List>
// // // // // // //           </Box>
// // // // // // //         ) : (
// // // // // // //           <Box
// // // // // // //             sx={{
// // // // // // //               flexGrow: 1,
// // // // // // //               display: "flex",
// // // // // // //               flexDirection: "column",
// // // // // // //               alignItems: "center",
// // // // // // //               justifyContent: "center",
// // // // // // //               textAlign: "center",
// // // // // // //               p: 3,
// // // // // // //               color: "text.secondary",
// // // // // // //             }}
// // // // // // //           >
// // // // // // //             <InboxOutlined sx={{ fontSize: 70, mb: 2 }} />
// // // // // // //             <Typography variant="h6">It's quiet in here</Typography>
// // // // // // //             <Typography variant="body2">
// // // // // // //               {notificationFilter === "mention" && "You have no new mentions."}
// // // // // // //               {notificationFilter === "system" &&
// // // // // // //                 "There are no new system updates."}
// // // // // // //               {notificationFilter === "all" && "Your inbox is clear."}
// // // // // // //             </Typography>
// // // // // // //           </Box>
// // // // // // //         )}

// // // // // // //         <Box
// // // // // // //           sx={{
// // // // // // //             p: 2,
// // // // // // //             borderTop: 1,
// // // // // // //             borderColor: "divider",
// // // // // // //             textAlign: "center",
// // // // // // //           }}
// // // // // // //         >
// // // // // // //           <Typography
// // // // // // //             variant="body2"
// // // // // // //             color="primary"
// // // // // // //             onClick={() => navigate("/settings/notifications")}
// // // // // // //             sx={{
// // // // // // //               display: "inline-flex",
// // // // // // //               alignItems: "center",
// // // // // // //               cursor: "pointer",
// // // // // // //             }}
// // // // // // //           >
// // // // // // //             <SettingsIcon sx={{ mr: 1, fontSize: "1.1rem" }} />
// // // // // // //             Notification Settings
// // // // // // //           </Typography>
// // // // // // //         </Box>
// // // // // // //       </Drawer>

// // // // // // //       {/* --- User Profile Menu (no changes) --- */}
// // // // // // //       <Menu
// // // // // // //         anchorEl={anchorEl}
// // // // // // //         open={Boolean(anchorEl)}
// // // // // // //         onClose={handleClose}
// // // // // // //         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
// // // // // // //         transformOrigin={{ vertical: "top", horizontal: "right" }}
// // // // // // //         slotProps={{
// // // // // // //           paper: {
// // // // // // //             elevation: 0,
// // // // // // //             sx: {
// // // // // // //               overflow: "visible",
// // // // // // //               width: 250,
// // // // // // //               mt: 1.5,
// // // // // // //               backgroundColor: "primary.main",
// // // // // // //               color: "primary.contrastText",
// // // // // // //               borderRadius: "10px",
// // // // // // //               boxShadow: "0px 4px 20px rgba(0,0,0,0.4)",
// // // // // // //               "& .MuiList-root": { padding: "0px" },
// // // // // // //               "& .MuiMenuItem-root": { padding: "12px 16px" },
// // // // // // //             },
// // // // // // //           },
// // // // // // //         }}
// // // // // // //       >
// // // // // // //         <Box sx={{ p: 2, pt: 1.5 }}>
// // // // // // //           <Typography variant="subtitle1" fontWeight={600} color="inherit">
// // // // // // //             {user?.username}
// // // // // // //           </Typography>
// // // // // // //           <Typography
// // // // // // //             variant="caption"
// // // // // // //             sx={{ textTransform: "capitalize", color: "inherit", opacity: 0.9 }}
// // // // // // //           >
// // // // // // //             Role: {user?.role}
// // // // // // //           </Typography>
// // // // // // //           <Divider sx={{ my: 1.5, borderColor: "rgba(255, 255, 255, 0.2)" }} />
// // // // // // //           <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
// // // // // // //             <EmailOutlined
// // // // // // //               fontSize="small"
// // // // // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // // // // //             />
// // // // // // //             <Typography
// // // // // // //               variant="body2"
// // // // // // //               sx={{ wordBreak: "break-all", color: "inherit" }}
// // // // // // //             >
// // // // // // //               {user?.email}
// // // // // // //             </Typography>
// // // // // // //           </Box>
// // // // // // //           <Box sx={{ display: "flex", alignItems: "center" }}>
// // // // // // //             <PhoneOutlined
// // // // // // //               fontSize="small"
// // // // // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // // // // //             />
// // // // // // //             <Typography variant="body2" color="inherit">
// // // // // // //               {user?.phone_number}
// // // // // // //             </Typography>
// // // // // // //           </Box>
// // // // // // //         </Box>
// // // // // // //       </Menu>

// // // // // // //       <ChatBot />
// // // // // // //     </Box>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default Layout;

// // // // // // import { useState, useEffect } from "react";
// // // // // // import {
// // // // // //   AppBar,
// // // // // //   Toolbar,
// // // // // //   Typography,
// // // // // //   Box,
// // // // // //   IconButton,
// // // // // //   Menu,
// // // // // //   MenuItem,
// // // // // //   Badge,
// // // // // //   Avatar,
// // // // // //   useTheme,
// // // // // //   useMediaQuery,
// // // // // //   Tooltip,
// // // // // //   Divider,
// // // // // //   Drawer,
// // // // // //   // New imports for Accordion design
// // // // // //   Accordion,
// // // // // //   AccordionSummary,
// // // // // //   AccordionDetails,
// // // // // // } from "@mui/material";
// // // // // // import {
// // // // // //   NotificationsOutlined,
// // // // // //   Menu as MenuIcon,
// // // // // //   Brightness4,
// // // // // //   Brightness7,
// // // // // //   EmailOutlined,
// // // // // //   PhoneOutlined,
// // // // // //   Close,
// // // // // //   ExpandMore, // Icon for accordion expansion
// // // // // //   NotificationsNone, // Icon for empty state
// // // // // // } from "@mui/icons-material";
// // // // // // import { useAuth } from "../../context/AuthContext";
// // // // // // import { useNavigate } from "react-router-dom";
// // // // // // import { useChatBot } from "../../context/ChatBotContext";
// // // // // // import Sidebar from "./Sidebar";
// // // // // // import ChatBot from "../common/ChatBot";
// // // // // // import { useThemeToggle } from "./Theme";

// // // // // // const Layout = ({ children, title }) => {
// // // // // //   const { user, logout, notifications } = useAuth();
// // // // // //   const { setIsOpen } = useChatBot();
// // // // // //   const navigate = useNavigate();
// // // // // //   const theme = useTheme();
// // // // // //   const { toggleColorMode } = useThemeToggle();
// // // // // //   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

// // // // // //   const [isDesktopOpen, setDesktopOpen] = useState(() => {
// // // // // //     const savedState = sessionStorage.getItem("sidebarOpenState");
// // // // // //     return savedState !== null ? JSON.parse(savedState) : true;
// // // // // //   });

// // // // // //   const [isMobileOpen, setMobileOpen] = useState(false);
// // // // // //   const [anchorEl, setAnchorEl] = useState(null);
// // // // // //   const [isNotificationDrawerOpen, setNotificationDrawerOpen] = useState(false);

// // // // // //   useEffect(() => {
// // // // // //     if (!isMobile) {
// // // // // //       sessionStorage.setItem("sidebarOpenState", JSON.stringify(isDesktopOpen));
// // // // // //     }
// // // // // //   }, [isDesktopOpen, isMobile]);

// // // // // //   const handleDesktopToggle = () => setDesktopOpen(!isDesktopOpen);
// // // // // //   const handleMobileToggle = () => setMobileOpen(!isMobileOpen);
// // // // // //   const handleMenu = (event) => setAnchorEl(event.currentTarget);
// // // // // //   const handleNotificationToggle = () =>
// // // // // //     setNotificationDrawerOpen(!isNotificationDrawerOpen);
// // // // // //   const handleClose = () => setAnchorEl(null);

// // // // // //   return (
// // // // // //     <Box
// // // // // //       sx={{
// // // // // //         display: "flex",
// // // // // //         minHeight: "100vh",
// // // // // //         overflow: "hidden",
// // // // // //         bgcolor: "background.default",
// // // // // //       }}
// // // // // //     >
// // // // // //       <AppBar
// // // // // //         position="fixed"
// // // // // //         elevation={0}
// // // // // //         sx={{
// // // // // //           zIndex: theme.zIndex.drawer + 1,
// // // // // //           backgroundColor: theme.palette.primary.main,
// // // // // //           color: theme.palette.primary.contrastText,
// // // // // //         }}
// // // // // //       >
// // // // // //         <Toolbar
// // // // // //           sx={{
// // // // // //             px: { xs: 2, sm: 3 },
// // // // // //             minHeight: { xs: 56, sm: 64 },
// // // // // //             display: "flex",
// // // // // //             justifyContent: "space-between",
// // // // // //             alignItems: "center",
// // // // // //           }}
// // // // // //         >
// // // // // //           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
// // // // // //             <IconButton
// // // // // //               color="inherit"
// // // // // //               onClick={handleMobileToggle}
// // // // // //               sx={{ display: { md: "none" } }}
// // // // // //             >
// // // // // //               <MenuIcon />
// // // // // //             </IconButton>
// // // // // //             <Typography
// // // // // //               variant="h6"
// // // // // //               sx={{
// // // // // //                 fontWeight: "bold",
// // // // // //                 fontSize: { xs: "1.1rem", sm: "1.25rem" },
// // // // // //                 color: "inherit",
// // // // // //               }}
// // // // // //             >
// // // // // //               {title}
// // // // // //             </Typography>
// // // // // //           </Box>
// // // // // //           <Box
// // // // // //             sx={{
// // // // // //               display: "flex",
// // // // // //               alignItems: "center",
// // // // // //               gap: { xs: 1, sm: 2 },
// // // // // //             }}
// // // // // //           >
// // // // // //             <Tooltip title="Toggle light/dark theme">
// // // // // //               <IconButton color="inherit" onClick={toggleColorMode}>
// // // // // //                 {theme.palette.mode === "dark" ? (
// // // // // //                   <Brightness7 />
// // // // // //                 ) : (
// // // // // //                   <Brightness4 />
// // // // // //                 )}
// // // // // //               </IconButton>
// // // // // //             </Tooltip>
// // // // // //             <Tooltip title="Notifications">
// // // // // //               <IconButton color="inherit" onClick={handleNotificationToggle}>
// // // // // //                 <Badge badgeContent={notifications?.length || 0} color="error">
// // // // // //                   <NotificationsOutlined />
// // // // // //                 </Badge>
// // // // // //               </IconButton>
// // // // // //             </Tooltip>
// // // // // //             <Box
// // // // // //               onClick={handleMenu}
// // // // // //               sx={{
// // // // // //                 display: "flex",
// // // // // //                 alignItems: "center",
// // // // // //                 gap: 1.5,
// // // // // //                 cursor: "pointer",
// // // // // //                 p: 0.5,
// // // // // //                 borderRadius: "8px",
// // // // // //                 "&:hover": {
// // // // // //                   backgroundColor: "rgba(255, 255, 255, 0.1)",
// // // // // //                 },
// // // // // //               }}
// // // // // //             >
// // // // // //               <Avatar
// // // // // //                 sx={{ width: 40, height: 40 }}
// // // // // //                 alt={user?.username || "Not specified"}
// // // // // //               />
// // // // // //               <Box
// // // // // //                 sx={{
// // // // // //                   display: { xs: "none", md: "flex" },
// // // // // //                   flexDirection: "column",
// // // // // //                   alignItems: "flex-start",
// // // // // //                 }}
// // // // // //               >
// // // // // //                 <Typography
// // // // // //                   sx={{
// // // // // //                     color: "inherit",
// // // // // //                     fontWeight: "bold",
// // // // // //                     lineHeight: 1.2,
// // // // // //                     fontSize: "0.9rem",
// // // // // //                   }}
// // // // // //                 >
// // // // // //                   {user?.username || "Not specified"}
// // // // // //                 </Typography>
// // // // // //                 <Typography
// // // // // //                   variant="caption"
// // // // // //                   sx={{
// // // // // //                     color: "inherit",
// // // // // //                     opacity: 0.85,
// // // // // //                     textTransform: "capitalize",
// // // // // //                   }}
// // // // // //                 >
// // // // // //                   {user?.role || "Admin"}
// // // // // //                 </Typography>
// // // // // //               </Box>
// // // // // //             </Box>
// // // // // //           </Box>
// // // // // //         </Toolbar>
// // // // // //       </AppBar>

// // // // // //       <Sidebar
// // // // // //         open={isDesktopOpen}
// // // // // //         onToggle={handleDesktopToggle}
// // // // // //         mobileOpen={isMobileOpen}
// // // // // //         onMobileToggle={handleMobileToggle}
// // // // // //       />

// // // // // //       <Box
// // // // // //         component="main"
// // // // // //         sx={{
// // // // // //           flexGrow: 1,
// // // // // //           mt: { xs: "56px", sm: "64px" },
// // // // // //           overflow: "hidden",
// // // // // //           boxSizing: "border-box",
// // // // // //           height: `calc(100vh - ${isMobile ? "56px" : "64px"})`,
// // // // // //           position: "relative",
// // // // // //         }}
// // // // // //       >
// // // // // //         <Box sx={{ height: "100%", overflowY: "auto" }}>{children}</Box>
// // // // // //       </Box>

// // // // // //       {/* --- ALTERNATIVE NOTIFICATION DRAWER (ACCORDION) --- */}
// // // // // //       <Drawer
// // // // // //         anchor="right"
// // // // // //         open={isNotificationDrawerOpen}
// // // // // //         onClose={handleNotificationToggle}
// // // // // //         sx={{
// // // // // //           "& .MuiDrawer-paper": {
// // // // // //             boxSizing: "border-box",
// // // // // //             width: { xs: "90vw", sm: 420 },
// // // // // //           },
// // // // // //         }}
// // // // // //       >
// // // // // //         <Box
// // // // // //           sx={{
// // // // // //             p: 2,
// // // // // //             display: "flex",
// // // // // //             justifyContent: "space-between",
// // // // // //             alignItems: "center",
// // // // // //           }}
// // // // // //         >
// // // // // //           <Typography variant="h6" fontWeight={600}>
// // // // // //             Notifications
// // // // // //           </Typography>
// // // // // //           <IconButton onClick={handleNotificationToggle}>
// // // // // //             <Close />
// // // // // //           </IconButton>
// // // // // //         </Box>
// // // // // //         <Divider sx={{ mb: 1 }} />

// // // // // //         {notifications && notifications.length > 0 ? (
// // // // // //           <Box sx={{ overflowY: "auto" }}>
// // // // // //             {notifications.map((n) => (
// // // // // //               <Accordion
// // // // // //                 key={n.id}
// // // // // //                 elevation={0}
// // // // // //                 disableGutters
// // // // // //                 sx={{
// // // // // //                   "&:before": { display: "none" }, // Removes the default top border
// // // // // //                   borderBottom: `1px solid ${theme.palette.divider}`,
// // // // // //                 }}
// // // // // //               >
// // // // // //                 <AccordionSummary
// // // // // //                   expandIcon={<ExpandMore />}
// // // // // //                   aria-controls={`panel-${n.id}-content`}
// // // // // //                   id={`panel-${n.id}-header`}
// // // // // //                 >
// // // // // //                   <Typography fontWeight={500}>{n.title}</Typography>
// // // // // //                 </AccordionSummary>
// // // // // //                 <AccordionDetails sx={{ backgroundColor: "action.hover" }}>
// // // // // //                   <Typography color="text.secondary">{n.message}</Typography>
// // // // // //                 </AccordionDetails>
// // // // // //               </Accordion>
// // // // // //             ))}
// // // // // //           </Box>
// // // // // //         ) : (
// // // // // //           <Box
// // // // // //             sx={{
// // // // // //               flexGrow: 1,
// // // // // //               display: "flex",
// // // // // //               flexDirection: "column",
// // // // // //               alignItems: "center",
// // // // // //               justifyContent: "center",
// // // // // //               textAlign: "center",
// // // // // //               p: 3,
// // // // // //               color: "text.secondary",
// // // // // //             }}
// // // // // //           >
// // // // // //             <NotificationsNone sx={{ fontSize: 80, mb: 2 }} />
// // // // // //             <Typography variant="h6" gutterBottom>
// // // // // //               Your inbox is empty
// // // // // //             </Typography>
// // // // // //             <Typography variant="body2">
// // // // // //               New notifications will appear here.
// // // // // //             </Typography>
// // // // // //           </Box>
// // // // // //         )}
// // // // // //       </Drawer>

// // // // // //       {/* --- User Profile Menu (no changes) --- */}
// // // // // //       <Menu
// // // // // //         anchorEl={anchorEl}
// // // // // //         open={Boolean(anchorEl)}
// // // // // //         onClose={handleClose}
// // // // // //         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
// // // // // //         transformOrigin={{ vertical: "top", horizontal: "right" }}
// // // // // //         slotProps={{
// // // // // //           paper: {
// // // // // //             elevation: 0,
// // // // // //             sx: {
// // // // // //               overflow: "visible",
// // // // // //               width: 250,
// // // // // //               mt: 1.5,
// // // // // //               backgroundColor: "primary.main",
// // // // // //               color: "primary.contrastText",
// // // // // //               borderRadius: "10px",
// // // // // //               boxShadow: "0px 4px 20px rgba(0,0,0,0.4)",
// // // // // //               "& .MuiList-root": { padding: "0px" },
// // // // // //               "& .MuiMenuItem-root": { padding: "12px 16px" },
// // // // // //             },
// // // // // //           },
// // // // // //         }}
// // // // // //       >
// // // // // //         <Box sx={{ p: 2, pt: 1.5 }}>
// // // // // //           <Typography variant="subtitle1" fontWeight={600} color="inherit">
// // // // // //             {user?.username}
// // // // // //           </Typography>
// // // // // //           <Typography
// // // // // //             variant="caption"
// // // // // //             sx={{ textTransform: "capitalize", color: "inherit", opacity: 0.9 }}
// // // // // //           >
// // // // // //             Role: {user?.role}
// // // // // //           </Typography>
// // // // // //           <Divider sx={{ my: 1.5, borderColor: "rgba(255, 255, 255, 0.2)" }} />
// // // // // //           <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
// // // // // //             <EmailOutlined
// // // // // //               fontSize="small"
// // // // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // // // //             />
// // // // // //             <Typography
// // // // // //               variant="body2"
// // // // // //               sx={{ wordBreak: "break-all", color: "inherit" }}
// // // // // //             >
// // // // // //               {user?.email}
// // // // // //             </Typography>
// // // // // //           </Box>
// // // // // //           <Box sx={{ display: "flex", alignItems: "center" }}>
// // // // // //             <PhoneOutlined
// // // // // //               fontSize="small"
// // // // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // // // //             />
// // // // // //             <Typography variant="body2" color="inherit">
// // // // // //               {user?.phone_number}
// // // // // //             </Typography>
// // // // // //           </Box>
// // // // // //         </Box>
// // // // // //       </Menu>

// // // // // //       <ChatBot />
// // // // // //     </Box>
// // // // // //   );
// // // // // // };

// // // // // // export default Layout;
// // // // // import { useState, useEffect } from "react";
// // // // // import {
// // // // //   AppBar,
// // // // //   Toolbar,
// // // // //   Typography,
// // // // //   Box,
// // // // //   IconButton,
// // // // //   Menu,
// // // // //   MenuItem,
// // // // //   Badge,
// // // // //   Avatar,
// // // // //   useTheme,
// // // // //   useMediaQuery,
// // // // //   Tooltip,
// // // // //   Divider,
// // // // //   Drawer,
// // // // //   Stack, // Using Stack for easy spacing
// // // // // } from "@mui/material";
// // // // // import {
// // // // //   NotificationsOutlined,
// // // // //   Menu as MenuIcon,
// // // // //   Brightness4,
// // // // //   Brightness7,
// // // // //   EmailOutlined,
// // // // //   PhoneOutlined,
// // // // //   Close,
// // // // //   ChatBubbleOutline, // Icon for chat bubbles
// // // // //   SpeakerNotesOffOutlined, // Icon for empty state
// // // // // } from "@mui/icons-material";
// // // // // import { useAuth } from "../../context/AuthContext";
// // // // // import { useNavigate } from "react-router-dom";
// // // // // import { useChatBot } from "../../context/ChatBotContext";
// // // // // import Sidebar from "./Sidebar";
// // // // // import ChatBot from "../common/ChatBot";
// // // // // import { useThemeToggle } from "./Theme";

// // // // // const Layout = ({ children, title }) => {
// // // // //   const { user, logout, notifications } = useAuth();
// // // // //   const { setIsOpen } = useChatBot();
// // // // //   const navigate = useNavigate();
// // // // //   const theme = useTheme();
// // // // //   const { toggleColorMode } = useThemeToggle();
// // // // //   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

// // // // //   const [isDesktopOpen, setDesktopOpen] = useState(() => {
// // // // //     const savedState = sessionStorage.getItem("sidebarOpenState");
// // // // //     return savedState !== null ? JSON.parse(savedState) : true;
// // // // //   });

// // // // //   const [isMobileOpen, setMobileOpen] = useState(false);
// // // // //   const [anchorEl, setAnchorEl] = useState(null);
// // // // //   const [isNotificationDrawerOpen, setNotificationDrawerOpen] = useState(false);

// // // // //   useEffect(() => {
// // // // //     if (!isMobile) {
// // // // //       sessionStorage.setItem("sidebarOpenState", JSON.stringify(isDesktopOpen));
// // // // //     }
// // // // //   }, [isDesktopOpen, isMobile]);

// // // // //   const handleDesktopToggle = () => setDesktopOpen(!isDesktopOpen);
// // // // //   const handleMobileToggle = () => setMobileOpen(!isMobileOpen);
// // // // //   const handleMenu = (event) => setAnchorEl(event.currentTarget);
// // // // //   const handleNotificationToggle = () =>
// // // // //     setNotificationDrawerOpen(!isNotificationDrawerOpen);
// // // // //   const handleClose = () => setAnchorEl(null);

// // // // //   return (
// // // // //     <Box
// // // // //       sx={{
// // // // //         display: "flex",
// // // // //         minHeight: "100vh",
// // // // //         overflow: "hidden",
// // // // //         bgcolor: "background.default",
// // // // //       }}
// // // // //     >
// // // // //       <AppBar
// // // // //         position="fixed"
// // // // //         elevation={0}
// // // // //         sx={{
// // // // //           zIndex: theme.zIndex.drawer + 1,
// // // // //           backgroundColor: theme.palette.primary.main,
// // // // //           color: theme.palette.primary.contrastText,
// // // // //         }}
// // // // //       >
// // // // //         <Toolbar
// // // // //           sx={{
// // // // //             px: { xs: 2, sm: 3 },
// // // // //             minHeight: { xs: 56, sm: 64 },
// // // // //             display: "flex",
// // // // //             justifyContent: "space-between",
// // // // //             alignItems: "center",
// // // // //           }}
// // // // //         >
// // // // //           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
// // // // //             <IconButton
// // // // //               color="inherit"
// // // // //               onClick={handleMobileToggle}
// // // // //               sx={{ display: { md: "none" } }}
// // // // //             >
// // // // //               <MenuIcon />
// // // // //             </IconButton>
// // // // //             <Typography
// // // // //               variant="h6"
// // // // //               sx={{
// // // // //                 fontWeight: "bold",
// // // // //                 fontSize: { xs: "1.1rem", sm: "1.25rem" },
// // // // //                 color: "inherit",
// // // // //               }}
// // // // //             >
// // // // //               {title}
// // // // //             </Typography>
// // // // //           </Box>
// // // // //           <Box
// // // // //             sx={{
// // // // //               display: "flex",
// // // // //               alignItems: "center",
// // // // //               gap: { xs: 1, sm: 2 },
// // // // //             }}
// // // // //           >
// // // // //             <Tooltip title="Toggle light/dark theme">
// // // // //               <IconButton color="inherit" onClick={toggleColorMode}>
// // // // //                 {theme.palette.mode === "dark" ? (
// // // // //                   <Brightness7 />
// // // // //                 ) : (
// // // // //                   <Brightness4 />
// // // // //                 )}
// // // // //               </IconButton>
// // // // //             </Tooltip>
// // // // //             <Tooltip title="Notifications">
// // // // //               <IconButton color="inherit" onClick={handleNotificationToggle}>
// // // // //                 <Badge badgeContent={notifications?.length || 0} color="error">
// // // // //                   <NotificationsOutlined />
// // // // //                 </Badge>
// // // // //               </IconButton>
// // // // //             </Tooltip>
// // // // //             <Box
// // // // //               onClick={handleMenu}
// // // // //               sx={{
// // // // //                 display: "flex",
// // // // //                 alignItems: "center",
// // // // //                 gap: 1.5,
// // // // //                 cursor: "pointer",
// // // // //                 p: 0.5,
// // // // //                 borderRadius: "8px",
// // // // //                 "&:hover": {
// // // // //                   backgroundColor: "rgba(255, 255, 255, 0.1)",
// // // // //                 },
// // // // //               }}
// // // // //             >
// // // // //               <Avatar
// // // // //                 sx={{ width: 40, height: 40 }}
// // // // //                 alt={user?.username || "Not specified"}
// // // // //               />
// // // // //               <Box
// // // // //                 sx={{
// // // // //                   display: { xs: "none", md: "flex" },
// // // // //                   flexDirection: "column",
// // // // //                   alignItems: "flex-start",
// // // // //                 }}
// // // // //               >
// // // // //                 <Typography
// // // // //                   sx={{
// // // // //                     color: "inherit",
// // // // //                     fontWeight: "bold",
// // // // //                     lineHeight: 1.2,
// // // // //                     fontSize: "0.9rem",
// // // // //                   }}
// // // // //                 >
// // // // //                   {user?.username || "Not specified"}
// // // // //                 </Typography>
// // // // //                 <Typography
// // // // //                   variant="caption"
// // // // //                   sx={{
// // // // //                     color: "inherit",
// // // // //                     opacity: 0.85,
// // // // //                     textTransform: "capitalize",
// // // // //                   }}
// // // // //                 >
// // // // //                   {user?.role || "Admin"}
// // // // //                 </Typography>
// // // // //               </Box>
// // // // //             </Box>
// // // // //           </Box>
// // // // //         </Toolbar>
// // // // //       </AppBar>

// // // // //       <Sidebar
// // // // //         open={isDesktopOpen}
// // // // //         onToggle={handleDesktopToggle}
// // // // //         mobileOpen={isMobileOpen}
// // // // //         onMobileToggle={handleMobileToggle}
// // // // //       />

// // // // //       <Box
// // // // //         component="main"
// // // // //         sx={{
// // // // //           flexGrow: 1,
// // // // //           mt: { xs: "56px", sm: "64px" },
// // // // //           overflow: "hidden",
// // // // //           boxSizing: "border-box",
// // // // //           height: `calc(100vh - ${isMobile ? "56px" : "64px"})`,
// // // // //           position: "relative",
// // // // //         }}
// // // // //       >
// // // // //         <Box sx={{ height: "100%", overflowY: "auto" }}>{children}</Box>
// // // // //       </Box>

// // // // //       {/* --- ALTERNATIVE NOTIFICATION DRAWER (CHAT FEED) --- */}
// // // // //       <Drawer
// // // // //         anchor="right"
// // // // //         open={isNotificationDrawerOpen}
// // // // //         onClose={handleNotificationToggle}
// // // // //         sx={{
// // // // //           "& .MuiDrawer-paper": {
// // // // //             boxSizing: "border-box",
// // // // //             width: { xs: "90vw", sm: 390 },
// // // // //             backgroundColor: "background.paper",
// // // // //           },
// // // // //         }}
// // // // //       >
// // // // //         <Box
// // // // //           sx={{
// // // // //             p: 2,
// // // // //             display: "flex",
// // // // //             justifyContent: "space-between",
// // // // //             alignItems: "center",
// // // // //           }}
// // // // //         >
// // // // //           <Typography variant="h6" fontWeight={600}>
// // // // //             Feed
// // // // //           </Typography>
// // // // //           <IconButton onClick={handleNotificationToggle}>
// // // // //             <Close />
// // // // //           </IconButton>
// // // // //         </Box>
// // // // //         <Divider />

// // // // //         {notifications && notifications.length > 0 ? (
// // // // //           <Box sx={{ p: 2, flexGrow: 1, overflowY: "auto" }}>
// // // // //             <Stack spacing={2.5}>
// // // // //               {notifications.map((n) => (
// // // // //                 <Box
// // // // //                   key={n.id}
// // // // //                   sx={{
// // // // //                     display: "flex",
// // // // //                     gap: 1.5,
// // // // //                     alignItems: "flex-start",
// // // // //                     maxWidth: "95%",
// // // // //                   }}
// // // // //                 >
// // // // //                   <Avatar
// // // // //                     sx={{ bgcolor: "primary.light", color: "primary.dark" }}
// // // // //                   >
// // // // //                     <ChatBubbleOutline />
// // // // //                   </Avatar>
// // // // //                   <Box
// // // // //                     sx={{
// // // // //                       bgcolor: "action.hover",
// // // // //                       p: 1.5,
// // // // //                       borderRadius: "4px 16px 16px 16px", // Chat bubble shape
// // // // //                       flexGrow: 1,
// // // // //                     }}
// // // // //                   >
// // // // //                     <Typography variant="subtitle2" fontWeight="bold">
// // // // //                       {n.title}
// // // // //                     </Typography>
// // // // //                     <Typography
// // // // //                       variant="body2"
// // // // //                       color="text.secondary"
// // // // //                       sx={{ wordWrap: "break-word" }}
// // // // //                     >
// // // // //                       {n.message}
// // // // //                     </Typography>
// // // // //                   </Box>
// // // // //                 </Box>
// // // // //               ))}
// // // // //             </Stack>
// // // // //           </Box>
// // // // //         ) : (
// // // // //           <Box
// // // // //             sx={{
// // // // //               flexGrow: 1,
// // // // //               display: "flex",
// // // // //               flexDirection: "column",
// // // // //               alignItems: "center",
// // // // //               justifyContent: "center",
// // // // //               textAlign: "center",
// // // // //               p: 3,
// // // // //               color: "text.secondary",
// // // // //             }}
// // // // //           >
// // // // //             <SpeakerNotesOffOutlined sx={{ fontSize: 80, mb: 2 }} />
// // // // //             <Typography variant="h6" gutterBottom>
// // // // //               No new messages
// // // // //             </Typography>
// // // // //             <Typography variant="body2">
// // // // //               Your feed is currently empty.
// // // // //             </Typography>
// // // // //           </Box>
// // // // //         )}
// // // // //       </Drawer>

// // // // //       {/* --- User Profile Menu (no changes) --- */}
// // // // //       <Menu
// // // // //         anchorEl={anchorEl}
// // // // //         open={Boolean(anchorEl)}
// // // // //         onClose={handleClose}
// // // // //         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
// // // // //         transformOrigin={{ vertical: "top", horizontal: "right" }}
// // // // //         slotProps={{
// // // // //           paper: {
// // // // //             elevation: 0,
// // // // //             sx: {
// // // // //               overflow: "visible",
// // // // //               width: 250,
// // // // //               mt: 1.5,
// // // // //               backgroundColor: "primary.main",
// // // // //               color: "primary.contrastText",
// // // // //               borderRadius: "10px",
// // // // //               boxShadow: "0px 4px 20px rgba(0,0,0,0.4)",
// // // // //               "& .MuiList-root": { padding: "0px" },
// // // // //               "& .MuiMenuItem-root": { padding: "12px 16px" },
// // // // //             },
// // // // //           },
// // // // //         }}
// // // // //       >
// // // // //         <Box sx={{ p: 2, pt: 1.5 }}>
// // // // //           <Typography variant="subtitle1" fontWeight={600} color="inherit">
// // // // //             {user?.username}
// // // // //           </Typography>
// // // // //           <Typography
// // // // //             variant="caption"
// // // // //             sx={{ textTransform: "capitalize", color: "inherit", opacity: 0.9 }}
// // // // //           >
// // // // //             Role: {user?.role}
// // // // //           </Typography>
// // // // //           <Divider sx={{ my: 1.5, borderColor: "rgba(255, 255, 255, 0.2)" }} />
// // // // //           <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
// // // // //             <EmailOutlined
// // // // //               fontSize="small"
// // // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // // //             />
// // // // //             <Typography
// // // // //               variant="body2"
// // // // //               sx={{ wordBreak: "break-all", color: "inherit" }}
// // // // //             >
// // // // //               {user?.email}
// // // // //             </Typography>
// // // // //           </Box>
// // // // //           <Box sx={{ display: "flex", alignItems: "center" }}>
// // // // //             <PhoneOutlined
// // // // //               fontSize="small"
// // // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // // //             />
// // // // //             <Typography variant="body2" color="inherit">
// // // // //               {user?.phone_number}
// // // // //             </Typography>
// // // // //           </Box>
// // // // //         </Box>
// // // // //       </Menu>

// // // // //       <ChatBot />
// // // // //     </Box>
// // // // //   );
// // // // // };

// // // // // export default Layout;
// // // // import { useState, useEffect } from "react";
// // // // import {
// // // //   AppBar,
// // // //   Toolbar,
// // // //   Typography,
// // // //   Box,
// // // //   IconButton,
// // // //   Menu,
// // // //   MenuItem,
// // // //   Badge,
// // // //   Avatar,
// // // //   useTheme,
// // // //   useMediaQuery,
// // // //   Tooltip,
// // // //   Divider,
// // // //   Drawer,
// // // //   keyframes, // New import for the blinking cursor animation
// // // // } from "@mui/material";
// // // // import {
// // // //   NotificationsOutlined,
// // // //   Menu as MenuIcon,
// // // //   Brightness4,
// // // //   Brightness7,
// // // //   EmailOutlined,
// // // //   PhoneOutlined,
// // // //   Close,
// // // //   DataObject, // Icon for the empty state
// // // // } from "@mui/icons-material";
// // // // import { useAuth } from "../../context/AuthContext";
// // // // import { useNavigate } from "react-router-dom";
// // // // import { useChatBot } from "../../context/ChatBotContext";
// // // // import Sidebar from "./Sidebar";
// // // // import ChatBot from "../common/ChatBot";
// // // // import { useThemeToggle } from "./Theme";

// // // // // Define the keyframes for the blinking cursor
// // // // const blink = keyframes`
// // // //   50% { opacity: 0; }
// // // // `;

// // // // const Layout = ({ children, title }) => {
// // // //   const { user, logout, notifications } = useAuth();
// // // //   const { setIsOpen } = useChatBot();
// // // //   const navigate = useNavigate();
// // // //   const theme = useTheme();
// // // //   const { toggleColorMode } = useThemeToggle();
// // // //   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

// // // //   const [isDesktopOpen, setDesktopOpen] = useState(() => {
// // // //     const savedState = sessionStorage.getItem("sidebarOpenState");
// // // //     return savedState !== null ? JSON.parse(savedState) : true;
// // // //   });

// // // //   const [isMobileOpen, setMobileOpen] = useState(false);
// // // //   const [anchorEl, setAnchorEl] = useState(null);
// // // //   const [isNotificationDrawerOpen, setNotificationDrawerOpen] = useState(false);

// // // //   useEffect(() => {
// // // //     if (!isMobile) {
// // // //       sessionStorage.setItem("sidebarOpenState", JSON.stringify(isDesktopOpen));
// // // //     }
// // // //   }, [isDesktopOpen, isMobile]);

// // // //   const handleDesktopToggle = () => setDesktopOpen(!isDesktopOpen);
// // // //   const handleMobileToggle = () => setMobileOpen(!isMobileOpen);
// // // //   const handleMenu = (event) => setAnchorEl(event.currentTarget);
// // // //   const handleNotificationToggle = () =>
// // // //     setNotificationDrawerOpen(!isNotificationDrawerOpen);
// // // //   const handleClose = () => setAnchorEl(null);

// // // //   return (
// // // //     <Box
// // // //       sx={{
// // // //         display: "flex",
// // // //         minHeight: "100vh",
// // // //         overflow: "hidden",
// // // //         bgcolor: "background.default",
// // // //       }}
// // // //     >
// // // //       <AppBar
// // // //         position="fixed"
// // // //         elevation={0}
// // // //         sx={{
// // // //           zIndex: theme.zIndex.drawer + 1,
// // // //           backgroundColor: theme.palette.primary.main,
// // // //           color: theme.palette.primary.contrastText,
// // // //         }}
// // // //       >
// // // //         <Toolbar
// // // //           sx={{
// // // //             px: { xs: 2, sm: 3 },
// // // //             minHeight: { xs: 56, sm: 64 },
// // // //             display: "flex",
// // // //             justifyContent: "space-between",
// // // //             alignItems: "center",
// // // //           }}
// // // //         >
// // // //           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
// // // //             <IconButton
// // // //               color="inherit"
// // // //               onClick={handleMobileToggle}
// // // //               sx={{ display: { md: "none" } }}
// // // //             >
// // // //               <MenuIcon />
// // // //             </IconButton>
// // // //             <Typography
// // // //               variant="h6"
// // // //               sx={{
// // // //                 fontWeight: "bold",
// // // //                 fontSize: { xs: "1.1rem", sm: "1.25rem" },
// // // //                 color: "inherit",
// // // //               }}
// // // //             >
// // // //               {title}
// // // //             </Typography>
// // // //           </Box>
// // // //           <Box
// // // //             sx={{
// // // //               display: "flex",
// // // //               alignItems: "center",
// // // //               gap: { xs: 1, sm: 2 },
// // // //             }}
// // // //           >
// // // //             <Tooltip title="Toggle light/dark theme">
// // // //               <IconButton color="inherit" onClick={toggleColorMode}>
// // // //                 {theme.palette.mode === "dark" ? (
// // // //                   <Brightness7 />
// // // //                 ) : (
// // // //                   <Brightness4 />
// // // //                 )}
// // // //               </IconButton>
// // // //             </Tooltip>
// // // //             <Tooltip title="Notifications">
// // // //               <IconButton color="inherit" onClick={handleNotificationToggle}>
// // // //                 <Badge badgeContent={notifications?.length || 0} color="error">
// // // //                   <NotificationsOutlined />
// // // //                 </Badge>
// // // //               </IconButton>
// // // //             </Tooltip>
// // // //             <Box
// // // //               onClick={handleMenu}
// // // //               sx={{
// // // //                 display: "flex",
// // // //                 alignItems: "center",
// // // //                 gap: 1.5,
// // // //                 cursor: "pointer",
// // // //                 p: 0.5,
// // // //                 borderRadius: "8px",
// // // //                 "&:hover": {
// // // //                   backgroundColor: "rgba(255, 255, 255, 0.1)",
// // // //                 },
// // // //               }}
// // // //             >
// // // //               <Avatar
// // // //                 sx={{ width: 40, height: 40 }}
// // // //                 alt={user?.username || "Not specified"}
// // // //               />
// // // //               <Box
// // // //                 sx={{
// // // //                   display: { xs: "none", md: "flex" },
// // // //                   flexDirection: "column",
// // // //                   alignItems: "flex-start",
// // // //                 }}
// // // //               >
// // // //                 <Typography
// // // //                   sx={{
// // // //                     color: "inherit",
// // // //                     fontWeight: "bold",
// // // //                     lineHeight: 1.2,
// // // //                     fontSize: "0.9rem",
// // // //                   }}
// // // //                 >
// // // //                   {user?.username || "Not specified"}
// // // //                 </Typography>
// // // //                 <Typography
// // // //                   variant="caption"
// // // //                   sx={{
// // // //                     color: "inherit",
// // // //                     opacity: 0.85,
// // // //                     textTransform: "capitalize",
// // // //                   }}
// // // //                 >
// // // //                   {user?.role || "Admin"}
// // // //                 </Typography>
// // // //               </Box>
// // // //             </Box>
// // // //           </Box>
// // // //         </Toolbar>
// // // //       </AppBar>

// // // //       <Sidebar
// // // //         open={isDesktopOpen}
// // // //         onToggle={handleDesktopToggle}
// // // //         mobileOpen={isMobileOpen}
// // // //         onMobileToggle={handleMobileToggle}
// // // //       />

// // // //       <Box
// // // //         component="main"
// // // //         sx={{
// // // //           flexGrow: 1,
// // // //           mt: { xs: "56px", sm: "64px" },
// // // //           overflow: "hidden",
// // // //           boxSizing: "border-box",
// // // //           height: `calc(100vh - ${isMobile ? "56px" : "64px"})`,
// // // //           position: "relative",
// // // //         }}
// // // //       >
// // // //         <Box sx={{ height: "100%", overflowY: "auto" }}>{children}</Box>
// // // //       </Box>

// // // //       {/* --- ALTERNATIVE NOTIFICATION DRAWER (TERMINAL LOG) --- */}
// // // //       <Drawer
// // // //         anchor="right"
// // // //         open={isNotificationDrawerOpen}
// // // //         onClose={handleNotificationToggle}
// // // //         sx={{
// // // //           "& .MuiDrawer-paper": {
// // // //             boxSizing: "border-box",
// // // //             width: { xs: "90vw", sm: 420 },
// // // //             backgroundColor: "#1E1E1E", // Terminal background
// // // //             color: "#E0E0E0", // Terminal text color
// // // //             fontFamily: "'Fira Code', 'Menlo', 'monospace'",
// // // //           },
// // // //         }}
// // // //       >
// // // //         <Box
// // // //           sx={{
// // // //             p: 2,
// // // //             display: "flex",
// // // //             justifyContent: "space-between",
// // // //             alignItems: "center",
// // // //           }}
// // // //         >
// // // //           <Typography variant="h6" fontWeight={500} fontFamily="inherit">
// // // //             // LOG: NOTIFICATIONS
// // // //           </Typography>
// // // //           <IconButton
// // // //             onClick={handleNotificationToggle}
// // // //             sx={{ color: "#E0E0E0" }}
// // // //           >
// // // //             <Close />
// // // //           </IconButton>
// // // //         </Box>
// // // //         <Divider sx={{ borderColor: "rgba(255, 255, 255, 0.2)" }} />

// // // //         <Box sx={{ p: 2, flexGrow: 1, overflowY: "auto" }}>
// // // //           {notifications && notifications.length > 0 ? (
// // // //             notifications.map((n, index) => (
// // // //               <Box key={n.id} sx={{ mb: 2 }}>
// // // //                 <Typography
// // // //                   component="div"
// // // //                   fontFamily="inherit"
// // // //                   sx={{ display: "flex" }}
// // // //                 >
// // // //                   <Box component="span" sx={{ color: "#82AAFF", mr: 1 }}>
// // // //                     {">"}
// // // //                   </Box>
// // // //                   <Box component="span" sx={{ color: "#C3E88D" }}>
// // // //                     {n.title}
// // // //                   </Box>
// // // //                 </Typography>
// // // //                 <Typography
// // // //                   variant="body2"
// // // //                   fontFamily="inherit"
// // // //                   sx={{ pl: 3, whiteSpace: "pre-wrap" }}
// // // //                 >
// // // //                   {n.message}
// // // //                 </Typography>
// // // //                 {/* Add blinking cursor to the last item */}
// // // //                 {index === notifications.length - 1 && (
// // // //                   <Box
// // // //                     component="span"
// // // //                     sx={{
// // // //                       animation: `${blink} 1s step-end infinite`,
// // // //                       ml: 3,
// // // //                       bgcolor: "#E0E0E0",
// // // //                       display: "inline-block",
// // // //                       width: "8px",
// // // //                       height: "16px",
// // // //                       verticalAlign: "text-bottom",
// // // //                     }}
// // // //                   />
// // // //                 )}
// // // //               </Box>
// // // //             ))
// // // //           ) : (
// // // //             <Box
// // // //               sx={{
// // // //                 flexGrow: 1,
// // // //                 display: "flex",
// // // //                 flexDirection: "column",
// // // //                 alignItems: "center",
// // // //                 justifyContent: "center",
// // // //                 height: "100%",
// // // //                 color: "grey.500",
// // // //               }}
// // // //             >
// // // //               <DataObject sx={{ fontSize: 80, mb: 2 }} />
// // // //               <Typography fontFamily="inherit">
// // // //                 [No new entries in log]
// // // //               </Typography>
// // // //             </Box>
// // // //           )}
// // // //         </Box>
// // // //       </Drawer>

// // // //       {/* --- User Profile Menu (no changes) --- */}
// // // //       <Menu
// // // //         anchorEl={anchorEl}
// // // //         open={Boolean(anchorEl)}
// // // //         onClose={handleClose}
// // // //         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
// // // //         transformOrigin={{ vertical: "top", horizontal: "right" }}
// // // //         slotProps={{
// // // //           paper: {
// // // //             elevation: 0,
// // // //             sx: {
// // // //               overflow: "visible",
// // // //               width: 250,
// // // //               mt: 1.5,
// // // //               backgroundColor: "primary.main",
// // // //               color: "primary.contrastText",
// // // //               borderRadius: "10px",
// // // //               boxShadow: "0px 4px 20px rgba(0,0,0,0.4)",
// // // //               "& .MuiList-root": { padding: "0px" },
// // // //               "& .MuiMenuItem-root": { padding: "12px 16px" },
// // // //             },
// // // //           },
// // // //         }}
// // // //       >
// // // //         <Box sx={{ p: 2, pt: 1.5 }}>
// // // //           <Typography variant="subtitle1" fontWeight={600} color="inherit">
// // // //             {user?.username}
// // // //           </Typography>
// // // //           <Typography
// // // //             variant="caption"
// // // //             sx={{ textTransform: "capitalize", color: "inherit", opacity: 0.9 }}
// // // //           >
// // // //             Role: {user?.role}
// // // //           </Typography>
// // // //           <Divider sx={{ my: 1.5, borderColor: "rgba(255, 255, 255, 0.2)" }} />
// // // //           <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
// // // //             <EmailOutlined
// // // //               fontSize="small"
// // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // //             />
// // // //             <Typography
// // // //               variant="body2"
// // // //               sx={{ wordBreak: "break-all", color: "inherit" }}
// // // //             >
// // // //               {user?.email}
// // // //             </Typography>
// // // //           </Box>
// // // //           <Box sx={{ display: "flex", alignItems: "center" }}>
// // // //             <PhoneOutlined
// // // //               fontSize="small"
// // // //               sx={{ mr: 1.5, color: "inherit" }}
// // // //             />
// // // //             <Typography variant="body2" color="inherit">
// // // //               {user?.phone_number}
// // // //             </Typography>
// // // //           </Box>
// // // //         </Box>
// // // //       </Menu>

// // // //       <ChatBot />
// // // //     </Box>
// // // //   );
// // // // };

// // // // export default Layout;
// // // import { useState, useEffect } from "react";
// // // import {
// // //   AppBar,
// // //   Toolbar,
// // //   Typography,
// // //   Box,
// // //   IconButton,
// // //   Menu,
// // //   MenuItem,
// // //   Badge,
// // //   Avatar,
// // //   useTheme,
// // //   useMediaQuery,
// // //   Tooltip,
// // //   Divider,
// // //   Drawer,
// // //   Stack, // Using Stack for layout
// // // } from "@mui/material";
// // // import {
// // //   NotificationsOutlined,
// // //   Menu as MenuIcon,
// // //   Brightness4,
// // //   Brightness7,
// // //   EmailOutlined,
// // //   PhoneOutlined,
// // //   Close,
// // //   BubbleChart, // New icon for the empty state
// // //   Code, // New icon for the notification items
// // // } from "@mui/icons-material";
// // // import { useAuth } from "../../context/AuthContext";
// // // import { useNavigate } from "react-router-dom";
// // // import { useChatBot } from "../../context/ChatBotContext";
// // // import Sidebar from "./Sidebar";
// // // import ChatBot from "../common/ChatBot";
// // // import { useThemeToggle } from "./Theme";

// // // const Layout = ({ children, title }) => {
// // //   const { user, logout, notifications } = useAuth();
// // //   const { setIsOpen } = useChatBot();
// // //   const navigate = useNavigate();
// // //   const theme = useTheme();
// // //   const { toggleColorMode } = useThemeToggle();
// // //   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

// // //   const [isDesktopOpen, setDesktopOpen] = useState(() => {
// // //     const savedState = sessionStorage.getItem("sidebarOpenState");
// // //     return savedState !== null ? JSON.parse(savedState) : true;
// // //   });

// // //   const [isMobileOpen, setMobileOpen] = useState(false);
// // //   const [anchorEl, setAnchorEl] = useState(null);
// // //   const [isNotificationDrawerOpen, setNotificationDrawerOpen] = useState(false);

// // //   useEffect(() => {
// // //     if (!isMobile) {
// // //       sessionStorage.setItem("sidebarOpenState", JSON.stringify(isDesktopOpen));
// // //     }
// // //   }, [isDesktopOpen, isMobile]);

// // //   const handleDesktopToggle = () => setDesktopOpen(!isDesktopOpen);
// // //   const handleMobileToggle = () => setMobileOpen(!isMobileOpen);
// // //   const handleMenu = (event) => setAnchorEl(event.currentTarget);
// // //   const handleNotificationToggle = () =>
// // //     setNotificationDrawerOpen(!isNotificationDrawerOpen);
// // //   const handleClose = () => setAnchorEl(null);

// // //   return (
// // //     <Box
// // //       sx={{
// // //         display: "flex",
// // //         minHeight: "100vh",
// // //         overflow: "hidden",
// // //         bgcolor: "background.default",
// // //       }}
// // //     >
// // //       <AppBar
// // //         position="fixed"
// // //         elevation={0}
// // //         sx={{
// // //           zIndex: theme.zIndex.drawer + 1,
// // //           backgroundColor: theme.palette.primary.main,
// // //           color: theme.palette.primary.contrastText,
// // //         }}
// // //       >
// // //         <Toolbar
// // //           sx={{
// // //             px: { xs: 2, sm: 3 },
// // //             minHeight: { xs: 56, sm: 64 },
// // //             display: "flex",
// // //             justifyContent: "space-between",
// // //             alignItems: "center",
// // //           }}
// // //         >
// // //           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
// // //             <IconButton
// // //               color="inherit"
// // //               onClick={handleMobileToggle}
// // //               sx={{ display: { md: "none" } }}
// // //             >
// // //               <MenuIcon />
// // //             </IconButton>
// // //             <Typography
// // //               variant="h6"
// // //               sx={{
// // //                 fontWeight: "bold",
// // //                 fontSize: { xs: "1.1rem", sm: "1.25rem" },
// // //                 color: "inherit",
// // //               }}
// // //             >
// // //               {title}
// // //             </Typography>
// // //           </Box>
// // //           <Box
// // //             sx={{
// // //               display: "flex",
// // //               alignItems: "center",
// // //               gap: { xs: 1, sm: 2 },
// // //             }}
// // //           >
// // //             <Tooltip title="Toggle light/dark theme">
// // //               <IconButton color="inherit" onClick={toggleColorMode}>
// // //                 {theme.palette.mode === "dark" ? (
// // //                   <Brightness7 />
// // //                 ) : (
// // //                   <Brightness4 />
// // //                 )}
// // //               </IconButton>
// // //             </Tooltip>
// // //             <Tooltip title="Notifications">
// // //               <IconButton color="inherit" onClick={handleNotificationToggle}>
// // //                 <Badge badgeContent={notifications?.length || 0} color="error">
// // //                   <NotificationsOutlined />
// // //                 </Badge>
// // //               </IconButton>
// // //             </Tooltip>
// // //             <Box
// // //               onClick={handleMenu}
// // //               sx={{
// // //                 display: "flex",
// // //                 alignItems: "center",
// // //                 gap: 1.5,
// // //                 cursor: "pointer",
// // //                 p: 0.5,
// // //                 borderRadius: "8px",
// // //                 "&:hover": {
// // //                   backgroundColor: "rgba(255, 255, 255, 0.1)",
// // //                 },
// // //               }}
// // //             >
// // //               <Avatar
// // //                 sx={{ width: 40, height: 40 }}
// // //                 alt={user?.username || "Not specified"}
// // //               />
// // //               <Box
// // //                 sx={{
// // //                   display: { xs: "none", md: "flex" },
// // //                   flexDirection: "column",
// // //                   alignItems: "flex-start",
// // //                 }}
// // //               >
// // //                 <Typography
// // //                   sx={{
// // //                     color: "inherit",
// // //                     fontWeight: "bold",
// // //                     lineHeight: 1.2,
// // //                     fontSize: "0.9rem",
// // //                   }}
// // //                 >
// // //                   {user?.username || "Not specified"}
// // //                 </Typography>
// // //                 <Typography
// // //                   variant="caption"
// // //                   sx={{
// // //                     color: "inherit",
// // //                     opacity: 0.85,
// // //                     textTransform: "capitalize",
// // //                   }}
// // //                 >
// // //                   {user?.role || "Admin"}
// // //                 </Typography>
// // //               </Box>
// // //             </Box>
// // //           </Box>
// // //         </Toolbar>
// // //       </AppBar>

// // //       <Sidebar
// // //         open={isDesktopOpen}
// // //         onToggle={handleDesktopToggle}
// // //         mobileOpen={isMobileOpen}
// // //         onMobileToggle={handleMobileToggle}
// // //       />

// // //       <Box
// // //         component="main"
// // //         sx={{
// // //           flexGrow: 1,
// // //           mt: { xs: "56px", sm: "64px" },
// // //           overflow: "hidden",
// // //           boxSizing: "border-box",
// // //           height: `calc(100vh - ${isMobile ? "56px" : "64px"})`,
// // //           position: "relative",
// // //         }}
// // //       >
// // //         <Box sx={{ height: "100%", overflowY: "auto" }}>{children}</Box>
// // //       </Box>

// // //       {/* --- ALTERNATIVE NOTIFICATION DRAWER (GRADIENT GLOW) --- */}
// // //       <Drawer
// // //         anchor="right"
// // //         open={isNotificationDrawerOpen}
// // //         onClose={handleNotificationToggle}
// // //         sx={{
// // //           "& .MuiDrawer-paper": {
// // //             boxSizing: "border-box",
// // //             width: { xs: "90vw", sm: 400 },
// // //             backgroundColor: "#121212",
// // //             color: "#E0E0E0",
// // //             borderLeft: "1px solid #333",
// // //           },
// // //         }}
// // //       >
// // //         <Box
// // //           sx={{
// // //             p: 2,
// // //             display: "flex",
// // //             justifyContent: "space-between",
// // //             alignItems: "center",
// // //           }}
// // //         >
// // //           <Typography variant="h6" fontWeight={600}>
// // //             System Stream
// // //           </Typography>
// // //           <IconButton
// // //             onClick={handleNotificationToggle}
// // //             sx={{ color: "#E0E0E0" }}
// // //           >
// // //             <Close />
// // //           </IconButton>
// // //         </Box>
// // //         <Divider sx={{ borderColor: "#333" }} />

// // //         {notifications && notifications.length > 0 ? (
// // //           <Box sx={{ p: 2, flexGrow: 1, overflowY: "auto" }}>
// // //             <Stack spacing={2}>
// // //               {notifications.map((n) => (
// // //                 <Box
// // //                   key={n.id}
// // //                   sx={{
// // //                     p: "2px",
// // //                     borderRadius: "12px",
// // //                     position: "relative",
// // //                     background: "linear-gradient(45deg, #333, #222)",
// // //                     transition: "all 0.3s ease",
// // //                     "&:hover": {
// // //                       background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
// // //                       boxShadow: `0 0 15px ${theme.palette.primary.main}80`,
// // //                     },
// // //                   }}
// // //                 >
// // //                   <Box
// // //                     sx={{
// // //                       p: 2,
// // //                       bgcolor: "#1E1E1E",
// // //                       borderRadius: "10px",
// // //                       display: "flex",
// // //                       alignItems: "center",
// // //                       gap: 2,
// // //                     }}
// // //                   >
// // //                     <Box
// // //                       sx={{
// // //                         width: 40,
// // //                         height: 40,
// // //                         borderRadius: "50%",
// // //                         display: "flex",
// // //                         alignItems: "center",
// // //                         justifyContent: "center",
// // //                         flexShrink: 0,
// // //                         background: `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
// // //                       }}
// // //                     >
// // //                       <Code />
// // //                     </Box>
// // //                     <Box>
// // //                       <Typography variant="body2" fontWeight="bold">
// // //                         {n.title}
// // //                       </Typography>
// // //                       <Typography variant="caption" color="#aaa">
// // //                         {n.message}
// // //                       </Typography>
// // //                     </Box>
// // //                   </Box>
// // //                 </Box>
// // //               ))}
// // //             </Stack>
// // //           </Box>
// // //         ) : (
// // //           <Box
// // //             sx={{
// // //               flexGrow: 1,
// // //               display: "flex",
// // //               flexDirection: "column",
// // //               alignItems: "center",
// // //               justifyContent: "center",
// // //               textAlign: "center",
// // //               p: 3,
// // //               color: "grey.700",
// // //             }}
// // //           >
// // //             <BubbleChart sx={{ fontSize: 80, mb: 2 }} />
// // //             <Typography variant="h6" gutterBottom>
// // //               Stream is Clear
// // //             </Typography>
// // //             <Typography variant="body2">
// // //               No new data packets received.
// // //             </Typography>
// // //           </Box>
// // //         )}
// // //       </Drawer>

// // //       {/* --- User Profile Menu (no changes) --- */}
// // //       <Menu
// // //         anchorEl={anchorEl}
// // //         open={Boolean(anchorEl)}
// // //         onClose={handleClose}
// // //         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
// // //         transformOrigin={{ vertical: "top", horizontal: "right" }}
// // //         slotProps={{
// // //           paper: {
// // //             elevation: 0,
// // //             sx: {
// // //               overflow: "visible",
// // //               width: 250,
// // //               mt: 1.5,
// // //               backgroundColor: "primary.main",
// // //               color: "primary.contrastText",
// // //               borderRadius: "10px",
// // //               boxShadow: "0px 4px 20px rgba(0,0,0,0.4)",
// // //               "& .MuiList-root": { padding: "0px" },
// // //               "& .MuiMenuItem-root": { padding: "12px 16px" },
// // //             },
// // //           },
// // //         }}
// // //       >
// // //         <Box sx={{ p: 2, pt: 1.5 }}>
// // //           <Typography variant="subtitle1" fontWeight={600} color="inherit">
// // //             {user?.username}
// // //           </Typography>
// // //           <Typography
// // //             variant="caption"
// // //             sx={{ textTransform: "capitalize", color: "inherit", opacity: 0.9 }}
// // //           >
// // //             Role: {user?.role}
// // //           </Typography>
// // //           <Divider sx={{ my: 1.5, borderColor: "rgba(255, 255, 255, 0.2)" }} />
// // //           <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
// // //             <EmailOutlined
// // //               fontSize="small"
// // //               sx={{ mr: 1.5, color: "inherit" }}
// // //             />
// // //             <Typography
// // //               variant="body2"
// // //               sx={{ wordBreak: "break-all", color: "inherit" }}
// // //             >
// // //               {user?.email}
// // //             </Typography>
// // //           </Box>
// // //           <Box sx={{ display: "flex", alignItems: "center" }}>
// // //             <PhoneOutlined
// // //               fontSize="small"
// // //               sx={{ mr: 1.5, color: "inherit" }}
// // //             />
// // //             <Typography variant="body2" color="inherit">
// // //               {user?.phone_number}
// // //             </Typography>
// // //           </Box>
// // //         </Box>
// // //       </Menu>

// // //       <ChatBot />
// // //     </Box>
// // //   );
// // // };

// // // export default Layout;
// // import { useState, useEffect } from "react";
// // import {
// //   AppBar,
// //   Toolbar,
// //   Typography,
// //   Box,
// //   IconButton,
// //   Menu,
// //   MenuItem,
// //   Badge,
// //   Avatar,
// //   useTheme,
// //   useMediaQuery,
// //   Tooltip,
// //   Divider,
// //   Drawer,
// //   Stack, // Using Stack for layout
// //   Grow, // New import for the custom animation
// // } from "@mui/material";
// // import {
// //   NotificationsOutlined,
// //   Menu as MenuIcon,
// //   Brightness4,
// //   Brightness7,
// //   EmailOutlined,
// //   PhoneOutlined,
// //   Close,
// //   GridView, // New icon for the empty state
// //   Hub, // New, changed icon for the notification items
// // } from "@mui/icons-material";
// // import { useAuth } from "../../context/AuthContext";
// // import { useNavigate } from "react-router-dom";
// // import { useChatBot } from "../../context/ChatBotContext";
// // import Sidebar from "./Sidebar";
// // import ChatBot from "../common/ChatBot";
// // import { useThemeToggle } from "./Theme";

// // const Layout = ({ children, title }) => {
// //   const { user, logout, notifications } = useAuth();
// //   const { setIsOpen } = useChatBot();
// //   const navigate = useNavigate();
// //   const theme = useTheme();
// //   const { toggleColorMode } = useThemeToggle();
// //   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

// //   const [isDesktopOpen, setDesktopOpen] = useState(() => {
// //     const savedState = sessionStorage.getItem("sidebarOpenState");
// //     return savedState !== null ? JSON.parse(savedState) : true;
// //   });

// //   const [isMobileOpen, setMobileOpen] = useState(false);
// //   const [anchorEl, setAnchorEl] = useState(null);
// //   const [isNotificationDrawerOpen, setNotificationDrawerOpen] = useState(false);

// //   useEffect(() => {
// //     if (!isMobile) {
// //       sessionStorage.setItem("sidebarOpenState", JSON.stringify(isDesktopOpen));
// //     }
// //   }, [isDesktopOpen, isMobile]);

// //   const handleDesktopToggle = () => setDesktopOpen(!isDesktopOpen);
// //   const handleMobileToggle = () => setMobileOpen(!isMobileOpen);
// //   const handleMenu = (event) => setAnchorEl(event.currentTarget);
// //   const handleNotificationToggle = () =>
// //     setNotificationDrawerOpen(!isNotificationDrawerOpen);
// //   const handleClose = () => setAnchorEl(null);

// //   return (
// //     <Box
// //       sx={{
// //         display: "flex",
// //         minHeight: "100vh",
// //         overflow: "hidden",
// //         bgcolor: "background.default",
// //       }}
// //     >
// //       <AppBar
// //         position="fixed"
// //         elevation={0}
// //         sx={{
// //           zIndex: theme.zIndex.drawer + 1,
// //           backgroundColor: theme.palette.primary.main,
// //           color: theme.palette.primary.contrastText,
// //         }}
// //       >
// //         <Toolbar
// //           sx={{
// //             px: { xs: 2, sm: 3 },
// //             minHeight: { xs: 56, sm: 64 },
// //             display: "flex",
// //             justifyContent: "space-between",
// //             alignItems: "center",
// //           }}
// //         >
// //           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
// //             <IconButton
// //               color="inherit"
// //               onClick={handleMobileToggle}
// //               sx={{ display: { md: "none" } }}
// //             >
// //               <MenuIcon />
// //             </IconButton>
// //             <Typography
// //               variant="h6"
// //               sx={{
// //                 fontWeight: "bold",
// //                 fontSize: { xs: "1.1rem", sm: "1.25rem" },
// //                 color: "inherit",
// //               }}
// //             >
// //               {title}
// //             </Typography>
// //           </Box>
// //           <Box
// //             sx={{
// //               display: "flex",
// //               alignItems: "center",
// //               gap: { xs: 1, sm: 2 },
// //             }}
// //           >
// //             <Tooltip title="Toggle light/dark theme">
// //               <IconButton color="inherit" onClick={toggleColorMode}>
// //                 {theme.palette.mode === "dark" ? (
// //                   <Brightness7 />
// //                 ) : (
// //                   <Brightness4 />
// //                 )}
// //               </IconButton>
// //             </Tooltip>
// //             <Tooltip title="Notifications">
// //               <IconButton color="inherit" onClick={handleNotificationToggle}>
// //                 <Badge badgeContent={notifications?.length || 0} color="error">
// //                   <NotificationsOutlined />
// //                 </Badge>
// //               </IconButton>
// //             </Tooltip>
// //             <Box
// //               onClick={handleMenu}
// //               sx={{
// //                 display: "flex",
// //                 alignItems: "center",
// //                 gap: 1.5,
// //                 cursor: "pointer",
// //                 p: 0.5,
// //                 borderRadius: "8px",
// //                 "&:hover": {
// //                   backgroundColor: "rgba(255, 255, 255, 0.1)",
// //                 },
// //               }}
// //             >
// //               <Avatar
// //                 sx={{ width: 40, height: 40 }}
// //                 alt={user?.username || "Not specified"}
// //               />
// //               <Box
// //                 sx={{
// //                   display: { xs: "none", md: "flex" },
// //                   flexDirection: "column",
// //                   alignItems: "flex-start",
// //                 }}
// //               >
// //                 <Typography
// //                   sx={{
// //                     color: "inherit",
// //                     fontWeight: "bold",
// //                     lineHeight: 1.2,
// //                     fontSize: "0.9rem",
// //                   }}
// //                 >
// //                   {user?.username || "Not specified"}
// //                 </Typography>
// //                 <Typography
// //                   variant="caption"
// //                   sx={{
// //                     color: "inherit",
// //                     opacity: 0.85,
// //                     textTransform: "capitalize",
// //                   }}
// //                 >
// //                   {user?.role || "Admin"}
// //                 </Typography>
// //               </Box>
// //             </Box>
// //           </Box>
// //         </Toolbar>
// //       </AppBar>

// //       <Sidebar
// //         open={isDesktopOpen}
// //         onToggle={handleDesktopToggle}
// //         mobileOpen={isMobileOpen}
// //         onMobileToggle={handleMobileToggle}
// //       />

// //       <Box
// //         component="main"
// //         sx={{
// //           flexGrow: 1,
// //           mt: { xs: "56px", sm: "64px" },
// //           overflow: "hidden",
// //           boxSizing: "border-box",
// //           height: `calc(100vh - ${isMobile ? "56px" : "64px"})`,
// //           position: "relative",
// //         }}
// //       >
// //         <Box sx={{ height: "100%", overflowY: "auto" }}>{children}</Box>
// //       </Box>

// //       {/* --- REVISED NOTIFICATION DRAWER (GLASS UI, TOP-RIGHT GROW ANIMATION) --- */}
// //       <Drawer
// //         anchor="top" // Open from the top
// //         open={isNotificationDrawerOpen}
// //         onClose={handleNotificationToggle}
// //         hideBackdrop // Hide the dark overlay for a cleaner look
// //         TransitionComponent={Grow} // Use the Grow animation
// //         sx={{
// //           "& .MuiDrawer-paper": {
// //             // Positioning
// //             width: { xs: "90vw", sm: 400 },
// //             marginLeft: "auto",
// //             marginTop: "70px",
// //             marginRight: { xs: "5vw", sm: "20px" },
// //             maxHeight: "calc(100vh - 90px)",
// //             // Glassmorphism effect
// //             backgroundColor:
// //               theme.palette.mode === "dark"
// //                 ? "rgba(30, 30, 30, 0.7)"
// //                 : "rgba(255, 255, 255, 0.7)",
// //             backdropFilter: "blur(20px)",
// //             WebkitBackdropFilter: "blur(20px)", // For Safari
// //             // Styling
// //             borderRadius: "16px",
// //             boxShadow: "none",
// //             border: `1px solid ${theme.palette.divider}`,
// //             color: theme.palette.text.primary,
// //           },
// //         }}
// //       >
// //         <Box
// //           sx={{
// //             p: 2,
// //             display: "flex",
// //             justifyContent: "space-between",
// //             alignItems: "center",
// //           }}
// //         >
// //           <Typography variant="h6" fontWeight={600}>
// //             System Stream
// //           </Typography>
// //           <IconButton
// //             onClick={handleNotificationToggle}
// //             sx={{ color: "text.primary" }}
// //           >
// //             <Close />
// //           </IconButton>
// //         </Box>
// //         <Divider sx={{ borderColor: "divider" }} />

// //         {notifications && notifications.length > 0 ? (
// //           <Box sx={{ p: 2, flexGrow: 1, overflowY: "auto" }}>
// //             <Stack spacing={2}>
// //               {notifications.map((n) => (
// //                 <Box
// //                   key={n.id}
// //                   sx={{
// //                     p: "2px",
// //                     borderRadius: "12px",
// //                     position: "relative",
// //                     background:
// //                       "linear-gradient(45deg, rgba(0,0,0,0), rgba(0,0,0,0))",
// //                     transition: "all 0.3s ease",
// //                     "&:hover": {
// //                       background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
// //                       boxShadow: `0 0 20px ${theme.palette.primary.main}80`,
// //                     },
// //                   }}
// //                 >
// //                   <Box
// //                     sx={{
// //                       p: 2,
// //                       bgcolor: "background.paper",
// //                       borderRadius: "10px",
// //                       display: "flex",
// //                       alignItems: "center",
// //                       gap: 2,
// //                     }}
// //                   >
// //                     <Box
// //                       sx={{
// //                         width: 40,
// //                         height: 40,
// //                         borderRadius: "50%",
// //                         display: "flex",
// //                         alignItems: "center",
// //                         justifyContent: "center",
// //                         flexShrink: 0,
// //                         background: `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
// //                         color: "primary.contrastText",
// //                       }}
// //                     >
// //                       <Hub />
// //                     </Box>
// //                     <Box>
// //                       <Typography variant="body2" fontWeight="bold">
// //                         {n.title}
// //                       </Typography>
// //                       <Typography variant="caption" color="text.secondary">
// //                         {n.message}
// //                       </Typography>
// //                     </Box>
// //                   </Box>
// //                 </Box>
// //               ))}
// //             </Stack>
// //           </Box>
// //         ) : (
// //           <Box
// //             sx={{
// //               flexGrow: 1,
// //               display: "flex",
// //               flexDirection: "column",
// //               alignItems: "center",
// //               justifyContent: "center",
// //               textAlign: "center",
// //               p: 3,
// //               color: "text.secondary",
// //             }}
// //           >
// //             <GridView sx={{ fontSize: 80, mb: 2 }} />
// //             <Typography variant="h6" gutterBottom>
// //               Stream is Clear
// //             </Typography>
// //             <Typography variant="body2">
// //               No new data packets received.
// //             </Typography>
// //           </Box>
// //         )}
// //       </Drawer>

// //       {/* --- User Profile Menu (no changes) --- */}
// //       <Menu
// //         anchorEl={anchorEl}
// //         open={Boolean(anchorEl)}
// //         onClose={handleClose}
// //         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
// //         transformOrigin={{ vertical: "top", horizontal: "right" }}
// //         slotProps={{
// //           paper: {
// //             elevation: 0,
// //             sx: {
// //               overflow: "visible",
// //               width: 250,
// //               mt: 1.5,
// //               backgroundColor: "primary.main",
// //               color: "primary.contrastText",
// //               borderRadius: "10px",
// //               boxShadow: "0px 4px 20px rgba(0,0,0,0.4)",
// //               "& .MuiList-root": { padding: "0px" },
// //               "& .MuiMenuItem-root": { padding: "12px 16px" },
// //             },
// //           },
// //         }}
// //       >
// //         <Box sx={{ p: 2, pt: 1.5 }}>
// //           <Typography variant="subtitle1" fontWeight={600} color="inherit">
// //             {user?.username}
// //           </Typography>
// //           <Typography
// //             variant="caption"
// //             sx={{ textTransform: "capitalize", color: "inherit", opacity: 0.9 }}
// //           >
// //             Role: {user?.role}
// //           </Typography>
// //           <Divider sx={{ my: 1.5, borderColor: "rgba(255, 255, 255, 0.2)" }} />
// //           <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
// //             <EmailOutlined
// //               fontSize="small"
// //               sx={{ mr: 1.5, color: "inherit" }}
// //             />
// //             <Typography
// //               variant="body2"
// //               sx={{ wordBreak: "break-all", color: "inherit" }}
// //             >
// //               {user?.email}
// //             </Typography>
// //           </Box>
// //           <Box sx={{ display: "flex", alignItems: "center" }}>
// //             <PhoneOutlined
// //               fontSize="small"
// //               sx={{ mr: 1.5, color: "inherit" }}
// //             />
// //             <Typography variant="body2" color="inherit">
// //               {user?.phone_number}
// //             </Typography>
// //           </Box>
// //         </Box>
// //       </Menu>

// //       <ChatBot />
// //     </Box>
// //   );
// // };

// // export default Layout;
// import { useState, useEffect } from "react";
// import {
//   AppBar,
//   Toolbar,
//   Typography,
//   Box,
//   IconButton,
//   Menu,
//   MenuItem,
//   Badge,
//   Avatar,
//   useTheme,
//   useMediaQuery,
//   Tooltip,
//   Divider,
//   Drawer,
//   Stack, // Using Stack for layout
//   Slide, // New import for the panel transition
//   Grow, // Using Grow for the staggered item animation
// } from "@mui/material";
// import {
//   NotificationsOutlined,
//   Menu as MenuIcon,
//   Brightness4,
//   Brightness7,
//   EmailOutlined,
//   PhoneOutlined,
//   Close,
//   CloudOff, // New icon for the empty state
//   Polyline, // New, professional and unique icon
// } from "@mui/icons-material";
// import { useAuth } from "../../context/AuthContext";
// import { useNavigate } from "react-router-dom";
// import { useChatBot } from "../../context/ChatBotContext";
// import Sidebar from "./Sidebar";
// import ChatBot from "../common/ChatBot";
// import { useThemeToggle } from "./Theme";

// const Layout = ({ children, title }) => {
//   const { user, logout, notifications } = useAuth();
//   const { setIsOpen } = useChatBot();
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const { toggleColorMode } = useThemeToggle();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

//   const [isDesktopOpen, setDesktopOpen] = useState(() => {
//     const savedState = sessionStorage.getItem("sidebarOpenState");
//     return savedState !== null ? JSON.parse(savedState) : true;
//   });

//   const [isMobileOpen, setMobileOpen] = useState(false);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [isNotificationDrawerOpen, setNotificationDrawerOpen] = useState(false);

//   useEffect(() => {
//     if (!isMobile) {
//       sessionStorage.setItem("sidebarOpenState", JSON.stringify(isDesktopOpen));
//     }
//   }, [isDesktopOpen, isMobile]);

//   const handleDesktopToggle = () => setDesktopOpen(!isDesktopOpen);
//   const handleMobileToggle = () => setMobileOpen(!isMobileOpen);
//   const handleMenu = (event) => setAnchorEl(event.currentTarget);
//   const handleNotificationToggle = () =>
//     setNotificationDrawerOpen(!isNotificationDrawerOpen);
//   const handleClose = () => setAnchorEl(null);

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         minHeight: "100vh",
//         overflow: "hidden",
//         bgcolor: "background.default",
//       }}
//     >
//       <AppBar
//         position="fixed"
//         elevation={0}
//         sx={{
//           zIndex: theme.zIndex.drawer + 1,
//           backgroundColor: theme.palette.primary.main,
//           color: theme.palette.primary.contrastText,
//         }}
//       >
//         <Toolbar
//           sx={{
//             px: { xs: 2, sm: 3 },
//             minHeight: { xs: 56, sm: 64 },
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//             <IconButton
//               color="inherit"
//               onClick={handleMobileToggle}
//               sx={{ display: { md: "none" } }}
//             >
//               <MenuIcon />
//             </IconButton>
//             <Typography
//               variant="h6"
//               sx={{
//                 fontWeight: "bold",
//                 fontSize: { xs: "1.1rem", sm: "1.25rem" },
//                 color: "inherit",
//               }}
//             >
//               {title}
//             </Typography>
//           </Box>
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               gap: { xs: 1, sm: 2 },
//             }}
//           >
//             <Tooltip title="Toggle light/dark theme">
//               <IconButton color="inherit" onClick={toggleColorMode}>
//                 {theme.palette.mode === "dark" ? (
//                   <Brightness7 />
//                 ) : (
//                   <Brightness4 />
//                 )}
//               </IconButton>
//             </Tooltip>
//             <Tooltip title="Notifications">
//               <IconButton color="inherit" onClick={handleNotificationToggle}>
//                 <Badge badgeContent={notifications?.length || 0} color="error">
//                   <NotificationsOutlined />
//                 </Badge>
//               </IconButton>
//             </Tooltip>
//             <Box
//               onClick={handleMenu}
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1.5,
//                 cursor: "pointer",
//                 p: 0.5,
//                 borderRadius: "8px",
//                 "&:hover": {
//                   backgroundColor: "rgba(255, 255, 255, 0.1)",
//                 },
//               }}
//             >
//               <Avatar
//                 sx={{ width: 40, height: 40 }}
//                 alt={user?.username || "Not specified"}
//               />
//               <Box
//                 sx={{
//                   display: { xs: "none", md: "flex" },
//                   flexDirection: "column",
//                   alignItems: "flex-start",
//                 }}
//               >
//                 <Typography
//                   sx={{
//                     color: "inherit",
//                     fontWeight: "bold",
//                     lineHeight: 1.2,
//                     fontSize: "0.9rem",
//                   }}
//                 >
//                   {user?.username || "Not specified"}
//                 </Typography>
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     color: "inherit",
//                     opacity: 0.85,
//                     textTransform: "capitalize",
//                   }}
//                 >
//                   {user?.role || "Admin"}
//                 </Typography>
//               </Box>
//             </Box>
//           </Box>
//         </Toolbar>
//       </AppBar>

//       <Sidebar
//         open={isDesktopOpen}
//         onToggle={handleDesktopToggle}
//         mobileOpen={isMobileOpen}
//         onMobileToggle={handleMobileToggle}
//       />

//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           mt: { xs: "56px", sm: "64px" },
//           overflow: "hidden",
//           boxSizing: "border-box",
//           height: `calc(100vh - ${isMobile ? "56px" : "64px"})`,
//           position: "relative",
//         }}
//       >
//         <Box sx={{ height: "100%", overflowY: "auto" }}>{children}</Box>
//       </Box>

//       {/* --- REVISED NOTIFICATION DRAWER (SLIDE TRANSITION, STAGGERED ANIMATION) --- */}
//       <Drawer
//         anchor="top"
//         open={isNotificationDrawerOpen}
//         onClose={handleNotificationToggle}
//         hideBackdrop
//         TransitionComponent={Slide}
//         TransitionProps={{ direction: "down", timeout: 600 }}
//         sx={{
//           "& .MuiDrawer-paper": {
//             width: { xs: "90vw", sm: 400 },
//             marginLeft: "auto",
//             marginTop: "70px",
//             marginRight: { xs: "5vw", sm: "20px" },
//             maxHeight: "calc(100vh - 90px)",
//             backgroundColor:
//               theme.palette.mode === "dark"
//                 ? "rgba(30, 30, 30, 0.7)"
//                 : "rgba(255, 255, 255, 0.7)",
//             backdropFilter: "blur(20px)",
//             WebkitBackdropFilter: "blur(20px)",
//             borderRadius: "16px",
//             boxShadow: "none",
//             border: `1px solid ${theme.palette.divider}`,
//             color: theme.palette.text.primary,
//           },
//         }}
//       >
//         <Box
//           sx={{
//             p: 2,
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           <Typography variant="h6" fontWeight={600}>
//             Notifications
//           </Typography>
//           <IconButton
//             onClick={handleNotificationToggle}
//             sx={{ color: "text.primary" }}
//           >
//             <Close />
//           </IconButton>
//         </Box>
//         <Divider sx={{ borderColor: "divider" }} />

//         {notifications && notifications.length > 0 ? (
//           <Box sx={{ p: 2, flexGrow: 1, overflowY: "auto" }}>
//             <Stack spacing={2}>
//               {notifications.map((n, index) => (
//                 <Grow
//                   key={n.id}
//                   in={isNotificationDrawerOpen}
//                   timeout={500 + index * 200} // Staggered delay
//                 >
//                   <Box
//                     sx={{
//                       p: "2px",
//                       borderRadius: "12px",
//                       position: "relative",
//                       background:
//                         "linear-gradient(45deg, rgba(0,0,0,0), rgba(0,0,0,0))",
//                       transition: "all 0.3s ease",
//                       "&:hover": {
//                         background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                         boxShadow: `0 0 20px ${theme.palette.primary.main}80`,
//                       },
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         p: 2,
//                         bgcolor: "background.paper",
//                         borderRadius: "10px",
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 2,
//                       }}
//                     >
//                       <Box
//                         sx={{
//                           width: 40,
//                           height: 40,
//                           borderRadius: "50%",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           flexShrink: 0,
//                           background: `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
//                           color: "primary.contrastText",
//                         }}
//                       >
//                         <Polyline />
//                       </Box>
//                       <Box>
//                         <Typography variant="body2" fontWeight="bold">
//                           {n.title}
//                         </Typography>
//                         <Typography variant="caption" color="text.secondary">
//                           {n.message}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   </Box>
//                 </Grow>
//               ))}
//             </Stack>
//           </Box>
//         ) : (
//           <Box
//             sx={{
//               flexGrow: 1,
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               textAlign: "center",
//               p: 3,
//               color: "text.secondary",
//             }}
//           >
//             <CloudOff sx={{ fontSize: 80, mb: 2 }} />
//             <Typography variant="h6" gutterBottom>
//               No Notifications
//             </Typography>
//             <Typography variant="body2">No new alerts received.</Typography>
//           </Box>
//         )}
//       </Drawer>

//       {/* --- User Profile Menu (no changes) --- */}
//       <Menu
//         anchorEl={anchorEl}
//         open={Boolean(anchorEl)}
//         onClose={handleClose}
//         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//         transformOrigin={{ vertical: "top", horizontal: "right" }}
//         slotProps={{
//           paper: {
//             elevation: 0,
//             sx: {
//               overflow: "visible",
//               width: 250,
//               mt: 1.5,
//               backgroundColor: "primary.main",
//               color: "primary.contrastText",
//               borderRadius: "10px",
//               boxShadow: "0px 4px 20px rgba(0,0,0,0.4)",
//               "& .MuiList-root": { padding: "0px" },
//               "& .MuiMenuItem-root": { padding: "12px 16px" },
//             },
//           },
//         }}
//       >
//         <Box sx={{ p: 2, pt: 1.5 }}>
//           <Typography variant="subtitle1" fontWeight={600} color="inherit">
//             {user?.username}
//           </Typography>
//           <Typography
//             variant="caption"
//             sx={{ textTransform: "capitalize", color: "inherit", opacity: 0.9 }}
//           >
//             Role: {user?.role}
//           </Typography>
//           <Divider sx={{ my: 1.5, borderColor: "rgba(255, 255, 255, 0.2)" }} />
//           <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
//             <EmailOutlined
//               fontSize="small"
//               sx={{ mr: 1.5, color: "inherit" }}
//             />
//             <Typography
//               variant="body2"
//               sx={{ wordBreak: "break-all", color: "inherit" }}
//             >
//               {user?.email}
//             </Typography>
//           </Box>
//           <Box sx={{ display: "flex", alignItems: "center" }}>
//             <PhoneOutlined
//               fontSize="small"
//               sx={{ mr: 1.5, color: "inherit" }}
//             />
//             <Typography variant="body2" color="inherit">
//               {user?.phone_number}
//             </Typography>
//           </Box>
//         </Box>
//       </Menu>

//       <ChatBot />
//     </Box>
//   );
// };

// export default Layout;
import { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Badge,
  Avatar,
  useTheme,
  useMediaQuery,
  Tooltip,
  Divider,
  Drawer,
  Stack,
  Slide,
  Grow,
} from "@mui/material";
import {
  NotificationsOutlined,
  Menu as MenuIcon,
  Brightness4,
  Brightness7,
  EmailOutlined,
  PhoneOutlined,
  Close,
  CloudOff,
  Star, // Import filled Star icon
  StarBorder, // Import outlined Star icon
} from "@mui/icons-material";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useChatBot } from "../../context/ChatBotContext";
import Sidebar from "./Sidebar";
import ChatBot from "../common/ChatBot";
import { useThemeMode } from "../../theme/ThemeContext";


const Layout = ({ children, title }) => {
  const { user, logout, notifications, updateNotification } = useAuth(); // Get updateNotification from context
  const { setIsOpen } = useChatBot();
  const navigate = useNavigate();
  const theme = useTheme();
  const { toggleTheme } = useThemeMode();

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [isDesktopOpen, setDesktopOpen] = useState(() => {
    const savedState = sessionStorage.getItem("sidebarOpenState");
    return savedState !== null ? JSON.parse(savedState) : true;
  });

  const [isMobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isNotificationDrawerOpen, setNotificationDrawerOpen] = useState(false);

  // Calculate unread count.
  const unreadCount = notifications.filter((n) => !n.is_read).length;

  useEffect(() => {
    if (!isMobile) {
      sessionStorage.setItem("sidebarOpenState", JSON.stringify(isDesktopOpen));
    }
  }, [isDesktopOpen, isMobile]);

  const handleDesktopToggle = () => setDesktopOpen(!isDesktopOpen);
  const handleMobileToggle = () => setMobileOpen(!isMobileOpen);
  const handleMenu = (event) => setAnchorEl(event.currentTarget);
  const handleNotificationToggle = () =>
    setNotificationDrawerOpen(!isNotificationDrawerOpen);
  const handleClose = () => setAnchorEl(null);

  // --- NOTIFICATION HANDLERS ---
  const handleMarkAsRead = (notification) => {
    // Only mark as read if it's currently unread to avoid unnecessary API calls
    if (!notification.is_read) {
      // Status 1 means 'read', status 2 means 'starred'
      const newStatus = notification.status === 2 ? 2 : 1;
      updateNotification(notification.id, newStatus, true);
    }
  };

  const handleToggleStar = (event, notification) => {
    event.stopPropagation(); // Prevent the parent onClick (mark as read) from firing
    const isCurrentlyStarred = notification.status === 2;
    // If starring, status becomes 2. If unstarring, it becomes 1 (read).
    const newStatus = isCurrentlyStarred ? 1 : 2;
    updateNotification(notification.id, newStatus, true); // Any interaction marks it as read
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        overflow: "hidden",
        bgcolor: "background.default",
      }}
    >
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
        }}
      >
        <Toolbar
          sx={{
            px: { xs: 2, sm: 3 },
            minHeight: { xs: 56, sm: 64 },
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <IconButton
              color="inherit"
              onClick={handleMobileToggle}
              sx={{ display: { md: "none" } }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                fontSize: { xs: "1.1rem", sm: "1.25rem" },
                color: "inherit",
              }}
            >
              {title}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: { xs: 1, sm: 2 },
            }}
          >
            <Tooltip title="Toggle light/dark theme">
              <IconButton color="inherit" onClick={toggleTheme}>

                {theme.palette.mode === "dark" ? (
                  <Brightness7 />
                ) : (
                  <Brightness4 />
                )}
              </IconButton>
            </Tooltip>
            <Tooltip title="Notifications">
              <IconButton color="inherit" onClick={handleNotificationToggle}>
                <Badge badgeContent={unreadCount} color="error">
                  <NotificationsOutlined />
                </Badge>
              </IconButton>
            </Tooltip>
            <Box
              onClick={handleMenu}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                cursor: "pointer",
                p: 0.5,
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
              }}
            >
              <Avatar
                sx={{ width: 40, height: 40 }}
                alt={user?.username || "Not specified"}
              />
              <Box
                sx={{
                  display: { xs: "none", md: "flex" },
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <Typography
                  sx={{
                    color: "inherit",
                    fontWeight: "bold",
                    lineHeight: 1.2,
                    fontSize: "0.9rem",
                  }}
                >
                  {user?.username || "Not specified"}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    color: "inherit",
                    opacity: 0.85,
                    textTransform: "capitalize",
                  }}
                >
                  {user?.role || "Admin"}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      <Sidebar
        open={isDesktopOpen}
        onToggle={handleDesktopToggle}
        mobileOpen={isMobileOpen}
        onMobileToggle={handleMobileToggle}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: { xs: "56px", sm: "64px" },
          overflowY: "auto",
          boxSizing: "border-box",
          height: `calc(100vh - ${isMobile ? "56px" : "64px"})`,
          position: "relative",
          msOverflowStyle: "none", // Hide scrollbar
          scrollbarWidth: "none", // Hide scrollbar
          "&::-webkit-scrollbar": {
            display: "none", // Hide scrollbar
          },
        }}
      >
        {children}
      </Box>

      {/* --- REVISED NOTIFICATION DRAWER --- */}
      <Drawer
        anchor="top"
        open={isNotificationDrawerOpen}
        onClose={handleNotificationToggle}
        hideBackdrop
        TransitionComponent={Slide}
        TransitionProps={{ direction: "down", timeout: 600 }}
        sx={{
          "& .MuiDrawer-paper": {
            width: { xs: "90vw", sm: 400 },
            marginLeft: "auto",
            marginTop: "70px",
            marginRight: { xs: "5vw", sm: "20px" },
            maxHeight: "calc(100vh - 90px)",
            backgroundColor:
              theme.palette.mode === "dark"
                ? "rgba(30, 30, 30, 0.7)"
                : "rgba(255, 255, 255, 0.7)",
            backdropFilter: "blur(20px)",
            WebkitBackdropFilter: "blur(20px)",
            borderRadius: "12px",
            boxShadow: "none",
            border: `1px solid ${theme.palette.divider}`,
            color: theme.palette.text.primary,
          },
        }}
      >
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            Notifications
          </Typography>
          <IconButton
            onClick={handleNotificationToggle}
            sx={{ color: "text.primary" }}
          >
            <Close />
          </IconButton>
        </Box>
        <Divider sx={{ borderColor: "divider" }} />

        {notifications && notifications.length > 0 ? (
          <Box sx={{ p: 2, flexGrow: 1, overflowY: "auto" }}>
            <Stack spacing={2}>
              {notifications.map((n, index) => (
                <Grow
                  key={n.id}
                  in={isNotificationDrawerOpen}
                  timeout={500 + index * 100}
                >
                  <Box
                    onClick={() => handleMarkAsRead(n)}
                    sx={{
                      p: 2,
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 2,
                      cursor: "pointer",
                      transition: "background-color 0.3s ease",
                      backgroundColor: n.is_read
                        ? "transparent"
                        : theme.palette.action.hover,
                      "&:hover": {
                        backgroundColor: theme.palette.action.selected,
                      },
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Box
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          backgroundColor: n.is_read
                            ? "transparent"
                            : "primary.main",
                          flexShrink: 0,
                        }}
                      />
                      <Box>
                        <Typography variant="body2" fontWeight="bold">
                          {n.title}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {n.message}
                        </Typography>
                        <Typography
                          variant="caption"
                          display="block"
                          color="text.disabled"
                          mt={0.5}
                        >
                          {new Date(n.created_at).toLocaleString()}
                        </Typography>
                      </Box>
                    </Box>
                    <Tooltip
                      title={n.status === 2 ? "Unstar" : "Star notification"}
                    >
                      <IconButton
                        onClick={(e) => handleToggleStar(e, n)}
                        size="small"
                        sx={{
                          color:
                            n.status === 2
                              ? theme.palette.warning.main
                              : theme.palette.action.active,
                        }}
                      >
                        {n.status === 2 ? <Star /> : <StarBorder />}
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Grow>
              ))}
            </Stack>
          </Box>
        ) : (
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              p: 3,
              color: "text.secondary",
            }}
          >
            <CloudOff sx={{ fontSize: 80, mb: 2 }} />
            <Typography variant="h6" gutterBottom>
              No Notifications
            </Typography>
            <Typography variant="body2">No new alerts received.</Typography>
          </Box>
        )}
      </Drawer>

      {/* --- User Profile Menu --- */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              width: 250,
              mt: 1.5,
              backgroundColor: "primary.main",
              color: "primary.contrastText",
              borderRadius: "12px",
              boxShadow: "0px 4px 20px rgba(0,0,0,0.4)",
              "& .MuiList-root": { padding: "0px" },
              "& .MuiMenuItem-root": { padding: "12px 16px" },
            },
          },
        }}
      >
        <Box sx={{ p: 2, pt: 1.5 }}>
          <Typography variant="subtitle1" fontWeight={600} color="inherit">
            {user?.username}
          </Typography>
          <Typography
            variant="caption"
            sx={{ textTransform: "capitalize", color: "inherit", opacity: 0.9 }}
          >
            Role: {user?.role}
          </Typography>
          <Divider sx={{ my: 1.5, borderColor: "rgba(255, 255, 255, 0.2)" }} />
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <EmailOutlined
              fontSize="small"
              sx={{ mr: 1.5, color: "inherit" }}
            />
            <Typography
              variant="body2"
              sx={{ wordBreak: "break-all", color: "inherit" }}
            >
              {user?.email}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <PhoneOutlined
              fontSize="small"
              sx={{ mr: 1.5, color: "inherit" }}
            />
            <Typography variant="body2" color="inherit">
              {user?.phone_number}
            </Typography>
          </Box>
        </Box>
        <Divider sx={{ borderColor: "rgba(255, 255, 255, 0.2)" }} />
        <MenuItem onClick={logout}>
          <Typography>Logout</Typography>
        </MenuItem>
      </Menu>

      <ChatBot />
    </Box>
  );
};

export default Layout;
